import React, { useEffect, useRef, useState } from "react";
import { FaUserCircle, FaIdBadge, FaUser, FaPhone, FaEnvelope, FaInstagram, FaTwitter, FaFacebook, FaPlus, FaBuilding, FaBriefcase, FaGlobe, FaBox, FaIndustry, FaRegCalendarAlt, FaRegBell, FaCommentDots, FaClipboard, FaQuestionCircle, FaGift, FaRegComment, FaUsers, FaRegImage, FaSearch, FaYoutube, } from "react-icons/fa";
import { FaPaperPlane, FaEnvelopeOpen } from 'react-icons/fa';
import "./index.css";
import axios from "axios";
import { Navbar, Nav, Container, Table, FormControl, Button, ListGroup, } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import lionslogo from "../Images/lionslogo.png";
import lbnlogo from '../Images/lbnlogo.jpeg';
import { Card, Row, Col, ProgressBar } from "react-bootstrap";
import handshake from "./handshake.png";
import appointment from "./appointment.png";
import eventlist from "./eventlist.png";
import offer from "./offer.png";
import referralimg from "./referralimg.png";
import royal from './royal.png';
import referrall1 from './referrall1.png';
import { TfiJoomla } from "react-icons/tfi";
import A1 from "./onetoone.png";
import A2 from "./visitoeinvite.png";
import stickynote from "./sticky-note.png";
import { Form, Dropdown, DropdownButton, ButtonGroup, Spinner, Alert } from "react-bootstrap";
import bell from "./bell.png";

import ProductList from "../ProductList/ProductList";
import { FaCalendarAlt, FaRegClock, FaMapPin } from "react-icons/fa";
import { RiArrowLeftDownFill, RiArrowLeftUpFill } from "react-icons/ri";
import { GrValidate } from "react-icons/gr";
import Select from 'react-select';
import { GiChessKing } from "react-icons/gi";
import Modal from "react-modal";
Modal.setAppElement("#root");

const UserDashboard = ({ productId }) => {
  const navigate = useNavigate();

  const email = sessionStorage.getItem("email");
  const UserId = sessionStorage.getItem("email");
  const userId = sessionStorage.getItem('userId');

  const [users, setUsers] = useState([]);

  const [users1, setUsers1] = useState([])

  const [royalpoints, setRoyalPoints] = useState([]);
  const [referral_member, setReferral_Members] = useState([]);
  const [loading, setLoading] = useState(true);

  const [isMember, setIsMember] = useState(null);

  // useEffect(() => {
  //   axios
  //     .get(`https://api.lbnhyderabad.com/signup/get/${email}`)
  //     .then((response) => {
  //       setUsers(response.data);
  //       setRoyalPoints(response.data.royalpoints)
  //       setIsMember(response.data.formStates);
  //       setLoading(false);
  //     })
  //     .catch((error) => {
  //       console.error("There was an error fetching the data!", error);
  //       setLoading(false);
  //     });
  // }, [email]);

  const fetchUserData = async () => {
    try {
      const response = await axios.get(`https://api.lbnhyderabad.com/signup/get/${email}`);
      setUsers(response.data);
      setRoyalPoints(response.data.royalpoints);
      setReferral_Members(response.data.referral_id);
      setIsMember(response.data.formStates);
      setLoading(false);
    } catch (error) {
      console.error("There was an error fetching the data!", error);
      setLoading(false);
    }
  };

  const fetchUserss = async () => {
    try {
      const response = await axios.get('https://api.lbnhyderabad.com/admin-dashboard'); // Change the URL accordingly
      //const filteredUsers = response.data.filter(user => user.chapterCategory === chapter);  // Filter by chapterCategory
      //console.log(filteredUsers)
      setUsers1(response.data); // Set the users state with the data chapterCategory

    } catch (err) {
      setError('Error fetching users data'); // Set error state
      console.error(err);
    } finally {
      setLoading(false); // Set loading to false after fetching
    }
  };

  console.log(referral_member)

  useEffect(() => {
    fetchUserData();
    fetchUserss();
  }, [email]);



  const [referralMembers, setReferralMembers] = useState([]);
  const [referralCount, setReferralCount] = useState(0);
  const [showModalC, setShowModalC] = useState(false);
  // const handleModalOpen = () => setShowModalC(true);
  const handleModalClose = () => setShowModalC(false);

  const handleModalOpenC = () => {
    console.log("Card clicked");
    setShowModalC(true);
  };

  const fetchReferralMembers = async (referrerId) => {
    try {
      const response = await axios.get(`https://api.lbnhyderabad.com/signup/referrals/${referrerId}`);
      setReferralMembers(response.data);
      setReferralCount(response.data.length);
    } catch (error) {
      console.error("Error fetching referral members:", error);
    }
  };
  console.log('this is the reffrel members', referralMembers)
  // Call this after login or after getting current user info
  useEffect(() => {
    const currentUserId = users?.id; // assuming you have current user info
    if (currentUserId) {
      fetchReferralMembers(currentUserId);
    }
  }, [users]);

  console.log("this is email ", users);
  console.log('this is my points ', royalpoints)
  const [dropdownOpen, setDropdownOpen] = useState(false);

  const dropdownRef = useRef(null);
  const profileIconRef = useRef(null);

  const toggleDropdown = () => {
    setDropdownOpen(!dropdownOpen);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target) &&
        !profileIconRef.current.contains(event.target)
      ) {
        setDropdownOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleLogout = () => {
    alert("You have logged out!");
    sessionStorage.clear();
    navigate("/");
  };

  // profile submit data 

  const [formData, setFormData] = useState({
    name_of_company: "",
    designation: "",
    joined_year: "",
    position: "",
    year: "",
    website: "",
    official_email_id: "",
    product: "",
    businessVerticalData: "",
    businessProfession: "",
  });

  const [logo, setLogo] = useState(null);

  const handleInputChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
    if (e.target.name === 'Gst_No') {
      setGstNo(e.target.value);
    }
  };


  const handleSubmit = async (e) => {
    e.preventDefault();

    const updatedData = {
      email,
      ...formData,
    };

    const form = new FormData();
    for (const key in updatedData) {
      form.append(key, updatedData[key]);
    }

    // Ensure you are appending the correct file object
    if (logo) {
      form.append("logo", logo);
    }

    try {
      const response = await axios.put(
        "https://api.lbnhyderabad.com/product/profile/update",
        form,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
      setUsers(response.data.message);

      sessionStorage.setItem("formSubmitted", "true");

      fetchUserData();
      setIsModalOpenProfile(false);
      // window.location.reload();
    } catch (error) {
      console.error("Error saving data:", error);
    }
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    setLogo(file);
  };

  // sat & Aadhar

  const [Gst_No, setGstNo] = useState('');
  const [gstStatus, setGstStatus] = useState(null);
  const [Aadhar_No, setAadhar_No] = useState('');
  const [OTP, setOTP] = useState('');
  const [isOtpSent, setIsOtpSent] = useState(false);
  const [isOtpVerified, setIsOtpVerified] = useState(false);

  const handleInputChangev = (e) => {
    const { name, value } = e.target;
    if (name === 'Gst_No') {
      setGstNo(value);
    } else if (name === 'Aadhar_No') {
      setAadhar_No(value);
    } else if (name === 'OTP') {
      setOTP(value);
    }
  };
  const maskGST = (gst) => {
    if (!gst || gst.length !== 15) return gst;

    return (
      gst.slice(0, 10) + // first 10 characters
      "***" +            // mask 11th to 13th
      gst.slice(13)      // last 2 characters
    );
  };


  const verifyGstin = async () => {
    if (!Gst_No) {
      console.log("Please enter a GST number");
      setGstStatus(false);
      return;
    }

    console.log("Verifying GSTIN...");
    try {
      const res = await axios.post('https://api.lbnhyderabad.com/signup/verify-gstin', { GSTIN: Gst_No });
      console.log(res.data);
      if (res.data && res.data.gst_in_status === "Active") {
        setGstStatus(true);
        setFormData(prev => ({
          ...prev,
          name_of_company: res.data.legal_name_of_business,
        }));
      } else {
        setGstStatus(false);
        setError("Invalid GSTIN or GSTIN not active");
      }
    } catch (err) {
      console.log(err.response ? err.response.data : "API request failed");
      setGstStatus(false);
      setError("Error verifying GSTIN");
    }
  };

  const sendOtp = async () => {
    try {
      const response = await axios.post('https://api.lbnhyderabad.com/signup/api/send-aadhar-otp', { Aadhar_No });
      if (response.data.ref_id) {
        setIsOtpSent(true);
      }
    } catch (error) {
      console.log('Error sending OTP. Please try again.');
      setError('Error sending OTP');
    }
  };

  const verifyOtp = async () => {
    try {

      const userId = sessionStorage.getItem('userId');

      const response = await axios.post('https://api.lbnhyderabad.com/signup/api/verify-aadhar-otp',
        {
          otp: OTP,
          Aadhar_No,
          userId
        });
      console.log(response.data);
      if (response.data.status === 'VALID') {
        setIsOtpVerified(true);
        setIsOtpSent(false);
        setError('');
      } else {
        setError('OTP verification failed');
      }
    } catch (error) {
      console.log('Error verifying OTP. Please try again.');
      setError('Error verifying OTP');
    }
  };


  const resetProcess = () => {
    setAadhar_No('');
    setOTP('');
    setIsOtpSent(false);
    setIsOtpVerified(false);
    setError('');
  };



  const [showModal, setShowModal] = useState(false);
  const [productData, setProductData] = useState({
    productName: "",
    productDesc: "",
    productPhoto: null,
    offer: "",
    validity: "",
    productPrice: "",
  });

  const [productPhoto, setproductPhoto] = useState("");

  const openModal = () => setShowModal(true);

  const closeModal = () => setShowModal(false);

  const handleModelInputChange = (e) => {
    const { name, value } = e.target;

    setProductData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleModelFileChange = (e) => {
    const file = e.target.files[0];
    setproductPhoto(file);
  };

  const [message, setMessage] = useState("");

  const handleFormSubmit = (e) => {
    e.preventDefault();
    const formData = new FormData();

    formData.append("productName", productData.productName);
    formData.append("validity", productData.validity);
    formData.append("offer", productData.offer);
    formData.append("productDesc", productData.productDesc);
    formData.append("productPrice", productData.productPrice);
    formData.append("UserId", UserId);
    formData.append("user", userId);
    if (productPhoto) {
      formData.append("productPhoto", productPhoto);
    }

    axios
      .post("https://api.lbnhyderabad.com/product/add-product", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then((response) => {
        console.log(response.data);
        setMessage(response.data.message);
        setShowModal(false);
      })
      .catch((error) => {
        console.error("Error saving product:", error);
      });
  };

  const [products, setProducts] = useState([]);
  const [allProducts, setAllProducts] = useState([]);
  const [error, setError] = useState(null);

  const [editProductData, setEditProductData] = useState({
    productName: "",
    productDesc: "",
    productPhoto: null,
    offer: "",
    validity: "",
    productPrice: "",
  });


  const [showModaal, setShowModaal] = useState(false);
  const openModaal = () => setShowModaal(true);

  const closeModaal = () => setShowModaal(false);
  const [editProductId, setEditProductId] = useState(null);
  console.log(editProductId);

  const handleEditSubmit = (e) => {
    console.log("editbutton click");
    e.preventDefault();
    const formData = new FormData();
    formData.append("productName", editProductData.productName);
    formData.append("productDesc", editProductData.productDesc);
    formData.append("productPrice", editProductData.productPrice);
    formData.append("offer", editProductData.offer);
    formData.append("validity", editProductData.validity);
    formData.append("UserId", UserId);

    if (productPhoto) {
      formData.append("productPhoto", productPhoto);
    }

    axios.put(`https://api.lbnhyderabad.com/product/update/${editProductId}`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    )
      .then((response) => {
        setMessage(response.data.message);
        setShowModaal(false);
        setEditProductId(null);
        fetchProducts();
      })
      .catch((error) => {
        console.error("Error updating product:", error);
      });
  };

  const editProduct = (product) => {
    setEditProductData({
      productName: product.productName,
      productDesc: product.productDesc,
      productPrice: product.productPrice,
      offer: product.offer,
      validity: product.validity,
      productPhoto: product.productPhoto,
    });
    setShowModaal(true);
    setEditProductId(product.id);
  };

  const handleEditModelInputChange = (e) => {
    const { name, value } = e.target;

    setEditProductData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleEditModelFileChange = (e) => {
    const file = e.target.files[0];
    setproductPhoto(file);
  };

  /* delete api integration here */

  const deleteProduct = (productId) => {
    console.log(productId);
    const confirmation = window.confirm(
      "Are you sure you want to delete this product?"
    );
    if (!confirmation) return;

    fetch(`https://api.lbnhyderabad.com/product/delete/${productId}`, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.message === "Product deleted successfully") {
          alert("Product deleted successfully");

          fetchProducts();
        } else {
          alert(data.message);
        }
      })
      .catch((error) => {
        console.error("Error deleting product:", error);
        alert("An error occurred while deleting the product.");
      });
  };

  const [activeSection, setActiveSection] = useState("home"); // Default to 'home'

  const handleKycAlertClick = () => {
    setActiveSection('profile');
  };
  const [isNavbarCollapsed, setIsNavbarCollapsed] = useState(true);

  const handleNavClick = (section) => {
    setActiveSection(section);
    setIsNavbarCollapsed(true);
  };

  const [referralData, setReferralData] = useState([]);
  const [referralOutData, serReferralOutData] = useState([]);

  const [thanks, setThanks] = useState([])
  // const email = sessionStorage.getItem('email');
  // Fetch data when the component mounts
  // useEffect(() => {
  //   axios
  //     .get("https://api.lbnhyderabad.com/refferal/api/referralstore") // Assuming your backend is running on port 3000
  //     .then((response) => {

  //       const filteredData = response.data.filter(
  //         (item) => item.email === email
  //       );
  //       const filteredDataa = response.data.filter(
  //         (item) => item.salerEmail === email
  //       );

  //       const filteredDataaa = response.data.filter(
  //         (item) => item.salerEmail === email
  //       );

  //       setReferralData(filteredData); // Set the data from API to state
  //       serReferralOutData(filteredDataa);
  //       setThanks(filteredDataaa);
  //       setLoading(false); // Set loading state to false when data is fetched
  //     })
  //     .catch((err) => {
  //       setError("Error fetching referral data");
  //       setLoading(false);
  //     });
  // }, []);

  const fetchReferralData = async (email, setReferralData, serReferralOutData, setThanks, setLoading, setError) => {
    try {
      const response = await axios.get("https://api.lbnhyderabad.com/refferal/api/referralstore");

      const filteredData = response.data.filter(item => item.email === email);
      const filteredDataa = response.data.filter(item => item.salerEmail === email);
      const filteredDataaa = response.data.filter(item => item.salerEmail === email); // Same as filteredDataa?

      setReferralData(filteredData);
      serReferralOutData(filteredDataa);
      setThanks(filteredDataaa);
    } catch (error) {
      setError("Error fetching referral data");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchReferralData(email, setReferralData, serReferralOutData, setThanks, setLoading, setError);
  }, []);
  console.log(thanks)

  console.log("this is referral in data", referralData);
  console.log("this is referral out data", referralOutData);
  const [eventss, setEventss] = useState([]);

  const [meetings, setMeetings] = useState([]);
  const [yescount, setYescount] = useState('');
  const [nocount, setNocount] = useState('');
  const [noAtt, setNoAtt] = useState('')

  const [actionMeetings, setActionMeetings] = useState([]);


  const totalReferrals = referralData.length;
  const totalReferralss = referralOutData.length;
  const productsCount = products.length;
  const eventCount = eventss.length;
  const meetingsCount = meetings.length;

  const [selectedReferralOut, setSelectedReferralOut] = useState("");

  const [inputValue, setInputValue] = useState("");
  const [selectedReferralOutDetails, setSelectedReferralOutDetails] = useState(
    {}
  );

  const handleReferralOutSelect = (id) => {
    console.log("Selected ID:", id);
    setSelectedReferralOut(id);

    const selectedReferral = thanks.find(
      (item) => item.id === parseInt(id, 10)
    );
    console.log("Selected Referral Data:", selectedReferral);
    setSelectedReferralOutDetails(selectedReferral || {});
  };

  useEffect(() => {
    console.log("Selected Referral Out Details:", selectedReferralOutDetails);
  }, [selectedReferralOutDetails]); // This will run every time selectedReferralOutDetails changes

  console.log(selectedReferralOutDetails);

  const handleInputChangee = (event) => {
    setInputValue(event.target.value);
  };

  console.log(email);


  const fetchActionMeetings = async () => {
    try {
      const response = await fetch('https://api.lbnhyderabad.com/admin-dashboard/get/meetings');
      if (!response.ok) {
        throw new Error('Error fetching data');
      }
      const data = await response.json();

      // const filteredData = data.filter(meeting => meeting.response === 'no');
      const yesCount = data.filter(meeting => meeting.response === 'yes' && meeting.user_email === email).length;
      const noCount = data.filter(meeting => meeting.response === 'no' && meeting.user_email === email).length;
      // const NullCount = data.filter(meeting => meeting.response === ''&& meeting.user_email === email).length;
      setYescount(yesCount); // Assuming you have a state variable for yesCount
      setNocount(noCount);
      // setNoAtt(NullCount);

      setActionMeetings(data); // Store fetched meetings in state
      // setActionMeetionsAtt(filteredData);
      setLoading(false);  // Set loading to false after data is fetched
    } catch (err) {
      setError(err.message); // Set error state if any error occurs
      setLoading(false); // Set loading to false even on error
    }
  };

  useEffect(() => {
    fetchActionMeetings();
  }, []);


  // const [isModalOpen, setIsModalOpen] = useState(false);
  // const [customerDetails, setCustomerDetails] = useState({
  //   customerName: "",
  //   customerEmail: "",
  //   customerMobile: "",
  // });
  // const [selectedProduct, setSelectedProduct] = useState(null);

  // // Open the modal with the selected product
  // const handleOpenModal = (product) => {
  //   setSelectedProduct(product);
  //   setIsModalOpen(true);
  // };

  // // Close the modal
  // const handleCloseModal = () => {
  //   setIsModalOpen(false);
  //   setCustomerDetails({
  //     customerName: "",
  //     customerEmail: "",
  //     customerMobile: "",
  //   });
  // };

  // // Handle input change for customer details
  // const handleChange = (e) => {
  //   const { name, value } = e.target;
  //   setCustomerDetails((prevDetails) => ({
  //     ...prevDetails,
  //     [name]: value,
  //   }));
  // };

  // // Handle referral submission
  // const referral = async () => {
  //   const { customerName, customerEmail, customerMobile } = customerDetails;
  //   const product = selectedProduct; // Selected product info

  //   try {
  //     const response = await axios.post("https://api.lbnhyderabad.com/product/referral", {
  //       email: email, // Referrer's email
  //       product: product.productName, // Product name
  //       price: product.productPrice, // Product price
  //       name: product.productName, // Product name (for reference)
  //       customerEmail, // Customer's email
  //       customerName, // Customer's name
  //       customerMobile, // Customer's mobile
  //     });

  //     if (response.status === 200) {
  //       alert("Referral sent successfully!");
  //       handleCloseModal(); // Close the modal after successful submission
  //     } else {
  //       alert("Something went wrong!");
  //     }
  //   } catch (error) {
  //     console.error("Error sending referral:", error);
  //     alert("Error sending referral!");
  //   }
  // };

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [customerDetails, setCustomerDetails] = useState({
    customerName: "",
    customerEmail: "",
    customerMobile: "",
  });
  const [selectedProduct, setSelectedProduct] = useState(null);

  // Open the modal with the selected product
  const handleOpenModal = (product) => {
    setSelectedProduct(product);
    setIsModalOpen(true);
  };

  // Close the modal
  const handleCloseModal = () => {
    setIsModalOpen(false);
    setCustomerDetails({
      customerName: "",
      customerEmail: "",
      customerMobile: "",
    });
  };

  // Handle input change for customer details
  const handleChange = (e) => {
    const { name, value } = e.target;
    setCustomerDetails((prevDetails) => ({
      ...prevDetails,
      [name]: value,
    }));
  };

  // Handle referral submission
  const referral = async () => {
    const { customerName, customerEmail, customerMobile } = customerDetails;
    const product = selectedProduct; // Selected product info
    console.log(product);

    try {
      // Send the referral data to the backend API
      const response = await axios.post(
        "https://api.lbnhyderabad.com/signup/product-referral",
        {
          email: email, // Referrer's email
          // name: email, // Sender's name (who is sending the referral)
          productName: product.productName, // Product name
          product: product.productPhoto, // Product description or details
          price: product.productPrice, // Product price
          salerEmail: product.UserId, // Seller's em
          customerEmail, // Customer's email
          customerName, // Customer's name
          customerMobile, // Customer's mobile
        }
      );

      if (response.status === 200) {
        alert("Referral sent successfully!");
        fetchReferralData(email, setReferralData, serReferralOutData, setThanks, setLoading, setError);
        handleCloseModal(); // Close the modal after successful submission
      } else {
        alert("Something went wrong!");
      }
    } catch (error) {
      console.error("Error sending referral:", error);
      alert("Error sending referral!");
    }
  };



  const [thanksNotes, setThanksNotes] = useState([]);
  const [myThankNote, setMyThankNote] = useState([]);

  const thanksCount = thanksNotes.length;
  const MythanksCount = myThankNote.length;

  // Fetch the data from the API
  //   fetch('https://api.lbnhyderabad.com/product/thanksNote') // Replace with your actual backend URL
  //     .then((response) => response.json()) // Parse the JSON response
  //     .then((data) => {
  //       console.log('Fetched Data:', data); // Log the data to ensure it's coming in correctly
  //       const filteredData = data.filter((note) => note.customerEmail === email);
  //       setThanksNotes(filteredData); // Set the fetched data into state
  //       setLoading(false); // Set loading to false once data is fetched
  //     })
  //     .catch((err) => {
  //       console.error('Error fetching data:', err);
  //       setError('Error fetching thanks note data'); // Set error state if something goes wrong
  //       setLoading(false); // Set loading to false on error as well
  //     });

  // useEffect(() => {
  //   fetch();
  // }, []);

  console.log(email)


  const fetchThanksNotes = () => {
    fetch("https://api.lbnhyderabad.com/product/thanksNote") // Replace with your actual backend URL
      .then((response) => response.json()) // Parse the JSON response
      .then((data) => {
        console.log("Fetched Data:", data); // Log the data to ensure it's coming in correctly

        const filteredData = data.filter(
          (note) => note.salerEmail === email
        );
        const filteredMyData = data.filter(
          (note) => note.email === email
        );
        setMyThankNote(filteredMyData);
        setThanksNotes(filteredData); // Set the fetched data into state
        setLoading(false); // Set loading to false once data is fetched
      })
      .catch((err) => {
        console.error("Error fetching data:", err);
        setError("Error fetching thanks note data"); // Set error state if something goes wrong
        setLoading(false); // Set loading to false on error as well
      });
  };

  // Fetch data when the component mounts or when email changes (if email can change)
  useEffect(() => {
    if (email) {
      // Make sure email is available before fetching
      fetchThanksNotes();
    }
  }, [email]);

  console.log("this is thanks note data ", thanksNotes);
  console.log('this is thanks note data that i got', myThankNote)

  const sendThankYouNote1 = async () => {
    const response = await fetch(
      "https://api.lbnhyderabad.com/product/send-thanks-note",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          email: selectedReferralOutDetails.email, // Referral Sender Email
          product: selectedReferralOutDetails.product,
          productName: selectedReferralOutDetails.productName,
          price: selectedReferralOutDetails.price,
          customerName: selectedReferralOutDetails.customerName,
          customerEmail: selectedReferralOutDetails.customerEmail,
          salerEmail: selectedReferralOutDetails.salerEmail,
          customerMobile: selectedReferralOutDetails.customerMobile,
          additionalInfo: inputValue, // If any additional info is entered
        }),
      }
    );

    const data = await response.json();
    if (data.status === 200) {
      fetchThanksNotes();

      setSelectedReferralOutDetails({}); // Now it's fine to reassign
      setInputValue('');
      alert("Thank You Note Sent and Referral Saved!");
    } else {
      alert("Failed to send Thank You note.");
    }
  };

  const sendThankYouNote = async () => {
    try {
      const response = await fetch(
        // "https://api.lbnhyderabad.com/product/send-thanks-note",
        "https://api.lbnhyderabad.com/signup/withreferral-send-thanks-note",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            email: selectedReferralOutDetails.email, // Referral Sender Email
            product: selectedReferralOutDetails.product,
            productName: selectedReferralOutDetails.productName,
            price: selectedReferralOutDetails.price,
            customerName: selectedReferralOutDetails.customerName,
            customerEmail: selectedReferralOutDetails.customerEmail,
            salerEmail: selectedReferralOutDetails.salerEmail,
            customerMobile: selectedReferralOutDetails.customerMobile,
            additionalInfo: inputValue, // If any additional info is entered
          }),
        }
      );

      const data = await response.json();

      if (data.status === 200) {
        fetchThanksNotes();
        setSelectedReferralOutDetails({});
        setInputValue('');

        // Show backend message based on WhatsApp success/failure
        if (data.message.includes("WhatsApp message failed") || data.message.includes("WhatsApp failed")) {
          alert("Referral saved. Thank You note sent via Email. WhatsApp failed (optional).");
        } else {
          alert("Thank You Note Sent and Referral Saved via Email and WhatsApp!");
        }
      } else {
        alert("Failed to send Thank You note.");
      }
    } catch (error) {
      console.error("Error while sending thank you note:", error);
      alert("An error occurred while sending the Thank You note.");
    }
  };


  const sendThankYouNoteRef = async () => {
    const response = await fetch(
      // "https://api.lbnhyderabad.com/signup/referral-send-thanks-note",
      "https://api.lbnhyderabad.com/signup/withoutreferral-send-thanks-note",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          email: selectedUserThanks.email,


          salerEmail: email,

          additionalInfo: inputValue, // If any additional info is entered
        }),
      }
    );

    const data = await response.json();
    if (data.status === 200) {
      fetchThanksNotes();

      setSelectedReferralOutDetails({}); // Now it's fine to reassign
      setInputValue('');
      alert("Thank You Note Sent and Referral Saved!");
    } else {
      alert("Failed to send Thank You note.");
    }
  };

  const [thankType, setThankType] = useState("without"); // 'with' or 'without'

  const handleThankTypeChange = (e) => {
    setThankType(e.target.value);
  };

  const [errorMeetings, setErrorMeetings] = useState(null);
  const [loadingMeetings, setLoadingMeetings] = useState(true);

  const fetchMeeting = () => {
    fetch("https://api.lbnhyderabad.com/admin-dashboard/meetings")
      .then((res) => res.json())
      .then((data) => {
        console.log("Fetched data:", data);
        console.log("User chapterCategory:", users.chapterCategory);

        //    const filteredMeetings = data.filter(
        //   (meeting) => meeting.chapter === users.chapterCategory
        // );
        const filteredMeetings = data.filter(
          (meeting) =>
            meeting.chapter?.trim().toLowerCase() ===
            users.chapterCategory?.trim().toLowerCase()
        );
        setMeetings(filteredMeetings);
        setLoadingMeetings(false);


      })
      .catch((err) => {
        setErrorMeetings("Error fetching meetings data");
        setLoadingMeetings(false);
      });
  };

  useEffect(() => {
    if (users?.chapterCategory) {
      fetchMeeting();
    }
  }, [users]);

  useEffect(() => {
    fetchMeeting();
    fetchEvent();
  }, []);

  const [loadingEvents, setLoadingEvents] = useState(true);
  const [errorEvents, setErrorEvents] = useState(null);

  const fetchEvent = () => {
    fetch("https://api.lbnhyderabad.com/admin-dashboard/events")
      .then((res) => res.json())
      .then((data) => {
        setEventss(data);
        setLoadingEvents(false);
      })
      .catch((err) => {
        setErrorEvents("Error fetching events data");
        setLoadingEvents(false);
      });
  };

  // const isExpired = (date) => {
  //   const today = new Date();
  //   const meetingDate = new Date(date);
  //   return meetingDate < today;
  // };

  // const isExpired = (date, time) => {
  //   const today = new Date();

  //   // Convert the provided date and time into a full date object
  //   console.log('this is the data rr',date ,time)
  //   const meetingDate = new Date(date);
  //   const [hour, minute, second] = time.split(':').map(num => parseInt(num));

  //   // Set the time of the meeting based on the provided hour, minute, and second
  //   meetingDate.setHours(hour, minute, second, 0);

  //   // Check if the meeting date and time is in the past
  //   return meetingDate < today;
  // };

  const isExpired = (date, time) => {
    const today = new Date();

    // Convert the provided date and time into a full date object
    console.log('this is the data rr', date, time);
    const meetingDate = new Date(date);

    // Ensure time has hours, minutes, and optionally seconds
    const [hourStr, minuteStr, secondStr = "0"] = time.split(':');
    const hour = parseInt(hourStr, 10);
    const minute = parseInt(minuteStr, 10);
    const second = parseInt(secondStr, 10);

    // Set the full time
    meetingDate.setHours(hour, minute, second, 0);
    console.log('Meeting full datetime:', meetingDate.toString());
    console.log('Current datetime:', today.toString());
    // Check if the meeting date and time is in the past
    return meetingDate < today;



  };


  const [responses, setResponses] = useState({});
  const [yesCount, setYesCount] = useState(0);
  const [noCount, setNoCount] = useState(0);
  console.log(yesCount)
  console.log(noCount)


  useEffect(() => {
    fetchMeetings();
    fetchResponses();
  }, []);

  const fetchMeetings = async () => {
    try {
      const res = await axios.get('https://api.lbnhyderabad.com/admin-dashboard/meetings'); // Fetch meetings
      setMeetings(res.data);
    } catch (error) {
      console.error('Error fetching meetings:', error);
    }
  };

  const fetchResponses = async () => {
    try {
      const userEmail = sessionStorage.getItem('email'); // Get user email from session
      const res = await axios.get(`https://api.lbnhyderabad.com/admin-dashboard/meeting-response/${email}`);

      const userResponses = res.data.reduce((acc, response) => {
        acc[response.meeting_id] = response.response; // Map each meeting ID to the user's response
        return acc;
      }, {});

      setResponses(userResponses);
      calculateResponseCounts(userResponses);
    } catch (error) {
      console.error('Error fetching responses:', error);
    }
  };


  const calculateResponseCounts = (userResponses) => {
    const futureMeetings = meetings.filter(meeting => !isExpired(meeting.date)); // Get future meetings

    let yes = 0;
    let no = 0;

    futureMeetings.forEach(meeting => {
      const response = userResponses[meeting.id];
      if (response === 'yes') {
        yes++;
      } else if (response === 'no') {
        no++;
      }
    });

    setYesCount(yes);
    setNoCount(no);
  };



  const handleButtonClick = async (meetingId, userResponse) => {
    try {

      const userEmail = sessionStorage.getItem("email");; // Replace with the actual user ID, probably from logged-in user data
      const UserId = sessionStorage.getItem('userId'); // Replace with actual user email

      const response = await axios.post('https://api.lbnhyderabad.com/admin-dashboard/meeting-response', {
        user_id: UserId,
        user_email: userEmail,
        meeting_id: meetingId,
        response: userResponse
      });

      if (response.status === 200) {
        setResponses(prevState => ({
          ...prevState,
          [meetingId]: userResponse, // Store the response for the meeting
        }));

        console.log("Response saved successfully");
        fetchResponses();
        console.log("Response saved successfully");
      }
    } catch (error) {
      console.error("Error saving response", error);
    }
  };





  const [eventresponses, setEventResponses] = useState({});



  useEffect(() => {
    fetchEventResponses();
    fetchEventMeetings();
  }, []);

  const fetchEventMeetings = async () => {
    try {
      const res = await axios.get('https://api.lbnhyderabad.com/admin-dashboard/events'); // Fetch meetings
      setEventss(res.data);
    } catch (error) {
      console.error('Error fetching meetings:', error);
    }
  };

  const fetchEventResponses = async () => {
    try {
      const userEmail = sessionStorage.getItem('email'); // Get user email from session
      const res = await axios.get(`https://api.lbnhyderabad.com/admin-dashboard/event-response/${email}`);

      const eventResponse = res.data.reduce((acc, response) => {
        acc[response.events_id] = response.response;
        return acc;
      }, {});

      setEventResponses(eventResponse);

    } catch (error) {
      console.error('Error fetching responses:', error);
    }
  };

  const handleButtonEventClick = async (eventId, eventResponse) => {
    try {

      const userEmail = sessionStorage.getItem("email"); // Replace with the actual user ID, probably from logged-in user data
      const UserId = sessionStorage.getItem('userId'); // Replace with actual user email

      const response = await axios.post('https://api.lbnhyderabad.com/admin-dashboard/event-response', {
        user_id: UserId,
        user_email: userEmail,
        events_id: eventId,
        response: eventResponse
      });

      if (response.status === 200) {
        setEventResponses(prevState => ({
          ...prevState,
          [eventId]: eventresponses, // Store the response for the meeting
        }));

        console.log("Response saved successfully");
        fetchEventResponses();
        console.log("Response saved successfully");
      }
    } catch (error) {
      console.error("Error saving response", error);
    }
  };

  const [isModalOpenProfile, setIsModalOpenProfile] = useState(false);


  // const openModalProfile = () => setIsModalOpenProfile(true);


  const openModalProfile = async () => {
    setIsModalOpenProfile(true);

    try {
      // const email = await AsyncStorage.getItem("email");
      const email = sessionStorage.getItem("email");
      const response = await axios.get(`https://api.lbnhyderabad.com/signup/get/${email}`);
      const data = response.data;

      setFormData({
        name_of_company: data.name_of_company || "",
        designation: data.designation || "",
        joined_year: data.joined_year || "",
        position: data.position || "",
        year: data.year || "",
        website: data.website || "",
        official_email_id: data.official_email_id || "",
        product: data.product || "",
        businessVerticalData: data.businessVerticalData || "",
        businessProfession: data.businessProfession || "",
        Gst_No: data.Gst_No || "",
      });



    } catch (error) {
      console.error("Error fetching user data on modal open:", error);
    }
  };
  const closeModalProfile = () => setIsModalOpenProfile(false);

  const [currentProduct, setCurrentProduct] = useState(null);






  const [ratings, setRatings] = useState([]);
  const [averageRating, setAverageRating] = useState([]);
  const [newRating, setNewRating] = useState({ rating: 0, review: '' });
  const [isModalRatingOpen, setIsModalRatingOpen] = useState(false);



  const renderStars = (rating) => {
    const stars = [];
    for (let i = 0; i < 5; i++) {
      stars.push(i < rating ? '★' : '☆');
    }
    return stars.join(''); // Joins all the stars together, with filled or empty ones
  };

  const calculateAverageRating = (ratings) => {
    console.log("Product Ratings:", ratings);
    if (!ratings || ratings.length === 0) return 0;
    const total = ratings.reduce((acc, rating) => acc + rating.rating, 0);
    return total / ratings.length;
  };
  console.log("Ratings Data:", ratings); // To ensure it is in the correct structure



  const fetchRatings = (productId) => {
    return axios.get(`https://api.lbnhyderabad.com/product/products/${productId}/ratings`)
      .then(response => response.data)
      .catch(error => {
        console.error('Error fetching ratings:', error);
        return []; // Return empty array if error occurs
      });
  };

  const fetchRatingss = (productId) => {
    setRatings([]);  // Reset ratings before fetching
    axios.get(`https://api.lbnhyderabad.com/product/products/${productId}/ratings`)
      .then(response => {
        console.log("Fetched Ratings Data:", response.data);  // Log the response data
        setRatings(response.data);  // Set ratings state
        const avgRating = calculateAverageRating(response.data); // Calculate average rating
        setAverageRating(avgRating);
        console.log("Average Rating:", avgRating);  // Log average rating
      })
      .catch(error => console.error('Error fetching ratings:', error));
  };


  useEffect(() => {
    console.log("Updated Ratings:", ratings); // Log after state update
  }, [ratings]); // This will run every time `ratings` changes



  const [shuffledProducts, setShuffledProducts] = useState([]);

  const shuffleArray = (array) => {
    return array
      .map((item) => ({ item, sort: Math.random() }))
      .sort((a, b) => a.sort - b.sort)
      .map(({ item }) => item);
  };


  // const fetchProducts = async () => {
  //   try {
  //     const response = await axios.get("https://api.lbnhyderabad.com/product/show-all-data");

  //     const filteredProducts = response.data.filter((product) => product.UserId === UserId);
  //     const filteredProductss = response.data.filter((product) => product.UserId !== UserId);

  //     // Fetch ratings for each product in parallel using Promise.all
  //     const updatedProducts = await Promise.all(
  //       filteredProductss.map(async (product) => {
  //         const ratings = await fetchRatings(product.id); // Fetch ratings asynchronously
  //         return {
  //           ...product,
  //           ratings, // Attach fetched ratings to product
  //         };
  //       })
  //     );
  //     const updatedProductss = await Promise.all(
  //       filteredProducts.map(async (product) => {
  //         const ratings = await fetchRatings(product.id); // Fetch ratings asynchronously
  //         return {
  //           ...product,
  //           ratings, // Attach fetched ratings to product
  //         };
  //       })
  //     );

  //     setAllProducts(updatedProducts); // Set all products with ratings
  //     setProducts(updatedProductss);
  //     setLoading(false);
  //   } catch (err) {
  //     setError("Failed to fetch data");
  //     setLoading(false);
  //   }
  // };

  const fetchProducts = async () => {
    try {
      const response = await axios.get("https://api.lbnhyderabad.com/product/show-all-data");

      const filteredProducts = response.data.filter((product) => product.UserId === UserId);
      const filteredProductss = response.data.filter((product) => product.UserId !== UserId);


      if (!users1 || users1.length === 0) {
        console.error('No user data found!');
        return;
      }

      const userEmail = users1[0]?.email; // Get the first user's email, assuming `users` is an array of user objects

      if (!userEmail) {
        console.error('User email not found!');
        return;
      }


      const updatedProducts = await Promise.all(
        filteredProductss.map(async (product) => {
          const ratings = await fetchRatings(product.id);
          return { ...product, ratings };
        })
      );

      const updatedProductss = await Promise.all(
        filteredProducts.map(async (product) => {
          const ratings = await fetchRatings(product.id);
          return { ...product, ratings };
        })
      );

      const combined = [...updatedProducts];
      const shuffled = shuffleArray(combined);

      setProducts(updatedProductss);       // Your products, if you want them separately
      setAllProducts(updatedProducts);     // Others' products, if needed separately
      // this is the chapter wise products display
      console.log('this is shuffled', shuffled)
      const productsWithChapterCategory = shuffled.map((product) => {

        // Find the user that matches the UserId (which is the email here)
        const matchingUser = users1.find((user) => user.email === product.UserId);
        console.log('rhis is users1', users1)
        console.log('thisi s matchingUser', matchingUser)
        // If a matching user is found, add their chapterCategory to the product
        if (matchingUser) {
          return {
            ...product,
            chapterCategory: matchingUser.chapterCategory, // Attach chapterCategory to the product
          };
        }

        // If no matching user is found, return the product as is
        return product;
      });
      console.log('this is productsWithChapterCategory', productsWithChapterCategory)
      const filteredProductschapter = productsWithChapterCategory.filter(product => product.chapterCategory === users.chapterCategory);
      console.log('this is filteredProductschapter', filteredProductschapter)
      setShuffledProducts(filteredProductschapter);       // Display this list
      setLoading(false);
    } catch (err) {
      setError("Failed to fetch data");
      setLoading(false);
    }
  };

  useEffect(() => {
    if (users1 && users1.length > 0) {
      fetchProducts(); // Fetch products only if `users` data is available
    }
  }, [users1]); // Depend on users data so this effect triggers when `users` state changes


  useEffect(() => {
    fetchProducts();
    fetchRatings();
    fetchRatingss();
  }, []);
  // Reshuffle every hour
  useEffect(() => {
    const interval = setInterval(() => {
      setShuffledProducts((prev) => shuffleArray(prev));
    }, 60 * 60 * 1000); // 1 hour

    return () => clearInterval(interval);
  }, []);

  console.log(averageRating)

  // Handle rating submission
  const handleRatingSubmit = (productId) => {
    axios.post(`https://api.lbnhyderabad.com/product/api/products/${productId}/rating`, {
      email: email,  // Replace with actual user email
      rating: newRating.rating,
      review: newRating.review
    })
      .then(() => {
        fetchRatingss(productId);  // Refetch the ratings after submission
        setNewRating({ rating: 0, review: '' });
        fetchProducts();
      })
      .catch(error => console.error('Error posting rating:', error));
  };

  // const openRatingModal = () => {
  //   setIsModalRatingOpen(true);
  // };

  // const closeRatingModal = () => {
  //   setIsModalRatingOpen(false);
  // };
  const openRatingModal = (product) => {
    setIsModalRatingOpen(true);
    setCurrentProduct(product);
    fetchRatingss(product.id);  // Fetch the ratings for the product
  };

  const closeRatingModal = () => {
    setIsModalRatingOpen(false);
    setCurrentProduct(null);  // Clear current product on close
  };


  useEffect(() => {
    fetchProducts();
  }, []);



  // if (isMember === 0) {
  //   return (
  // <>
  //   <header className="headerdahboard">
  //     <input placeholder="Search profile" type="text" className="search" />
  //   </header>
  //   <div
  //     className="carddd"
  //     style={{
  //       width: "500px",
  //       justifyContent: "center",
  //       alignItems: "center",
  //       padding: "20px",
  //       borderRadius: "8px",
  //       margin: "20px auto",
  //     }}
  //   >
  //     <h2>Join the Lions Club</h2>
  //     <h2>Fill in your Business Information</h2>
  // <form onSubmit={handleSubmit} className="business-form">
  //   <div className="form-group">
  //     <label htmlFor="name_of_company">Name of Company:</label>
  //     <input
  //       type="text"
  //       name="name_of_company"
  //       value={formData.name_of_company}
  //       onChange={handleInputChange}
  //       className="form-input"
  //       required
  //     />
  //   </div>
  //   <div className="form-group">
  //     <label htmlFor="designation">Designation:</label>
  //     <input
  //       type="text"
  //       name="designation"
  //       value={formData.designation}
  //       onChange={handleInputChange}
  //       className="form-input"
  //       required
  //     />
  //   </div>
  //   <div className="form-group">
  //     <label htmlFor="designation">Joined_year:</label>
  //     <input
  //       type="number"
  //       name="joined_year"
  //       value={formData.joined_year}
  //       onChange={handleInputChange}
  //       placeholder="Joined Year"
  //       className="form-input"
  //       required
  //     />
  //   </div>
  //   <div className="form-group">
  //     <label htmlFor="designation">Position:</label>
  //     <input
  //       type="text"
  //       name="position"
  //       value={formData.position}
  //       onChange={handleInputChange}
  //       placeholder="Position"
  //       className="form-input"
  //       required
  //     />
  //   </div>
  //   <div className="form-group">
  //     <label htmlFor="designation">Year:</label>
  //     <input
  //       type="text"
  //       name="year"
  //       value={formData.year}
  //       onChange={handleInputChange}
  //       placeholder="Year"
  //       className="form-input"
  //       required
  //     />
  //   </div>
  //   <div className="form-group">
  //     <label htmlFor="website">Website:</label>
  //     <input
  //       type="url"
  //       name="website"
  //       value={formData.website}
  //       onChange={handleInputChange}
  //       className="form-input"
  //       required
  //     />
  //   </div>
  //   <div className="form-group">
  //     <label htmlFor="official_email_id">Official Email ID:</label>
  //     <input
  //       type="email"
  //       name="official_email_id"
  //       value={formData.official_email_id}
  //       onChange={handleInputChange}
  //       className="form-input"
  //       required
  //     />
  //   </div>
  //   <div className="form-group">
  //     <label htmlFor="product">Product:</label>
  //     <input
  //       type="text"
  //       name="product"
  //       value={formData.product}
  //       onChange={handleInputChange}
  //       className="form-input"
  //       required
  //     />
  //   </div>
  //   <div className="form-group">
  //     <label htmlFor="businessVerticalData">Business Vertical:</label>
  //     <input
  //       type="text"
  //       name="businessVerticalData"
  //       value={formData.businessVerticalData}
  //       onChange={handleInputChange}
  //       className="form-input"
  //       required
  //     />
  //   </div>
  //   <div className="form-group">
  //     <label htmlFor="businessProfession">Business Profession:</label>
  //     <input
  //       type="text"
  //       name="businessProfession"
  //       value={formData.businessProfession}
  //       onChange={handleInputChange}
  //       className="form-input"
  //       required
  //     />
  //   </div>
  //   <div className="form-group">
  //     <label htmlFor="businessProfession">Your Profile Photo:</label>
  //     <input
  //       type="file"
  //       name="logo"
  //       accept="image/*"
  //       onChange={handleFileChange}
  //       required
  //     />
  //   </div>

  //   <button type="submit" className="submit-btn">
  //     Submit
  //   </button>
  // </form>
  //   </div>

  //   <footer className="footer">
  //     <div className="social-icons">
  //       <a href="#">
  //         <FaInstagram />
  //       </a>
  //       <a href="#">
  //         <FaFacebook />
  //       </a>
  //       <a href="#">
  //         <FaTwitter />
  //       </a>
  //     </div>
  //     <p>©2023 Emedha technologies all right reserved.</p>
  //   </footer>
  // </>
  //   );
  // } else if (isMember === 1) {




  // B - B


  const [usersx, setUsersx] = useState([]);
  const [selectedUser, setSelectedUser] = useState(null);
  const [selectedUserSend, setSelectedUserSend] = useState(null);
  const [selectedUserThanks, setSelectedUserThanks] = useState(null);
  const [messagex, setMessagex] = useState('I am interested in for a one to one meeting you. Kindly confirm your appointment.');
  const [dateTime, setDateTime] = useState('');
  const [showModalSend, setShowModalSend] = useState(false);

  const [otherDetails, setOtherDetails] = useState({
    name: '',
    number: '',
    email: '',
  });
  useEffect(() => {
    fetch('https://api.lbnhyderabad.com/signup/api/users')
      .then((response) => response.json())
      .then((data) => setUsersx(data))
      .catch((error) => console.error('Error fetching users:', error));
  }, []);

  // Format users for the React Select component
  // const usersOptions = usersx.map((user) => ({
  //   value: user.id,
  //   label: user.name,
  // }));
  const usersOptions = usersx
    .filter((user) => user.email !== email &&
      user.chapterCategory === users.chapterCategory
    ) // exclude the logged-in user
    .map((user) => ({
      value: user.id,
      label: user.name,
    }));
  const usersOptionssend = usersx
    .filter((user) => user.email !== email &&

      (user.aadhaar_verify === 1 || user.gst_verify === 1) &&
      user.chapterCategory === users.chapterCategory
    ) // exclude the logged-in user
    .map((user) => ({
      value: user.id,
      label: user.name,
    }));

  const usersOptionsThanks = usersx
    .filter((user) => user.email !== email && user.isApprove === 1 &&
      user.chapterCategory === users.chapterCategory
    ) // exclude the logged-in user
    .map((user) => ({
      value: user.id,
      label: user.name,
    }));


  const handleUserChange = (selectedOption) => {
    const userId = selectedOption?.value;
    const userx = usersx.find((user) => user.id === parseInt(userId));
    setSelectedUser(userx);
  };

  const handleUserChange1 = (selectedOption) => {
    const userId = selectedOption?.value;
    const userx = usersx.find((user) => user.id === parseInt(userId));
    setSelectedUserSend(userx);
  };
  const handleUserChange2 = (selectedOption) => {
    const userId = selectedOption?.value;
    const userx = usersx.find((user) => user.id === parseInt(userId));
    setSelectedUserThanks(userx);
  };
  const handleInputChangeSend = (e) => {
    const { name, value } = e.target;
    setOtherDetails({ ...otherDetails, [name]: value });
  };

  // const handleSendReff = () => {
  //   if (!otherDetails.name || !otherDetails.number || !otherDetails.email) {
  //     alert("Please fill all fields");
  //     return;
  //   }

  //   // You can replace this with API call later
  //   console.log("Sending referral to:", otherDetails);

  //   // Reset modal and inputs
  //   setShowModalSend(false);
  //   setOtherDetails({ name: '', number: '', email: '' });
  // };
  // console.log('thi sis userx details ',selectedUserSend.businessVerticalData)

  const handleSendReff = async () => {
    const { name, number, email } = otherDetails;
    const productBV = selectedUserSend.businessVerticalData;
    const selectedEmail = selectedUserSend.email // Selected product info
    console.log(productBV);
    const emailLooged = sessionStorage.getItem('email');

    try {
      // Send the referral data to the backend API
      const response = await axios.post(
        "http://localhost:10005/product/Other_referral",
        {
          email: emailLooged, // Referrer's email
          // name: email, // Sender's name (who is sending the referral)
          productName: productBV, // Product name
          // product: product.productPhoto, // Product description or details
          // price: product.productPrice, // Product price
          salerEmail: selectedEmail, // Seller's em
          customerEmail: email, // Customer's email
          customerName: name, // Customer's name
          customerMobile: number, // Customer's mobile
          userId: userId,
        }
      );

      if (response.status === 200) {
        alert("Referral sent successfully!");
        setOtherDetails({
          name: '',
          number: '',
          email: ''
        });
        setShowModalSend(); // Close the modal after successful submission
      } else {
        alert("Something went wrong!");
      }
    } catch (error) {
      console.error("Error sending referral:", error);
      alert("Error sending referral!");
    }
  };

  const handleSendReffSelf = async () => {
    // const { name, number, email } = otherDetails;
    const productBV = selectedUserSend.businessVerticalData;
    const selectedEmail = selectedUserSend.email // Selected product info
    console.log(productBV);
    const emailLooged = sessionStorage.getItem('email');

    try {
      // Send the referral data to the backend API
      const response = await axios.post(
        "http://localhost:10005/product/self_referral",
        {
          email: emailLooged, // Referrer's email
          // name: email, // Sender's name (who is sending the referral)
          productName: productBV, // Product name
          // product: product.productPhoto, // Product description or details
          // price: product.productPrice, // Product price
          salerEmail: selectedEmail, // Seller's em
          // customerEmail:email, // Customer's email
          // customerName:name, // Customer's name
          // customerMobile:number, // Customer's mobile
          userId: userId,
        }
      );

      if (response.status === 200) {
        alert("Referral sent successfully!");
        setShowModalSend(); // Close the modal after successful submission
      } else {
        alert("Something went wrong!");
      }
    } catch (error) {
      console.error("Error sending referral:", error);
      alert("Error sending referral!");
    }
  };


  const handleMessageChange = (e) => {
    setMessagex(e.target.value);
  };

  const handleDateTimeChange = (e) => {
    setDateTime(e.target.value);
  };

  const handleSend = () => {
    if (!selectedUser || !messagex || !dateTime) {
      alert('Please fill all fields!');
      return;
    }

    const emailData = {
      name: selectedUser.name,
      email: selectedUser.email,
      dateTime: dateTime,
      message: messagex,
      userId: userId,
    };

    axios.post('https://api.lbnhyderabad.com/signup/api/send-invite', emailData, {
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
      },
    })
      .then((response) => {
        console.log(response.data);  // Log the full response object for debugging
        if (response.status === 200) {
          alert('Appointment request sent!');
          handleFetchInvitations();
          resetFormy();  // Reset the form on success
        } else {
          alert(`Failed to send invitation: ${response.data}`);
        }
      })
      .catch((error) => {
        console.error('Error sending email:', error);
        alert('An error occurred. Please try again later.');
      });
  };


  const resetFormy = () => {
    setSelectedUser(null);
    setMessagex('I am interested in for a one to one meeting you. Kindly confirm your appointment.');
    setDateTime('');
  };

  // report 

  const [invitations, setInvitations] = useState([]);
  const totalInvitation = invitations.length;
  const [selectedUserz, setSelectedUserz] = useState('');
  const [inputBox, setInputBox] = useState('');
  const [ask, setAsk] = useState('');
  const [give, setGive] = useState('');


  const handleFetchInvitations = () => {
    axios.get('https://api.lbnhyderabad.com/signup/api/invitations')
      .then((response) => {
        if (response.status === 200) {
          // setInvitations(response.data);
          const allInvitations = response.data;
          const filteredInvitations = allInvitations.filter(invite => invite.userId === userId);
          setInvitations(filteredInvitations);
        } else {
          alert('Failed to fetch invitations');
        }
      })
      .catch((error) => {
        console.error('Error fetching invitations:', error);
        alert('An error occurred while fetching invitations');
      });
  };

  useEffect(() => {
    handleFetchInvitations();
  }, []);

  const [invitationsget, setInvitationsget] = useState([]);

  const invitecount = invitationsget.length;
  useEffect(() => {
    fetchInvitations();
  }, []);

  const fetchInvitations = async () => {
    try {
      const response = await axios.get('https://api.lbnhyderabad.com/signup/api/visitorInvitations');

      const allInvitations = response.data;
      const filteredInvitations = allInvitations.filter(invite => invite.userId === userId);

      setInvitationsget(filteredInvitations);

    } catch (error) {
      console.error('Error fetching invitations:', error);
      alert('Failed to load visitor invitations.');
    } finally {
      setLoading(false);
    }
  };

  const handleSubmitz = (e) => {
    e.preventDefault();

    if (!selectedUserz || !selectedUserz.email) {
      alert('Please select a valid user');
      return;
    }

    const invitationData = {
      user: selectedUserz.name,
      inputBox,
      ask,
      give,
      recipientEmail: selectedUserz.email,
    };

    axios.post('https://api.lbnhyderabad.com/signup/api/report', invitationData)
      .then((response) => {
        if (response.status === 200) {
          alert('Invitation submitted successfully');
          setInputBox('');
          setAsk('');
          setGive('');
        } else {
          alert('Failed to submit invitation');
        }
      })
      .catch((error) => {
        console.error('Error submitting invitation:', error);
        alert('An error occurred while submitting the invitation');
      });
  };
  console.log('this is invitations', invitations)
  // Format invitations for react-select
  const usersOptionsz = invitations.map((invitation) => ({
    value: invitation.email,
    label: `${invitation.name},${new Date(invitation.dateTime).toLocaleString()}`,
  }));

  const handleUserChangez = (selectedOption) => {
    const selectedUser = invitations.find(invitation => invitation.email === selectedOption.value);
    setSelectedUserz(selectedUser);
  };



  //  visitor Invite

  const [meetingsy, setMeetingsy] = useState([]);
  const [selectedMeeting, setSelectedMeeting] = useState(null);
  const [visitorName, setVisitorName] = useState('');
  const [visitorMobile, setVisitorMobile] = useState('');
  const [visitorEmail, setVisitorEmail] = useState('');
  const [visitorMessage, setVisitorMessage] = useState([]);
  const [visitorImage, setVisitorImage] = useState(null);

  // const [visitorMessage, setVisitorMessage] = useState("Dear, I’m inviting you to attend our chapter meeting as a visitor.");

  useEffect(() => {
    axios.get('https://api.lbnhyderabad.com/signup/api/messages')
      .then(response => {
        if (response.data.length > 0) {
          setVisitorMessage(response.data[0].message);
        }
      })
      .catch(error => {
        console.error('Error fetching message:', error);
      });
  }, []);

  console.log('this is this visitorMessage', visitorMessage)

  const fetchVisitorInvite = () => {
    axios
      .get('https://api.lbnhyderabad.com/signup/api/visitorinvite')
      .then(response => {
        const filteredMeetings = response.data.filter(
          (meeting) =>
            meeting.chapter?.trim().toLowerCase() ===
            users.chapterCategory?.trim().toLowerCase()
        );
        setMeetingsy(filteredMeetings);
      })
      .catch(error => {
        console.error('Error fetching meetings:', error);
      });
  };

  useEffect(() => {
    if (users?.chapterCategory) {
      fetchVisitorInvite();
    }
  }, [users]);

  function formatDateToDateInput(date) {
    const dateObj = new Date(date);
    const year = dateObj.getFullYear();
    const month = (dateObj.getMonth() + 1).toString().padStart(2, '0');
    const day = dateObj.getDate().toString().padStart(2, '0');
    return `${year}-${month}-${day}`;
  }

  const handleSubmity = (e) => {
    e.preventDefault();

    if (!selectedMeeting || !visitorName || !visitorMobile || !visitorMessage) {
      alert('Please fill all fields');
      return;
    }
    const formattedDate = formatDateToDateInput(selectedMeeting.date);
    const formData = new FormData();
    formData.append("meetingId", selectedMeeting.id);
    formData.append("visitorName", visitorName);
    formData.append("visitorMobile", visitorMobile);
    // formData.append("visitorEmail", visitorEmail);
    formData.append('visitorEmail', visitorEmail || '');
    formData.append("visitorMessage", `Message: ${visitorMessage}\nVenue: ${selectedMeeting.venue}\nDate: ${formattedDate}`);
    formData.append("userId", userId);
    if (visitorImage) {
      formData.append("visitorImage", visitorImage); // the actual file object
    }

    axios.post('https://api.lbnhyderabad.com/signup/api/sendVisitorInvite', formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
      .then(response => {
        console.log(response);
        alert('Invitation sent successfully!');
        resetForm();
        fetchInvitations();
      })
      .catch(error => {
        console.error('Error sending invitation:', error);
        // alert('Failed to send invitation.',error);
        if (error.response && error.response.data && error.response.data.message) {
          alert(error.response.data.message);
        } else {
          alert('Failed to send invitation.');
        }
      });
  };



  const resetForm = () => {
    setSelectedMeeting(null);
    setVisitorName('');
    setVisitorMobile('');
    setVisitorEmail('');
    setVisitorMessage([]);
  };

  const meetingOptions = meetingsy.map((meeting) => ({
    value: meeting.id,
    label: `${meeting.venue} - ${new Date(meeting.date).toLocaleDateString()}`,
  }));

  const handleMeetingChange = (selectedOption) => {
    const meeting = meetingsy.find(m => m.id === selectedOption.value);
    setSelectedMeeting(meeting);
  };

  // event Visitor Invite



  const [invitationsget_event, setInvitationsget_event] = useState([]);

  const invitecount_event = invitationsget_event.length;
  useEffect(() => {
    fetchInvitations_event();
  }, []);

  const fetchInvitations_event = async () => {
    try {
      const response = await axios.get('https://api.lbnhyderabad.com/signup/api/visitorInvitations_event');

      const allInvitations = response.data;
      const filteredInvitations = allInvitations.filter(invite => invite.userId === userId);

      setInvitationsget_event(filteredInvitations);

    } catch (error) {
      console.error('Error fetching invitations:', error);
      alert('Failed to load visitor invitations.');
    } finally {
      setLoading(false);
    }
  };


  const [meetingsy_event, setMeetingsy_event] = useState([]);
  const [selectedMeeting_event, setSelectedMeeting_event] = useState(null);
  const [visitorName_event, setVisitorName_event] = useState('');
  const [visitorMobile_event, setVisitorMobile_event] = useState('');
  const [visitorEmail_event, setVisitorEmail_event] = useState('');
  const [visitorMessage_event, setVisitorMessage_event] = useState([]);
  const [visitorImage_event, setVisitorImage_event] = useState(null);


  // const [visitorMessage, setVisitorMessage] = useState("Dear, I’m inviting you to attend our chapter meeting as a visitor.");

  useEffect(() => {
    axios.get('https://api.lbnhyderabad.com/signup/api/messages_event')
      .then(response => {
        if (response.data.length > 0) {
          setVisitorMessage_event(response.data[0].message);
        }
      })
      .catch(error => {
        console.error('Error fetching message:', error);
      });
  }, []);

  console.log('this is this visitorMessage', visitorMessage_event)

  const fetchVisitorInvite_event = () => {
    axios
      .get('https://api.lbnhyderabad.com/signup/api/visitorinvite_event')
      .then(response => {
        const filteredMeetings = response.data.filter(
          (meeting) =>
            meeting.chapter?.trim().toLowerCase() ===
            users.chapterCategory?.trim().toLowerCase()
        );
        setMeetingsy_event(filteredMeetings);
      })
      .catch(error => {
        console.error('Error fetching meetings:', error);
      });
  };

  useEffect(() => {
    if (users?.chapterCategory) {
      fetchVisitorInvite_event();
    }
  }, [users]);

  function formatDateToDateInput(date) {
    const dateObj = new Date(date);
    const year = dateObj.getFullYear();
    const month = (dateObj.getMonth() + 1).toString().padStart(2, '0');
    const day = dateObj.getDate().toString().padStart(2, '0');
    return `${year}-${month}-${day}`;
  }

  const handleSubmity_event = (e) => {
    e.preventDefault();

    if (!selectedMeeting_event || !visitorName_event || !visitorMobile_event || !visitorMessage_event) {
      alert('Please fill all fields');
      return;
    }
    const formattedDate = formatDateToDateInput(selectedMeeting_event.date);
    const formData = new FormData();
    formData.append("meetingId", selectedMeeting_event.id);
    formData.append("visitorName", visitorName_event);
    formData.append("visitorMobile", visitorMobile_event);
    // formData.append("visitorEmail", visitorEmail);
    formData.append('visitorEmail', visitorEmail_event || '');
    formData.append("visitorMessage", `Message: ${visitorMessage_event}\nVenue: ${selectedMeeting_event.venue}\nDate: ${formattedDate}`);
    formData.append("userId", userId);
    if (visitorImage_event) {
      formData.append("visitorImage", visitorImage_event); // the actual file object
    }

    axios.post('https://api.lbnhyderabad.com/signup/api/sendVisitorInvite_event', formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
      .then(response => {
        console.log(response);
        alert('Invitation sent successfully!');
        resetForm_event();
        fetchInvitations();
      })
      .catch(error => {
        console.error('Error sending invitation:', error);
        // alert('Failed to send invitation.',error);
        if (error.response && error.response.data && error.response.data.message) {
          alert(error.response.data.message);
        } else {
          alert('Failed to send invitation.');
        }
      });
  };



  const resetForm_event = () => {
    setSelectedMeeting(null);
    setVisitorName_event('');
    setVisitorMobile_event('');
    setVisitorEmail_event('');
    setVisitorMessage_event([]);
  };

  const meetingOptions_event = meetingsy_event.map((meeting) => ({
    value: meeting.id,
    label: `${meeting.venue} - ${new Date(meeting.date).toLocaleDateString()}`,
  }));

  const handleMeetingChange_event = (selectedOption) => {
    const meeting = meetingsy_event.find(m => m.id === selectedOption.value);
    setSelectedMeeting_event(meeting);
  };


  // meating invite ...

  const [formDatamettinginvute, setFormDataMettingInvite] = useState({
    name: '',
    mobile: '',
    email: '',
    membershipNo: '',
    district: '320A',
    club: '',
    businessVertical: '',
    firmName: ''
  });

  const handleChangeMeetingInvite = (e) => {
    const { name, value } = e.target;
    setFormDataMettingInvite({ ...formData, [name]: value });
  };

  const handleSubmitMeetingInvite = (e) => {
    e.preventDefault();
    console.log(formData); // You can handle form submission here
  };

  // Inline styles for the form and its elements
  const formContainerStyle = {
    width: '100%',
    maxWidth: '600px',
    margin: '50px auto',
    padding: '20px',
    backgroundColor: '#fff',
    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
  };

  const formStyle = {
    display: 'flex',
    flexDirection: 'column',
  };

  const labelStyle = {
    fontWeight: 'bold',
    marginBottom: '5px',
  };

  const inputStyle = {
    marginBottom: '15px',
    padding: '10px',
    fontSize: '1rem',
    border: '1px solid #ccc',
    borderRadius: '5px',
  };

  const buttonStyle = {
    padding: '12px',
    backgroundColor: '#007BFF',
    color: 'white',
    fontSize: '1rem',
    border: 'none',
    borderRadius: '5px',
    cursor: 'pointer',
    transition: 'background-color 0.3s ease',
  };

  const buttonHoverStyle = {
    ...buttonStyle,
    backgroundColor: '#0056b3',
  };

  const mediaQueryStyle = {
    '@media (max-width: 600px)': {
      formContainerStyle: {
        padding: '15px',
      },
      labelStyle: {
        fontSize: '0.9rem',
      },
      inputStyle: {
        fontSize: '0.9rem',
      },
      buttonStyle: {
        padding: '10px',
      },
    },
  };

  const [searchTerm, setSearchTerm] = useState("");
  const filteredProducts = shuffledProducts.filter((product) => {
    const name = product.productName.toLowerCase();
    const desc = product.productDesc.toLowerCase();
    const term = searchTerm.toLowerCase();
    return name.includes(term) || desc.includes(term);
  });

  const [expanded, setExpanded] = useState(false);

  const toggleExpanded = () => setExpanded(!expanded);

  const isExpiredd = (validity) => {
    if (!validity) return false;
    const today = new Date();
    const validDate = new Date(validity);
    return validDate < today;
  };

  const formatDate = (date) => {
  if (!date) return "Not Available";

  const d = new Date(date);

  if (isNaN(d.getTime())) return "Not Available";

  return d.toLocaleDateString("en-GB", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });
};
  return (
    <>
      <div>
        {/* <header className="header-dashboard">
          <Navbar expand="lg" style={{ color: "#00529b", backgroundColor: "white" }}>
            <Container style={{ color: "white" }}>
              <Navbar.Brand><img src={lbnlogo} /></Navbar.Brand>

              <Navbar.Toggle aria-controls="navbar-nav" onClick={() => setIsNavbarCollapsed(!isNavbarCollapsed)} />

              <Navbar.Collapse id="navbar-nav" in={!isNavbarCollapsed}>
                <Nav className="me-auto">

                </Nav>

                <Nav>

                  <Nav.Link onClick={() => handleNavClick("home")} style={{ color: "#00529b" }}>Home</Nav.Link>
                 
                  <Nav.Link onClick={() => handleNavClick("products")} style={{ color: "#00529b" }}>Products</Nav.Link>
                  <Nav.Link onClick={() => handleNavClick("sendreferral")} style={{ color: "#00529b" }}>Send Referral</Nav.Link>
                  <Dropdown align="end">
                    <Dropdown.Toggle variant="link" id="dropdown-one-to-one" style={{ color: "#00529b", textDecoration: 'none' }}>
                      Referrals
                    </Dropdown.Toggle>
                    <Dropdown.Menu>
                      <Dropdown.Item onClick={() => handleNavClick("referralIn")} style={{ color: "#00529b" }}>Referral Sent</Dropdown.Item>
                      <Dropdown.Item onClick={() => handleNavClick("referralOut")} style={{ color: "#00529b" }}>Referral Received</Dropdown.Item>
                    </Dropdown.Menu>
                  </Dropdown>


                
                  <Dropdown align="end">
                    <Dropdown.Toggle variant="link" id="dropdown-one-to-one" style={{ color: "#00529b", textDecoration: 'none' }}>
                      Calendar's
                    </Dropdown.Toggle>
                    <Dropdown.Menu>
                      <Dropdown.Item onClick={() => handleNavClick("meetingCalendar")} style={{ color: "#00529b" }}>Meeting Calendar</Dropdown.Item>
                      <Dropdown.Item onClick={() => handleNavClick("eventCalendar")} style={{ color: "#00529b" }}>Event Calendar</Dropdown.Item>
                    </Dropdown.Menu>
                  </Dropdown>

                    <Nav.Link onClick={() => handleNavClick("thankYou")} style={{ color: "#00529b" }}>Thanks Note</Nav.Link>
               
                  <Dropdown align="end">
                    <Dropdown.Toggle variant="link" id="dropdown-one-to-one" style={{ color: "#00529b", textDecoration: 'none' }}>
                      B - B
                    </Dropdown.Toggle>
                    <Dropdown.Menu>
                      <Dropdown.Item onClick={() => handleNavClick("invite")} style={{ color: "#00529b" }}>Invite</Dropdown.Item>
                      <Dropdown.Item onClick={() => handleNavClick("report")} style={{ color: "#00529b" }}>Report</Dropdown.Item>
                    </Dropdown.Menu>
                  </Dropdown>

                  <Dropdown align="end">
                    <Dropdown.Toggle variant="link" id="dropdown-one-to-one" style={{ color: "#00529b", textDecoration: 'none' }}>
                      Visitor Invite
                    </Dropdown.Toggle>
                    <Dropdown.Menu>
                      <Dropdown.Item onClick={() => handleNavClick("visitorInvite")} style={{ color: "#00529b" }}>Visitor Meeting Invite</Dropdown.Item>
                      <Dropdown.Item onClick={() => handleNavClick("visitorEventInvite")} style={{ color: "#00529b" }}>Visitor Event Invite</Dropdown.Item>
                    </Dropdown.Menu>
                  </Dropdown>

                  <div className="profile-iconn-container" ref={profileIconRef}>
                      {users.logo ? (
                      <img
                        src={users.logo}
                        alt={`Profile picture of ${users.name}`}
                        onClick={toggleDropdown}
                        height="35"
                        width="60"
                        style={{
                          borderRadius: "50%",
                          border: "2px solid #007bff",
                          objectFit: "contain",
                          cursor: "pointer"
                        }}
                      />
                    ) : (
                      <FaUserCircle
                        onClick={toggleDropdown}
                        style={{ color: "#00529b", fontSize: 35, cursor: "pointer" }}
                      />
                    )}

                    {dropdownOpen && (
                      <div className="dropdownn-menu" ref={dropdownRef}>
                        <div className="dropdownn-item" onClick={() => handleNavClick("profile")}>My Profile</div>
                        <div className="dropdownn-item logout" onClick={handleLogout}>Logout</div>
                      </div>
                    )}
                  </div>
                </Nav>
              </Navbar.Collapse>
            </Container>
          </Navbar>
        </header> */}

        <header
  className="header-dashboard"
  style={{
    position: "sticky",
    top: 0,
    zIndex: 999,
    background: "rgba(255,255,255,0.96)",
    backdropFilter: "blur(12px)",
    boxShadow: "0 4px 20px rgba(0,0,0,0.08)",
    borderBottom: "1px solid rgba(0,0,0,0.06)",
  }}
>
  <Navbar
    expand="lg"
    expanded={!isNavbarCollapsed}
    style={{
      backgroundColor: "transparent",
      padding: "0px",
    }}
  >
    <Container
      fluid
      style={{
        maxWidth: "1400px",
        margin: "0 auto",
        padding: "0px 18px",
        minHeight: "78px",
      }}
    >
      {/* LEFT LOGO */}
      <Navbar.Brand
        style={{
          display: "flex",
          alignItems: "center",
          gap: "12px",
          margin: 0,
        }}
      >
        <img
          src={lbnlogo}
          alt="logo"
          style={{
            width: "85px",
            height: "58px",
            borderRadius: "50%",
            objectFit: "contain",
            border: "3px solid #f59e0b",
            boxShadow: "0 4px 10px rgba(0,0,0,0.12)",
          }}
        />

        {/* <div className="dashboard-brand-text">
          <h3
            style={{
              margin: 0,
              fontSize: "20px",
              fontWeight: "700",
              color: "#1e3a8a",
              lineHeight: "1.1",
            }}
          >
            LBN
          </h3>

          <p
            style={{
              margin: 0,
              fontSize: "12px",
              color: "#666",
              fontWeight: "500",
            }}
          >
            Official Portal
          </p>
        </div> */}
      </Navbar.Brand>

      {/* TOGGLE */}
      <Navbar.Toggle
        aria-controls="navbar-nav"
        onClick={() => setIsNavbarCollapsed(!isNavbarCollapsed)}
        style={{
          border: "none",
          boxShadow: "none",
          padding: "6px 10px",
        }}
      />

      {/* NAVBAR */}
      <Navbar.Collapse id="navbar-nav">
        <Nav
          className="me-auto"
          style={{
            flex: 1,
          }}
        ></Nav>

        <Nav
          style={{
            alignItems: "center",
            gap: "10px",
          }}
        >
          {/* HOME */}
          <Nav.Link
            onClick={() => handleNavClick("home")}
            style={{
              color: "#00529b",
              fontWeight: "600",
              fontSize: "15px",
              position: "relative",
              padding: "10px 14px",
              borderRadius: "10px",
              transition: "0.3s",
            }}
          >
            Home
          </Nav.Link>

          {/* PRODUCTS */}
          <Nav.Link
            onClick={() => handleNavClick("products")}
            style={{
              color: "#00529b",
              fontWeight: "600",
              fontSize: "15px",
              padding: "10px 14px",
              borderRadius: "10px",
              transition: "0.3s",
            }}
          >
            Products
          </Nav.Link>

          {/* SEND REFERRAL */}
          <Nav.Link
            onClick={() => handleNavClick("sendreferral")}
            style={{
              color: "#00529b",
              fontWeight: "600",
              fontSize: "15px",
              padding: "10px 14px",
              borderRadius: "10px",
              transition: "0.3s",
            }}
          >
            Send Referral
          </Nav.Link>

          {/* REFERRALS */}
          <Dropdown align="end">
            <Dropdown.Toggle
              variant="link"
              id="dropdown-one-to-one"
              style={{
                color: "#00529b",
                textDecoration: "none",
                fontWeight: "600",
                fontSize: "15px",
                padding: "10px 14px",
                borderRadius: "10px",
                boxShadow: "none",
              }}
            >
              Referrals
            </Dropdown.Toggle>

            <Dropdown.Menu
              style={{
                border: "none",
                borderRadius: "16px",
                padding: "10px",
                boxShadow: "0 10px 30px rgba(0,0,0,0.12)",
                minWidth: "230px",
              }}
            >
              <Dropdown.Item
                onClick={() => handleNavClick("referralIn")}
                style={{
                  color: "#00529b",
                  padding: "12px 14px",
                  borderRadius: "10px",
                  fontWeight: "500",
                }}
              >
                Referral Sent
              </Dropdown.Item>

              <Dropdown.Item
                onClick={() => handleNavClick("referralOut")}
                style={{
                  color: "#00529b",
                  padding: "12px 14px",
                  borderRadius: "10px",
                  fontWeight: "500",
                }}
              >
                Referral Received
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>

          {/* CALENDAR */}
          <Dropdown align="end">
            <Dropdown.Toggle
              variant="link"
              style={{
                color: "#00529b",
                textDecoration: "none",
                fontWeight: "600",
                fontSize: "15px",
                padding: "10px 14px",
                borderRadius: "10px",
                boxShadow: "none",
              }}
            >
              Calendar's
            </Dropdown.Toggle>

            <Dropdown.Menu
              style={{
                border: "none",
                borderRadius: "16px",
                padding: "10px",
                boxShadow: "0 10px 30px rgba(0,0,0,0.12)",
                minWidth: "230px",
              }}
            >
              <Dropdown.Item
                onClick={() => handleNavClick("meetingCalendar")}
                style={{
                  color: "#00529b",
                  padding: "12px 14px",
                  borderRadius: "10px",
                  fontWeight: "500",
                }}
              >
                Meeting Calendar
              </Dropdown.Item>

              <Dropdown.Item
                onClick={() => handleNavClick("eventCalendar")}
                style={{
                  color: "#00529b",
                  padding: "12px 14px",
                  borderRadius: "10px",
                  fontWeight: "500",
                }}
              >
                Event Calendar
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>

          {/* THANKS */}
          <Nav.Link
            onClick={() => handleNavClick("thankYou")}
            style={{
              color: "#00529b",
              fontWeight: "600",
              fontSize: "15px",
              padding: "10px 14px",
              borderRadius: "10px",
              transition: "0.3s",
            }}
          >
            Thanks Note
          </Nav.Link>

          {/* B-B */}
          <Dropdown align="end">
            <Dropdown.Toggle
              variant="link"
              style={{
                color: "#00529b",
                textDecoration: "none",
                fontWeight: "600",
                fontSize: "15px",
                padding: "10px 14px",
                borderRadius: "10px",
                boxShadow: "none",
              }}
            >
              B - B
            </Dropdown.Toggle>

            <Dropdown.Menu
              style={{
                border: "none",
                borderRadius: "16px",
                padding: "10px",
                boxShadow: "0 10px 30px rgba(0,0,0,0.12)",
                minWidth: "220px",
              }}
            >
              <Dropdown.Item
                onClick={() => handleNavClick("invite")}
                style={{
                  color: "#00529b",
                  padding: "12px 14px",
                  borderRadius: "10px",
                  fontWeight: "500",
                }}
              >
                Invite
              </Dropdown.Item>

              <Dropdown.Item
                onClick={() => handleNavClick("report")}
                style={{
                  color: "#00529b",
                  padding: "12px 14px",
                  borderRadius: "10px",
                  fontWeight: "500",
                }}
              >
                Report
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>

          {/* VISITOR */}
          <Dropdown align="end">
            <Dropdown.Toggle
              variant="link"
              style={{
                color: "#00529b",
                textDecoration: "none",
                fontWeight: "600",
                fontSize: "15px",
                padding: "10px 14px",
                borderRadius: "10px",
                boxShadow: "none",
              }}
            >
              Visitor Invite
            </Dropdown.Toggle>

            <Dropdown.Menu
              style={{
                border: "none",
                borderRadius: "16px",
                padding: "10px",
                boxShadow: "0 10px 30px rgba(0,0,0,0.12)",
                minWidth: "260px",
              }}
            >
              <Dropdown.Item
                onClick={() => handleNavClick("visitorInvite")}
                style={{
                  color: "#00529b",
                  padding: "12px 14px",
                  borderRadius: "10px",
                  fontWeight: "500",
                }}
              >
                Visitor Meeting Invite
              </Dropdown.Item>

              <Dropdown.Item
                onClick={() => handleNavClick("visitorEventInvite")}
                style={{
                  color: "#00529b",
                  padding: "12px 14px",
                  borderRadius: "10px",
                  fontWeight: "500",
                }}
              >
                Visitor Event Invite
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>

          {/* PROFILE */}
          <div
            className="profile-iconn-container"
            ref={profileIconRef}
            style={{
              marginLeft: "8px",
              position: "relative",
            }}
          >
            {users.logo ? (
              <img
                src={users.logo}
                alt={`Profile picture of ${users.name}`}
                onClick={toggleDropdown}
                height="48"
                width="48"
                style={{
                  borderRadius: "50%",
                  border: "3px solid #f59e0b",
                  objectFit: "cover",
                  cursor: "pointer",
                  boxShadow: "0 4px 10px rgba(0,0,0,0.12)",
                }}
              />
            ) : (
              <FaUserCircle
                onClick={toggleDropdown}
                style={{
                  color: "#00529b",
                  fontSize: 42,
                  cursor: "pointer",
                }}
              />
            )}

            {dropdownOpen && (
              <div
                className="dropdownn-menu"
                ref={dropdownRef}
                style={{
                  position: "absolute",
                  top: "62px",
                  right: 0,
                  background: "#fff",
                  borderRadius: "16px",
                  minWidth: "220px",
                  padding: "10px",
                  boxShadow: "0 12px 30px rgba(0,0,0,0.14)",
                  border: "1px solid rgba(0,0,0,0.06)",
                  zIndex: 9999,
                }}
              >
                <div
                  className="dropdownn-item"
                  onClick={() => handleNavClick("profile")}
                  style={{
                    padding: "12px 14px",
                    borderRadius: "10px",
                    cursor: "pointer",
                    fontWeight: "500",
                    color: "#00529b",
                    transition: "0.3s",
                  }}
                >
                  My Profile
                </div>

                <div
                  className="dropdownn-item logout"
                  onClick={handleLogout}
                  style={{
                    padding: "12px 14px",
                    borderRadius: "10px",
                    cursor: "pointer",
                    fontWeight: "500",
                    color: "#dc2626",
                    transition: "0.3s",
                  }}
                >
                  Logout
                </div>
              </div>
            )}
          </div>
        </Nav>
      </Navbar.Collapse>
    </Container>
  </Navbar>

  {/* RESPONSIVE CSS */}
  <style>
    {`
      .navbar-toggler {
        border: none !important;
        box-shadow: none !important;
      }

      .navbar-toggler:focus {
        box-shadow: none !important;
      }

      .nav-link:hover {
        color: #1e3a8a !important;
        background: #eff6ff;
      }

      .dropdown-item:hover {
        background: #eff6ff !important;
      }

      .dropdownn-item:hover {
        background: #eff6ff;
      }

      @media (max-width: 1200px) {

        .navbar-nav {
          gap: 4px !important;
        }

        .nav-link {
          font-size: 14px !important;
          padding: 8px 10px !important;
        }
      }

      @media (max-width: 991px) {

        .dashboard-brand-text {
          display: none !important;
        }

        .navbar-collapse {
          background: #ffffff;
          margin-top: 18px;
          padding: 20px;
          border-radius: 22px;
          box-shadow: 0 10px 30px rgba(0,0,0,0.12);
          max-height: 80vh;
          overflow-y: auto;
        }

        .navbar-nav {
          gap: 6px !important;
        }

        .nav-link {
          width: 100%;
          border-radius: 12px !important;
          padding: 14px 16px !important;
        }

        .dropdown-toggle {
          width: 100%;
          text-align: left !important;
          border-radius: 12px !important;
          padding: 14px 16px !important;
        }

        .dropdown-menu {
          width: 100%;
          margin-top: 10px !important;
          border-radius: 16px !important;
          position: relative !important;
          transform: none !important;
        }

        .profile-iconn-container {
          margin-top: 16px !important;
          display: flex;
          justify-content: center;
        }

        .dropdownn-menu {
          right: auto !important;
          left: 50% !important;
          transform: translateX(-50%);
        }
      }

      @media (max-width: 576px) {

        .header-dashboard img {
          width: 48px !important;
          height: 48px !important;
        }

        .navbar-collapse {
          padding: 16px !important;
          border-radius: 18px !important;
        }

        .nav-link,
        .dropdown-toggle {
          font-size: 14px !important;
        }
      }
    `}
  </style>
</header>

        <div className="containerdashboard">
          <>
            {activeSection === "home" && (
              <div
                style={{
                  minHeight: "100vh",
                  background: "linear-gradient(to bottom right, #f8fafc, #dbeafe)",
                  paddingBottom: "40px",
                }}
              >
                {/* Header Section */}
                <div
                  style={{
                    background: "linear-gradient(to right, #1e3a8a, #1e40af)",
                    padding: "60px 20px",
                    color: "#fff",
                    marginBottom: "40px",
                  }}
                >
                  <div className="container">
                    <h1
                      style={{
                        fontSize: "42px",
                        fontWeight: "700",
                        marginBottom: "10px",
                      }}
                    >
                      Welcome Back!
                    </h1>

                    <p
                      style={{
                        fontSize: "18px",
                        opacity: 0.9,
                        marginBottom: 0,
                      }}
                    >
                      Lions Business Network Dashboard - Multiple District 320
                    </p>
                  </div>
                </div>

                <div className="container">
                  <Row className="g-4 justify-content-center">

                    {/* Referred Members */}
                    <Col xs={12} sm={6} lg={4} xl={3}>
                      <Card
                        onClick={handleModalOpenC}
                        style={{
                          border: "none",
                          borderRadius: "22px",
                          overflow: "hidden",
                          cursor: "pointer",
                          background: "#fff",
                          boxShadow: "0 10px 30px rgba(0,0,0,0.08)",
                          transition: "0.3s",
                          minHeight: "260px",
                        }}
                        className="h-100"
                      >
                        <Card.Body className="p-4 d-flex flex-column justify-content-between">
                          <div className="d-flex justify-content-between align-items-center mb-4">
                            <div
                              style={{
                                width: "65px",
                                height: "65px",
                                borderRadius: "18px",
                                background: "linear-gradient(135deg,#3b82f6,#2563eb)",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                              }}
                            >
                              <img
                                alt="Referral icon"
                                src={referrall1}
                                style={{ width: "38px", height: "38px" }}
                              />
                            </div>

                            <div
                              style={{
                                fontSize: "38px",
                                fontWeight: "700",
                                color: "#2563eb",
                              }}
                            >
                              {referralCount}
                            </div>
                          </div>

                          <div>
                            <h5 style={{ fontWeight: "700", color: "#1f2937" }}>
                              Referred Members
                            </h5>

                            <p
                              style={{
                                color: "#2563eb",
                                fontSize: "13px",
                                marginBottom: 0,
                              }}
                            >
                              Click to view members
                            </p>
                          </div>
                        </Card.Body>
                      </Card>
                    </Col>

                    {/* Loyalty Points */}
                    <Col xs={12} sm={6} lg={4} xl={3}>
                      <Card
                        style={{
                          border: "none",
                          borderRadius: "22px",
                          background: "#fff",
                          boxShadow: "0 10px 30px rgba(0,0,0,0.08)",
                          minHeight: "260px",
                        }}
                        className="h-100"
                      >
                        <Card.Body className="p-4 d-flex flex-column justify-content-between">
                          <div className="d-flex justify-content-between align-items-center mb-4">
                            <div
                              style={{
                                width: "65px",
                                height: "65px",
                                borderRadius: "18px",
                                background: "linear-gradient(135deg,#f59e0b,#f97316)",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                              }}
                            >
                              <img
                                alt="Referral icon"
                                src={royal}
                                style={{ width: "38px", height: "38px" }}
                              />
                            </div>

                            <div
                              style={{
                                fontSize: "38px",
                                fontWeight: "700",
                                color: "#f59e0b",
                              }}
                            >
                              {royalpoints}
                            </div>
                          </div>

                          <div>
                            <h5 style={{ fontWeight: "700", color: "#1f2937" }}>
                              Loyalty Points
                            </h5>
                          </div>
                        </Card.Body>
                      </Card>
                    </Col>

                    {/* Products */}
                    <Col xs={12} sm={6} lg={4} xl={3}>
                      <Card
                        style={{
                          border: "none",
                          borderRadius: "22px",
                          background: "#fff",
                          boxShadow: "0 10px 30px rgba(0,0,0,0.08)",
                          minHeight: "260px",
                        }}
                        className="h-100"
                      >
                        <Card.Body className="p-4 d-flex flex-column justify-content-between">
                          <div className="d-flex justify-content-between align-items-center mb-4">
                            <div
                              style={{
                                width: "65px",
                                height: "65px",
                                borderRadius: "18px",
                                background: "linear-gradient(135deg,#8b5cf6,#7c3aed)",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                              }}
                            >
                              <img
                                alt="Referral icon"
                                src={offer}
                                style={{ width: "38px", height: "38px" }}
                              />
                            </div>

                            <div
                              style={{
                                fontSize: "38px",
                                fontWeight: "700",
                                color: "#7c3aed",
                              }}
                            >
                              {productsCount}
                            </div>
                          </div>

                          <div>
                            <h5 style={{ fontWeight: "700", color: "#1f2937" }}>
                              Products
                            </h5>

                            <p
                              style={{
                                color: "#6b7280",
                                fontSize: "13px",
                                marginBottom: 0,
                              }}
                            >
                              Total Products
                            </p>
                          </div>
                        </Card.Body>
                      </Card>
                    </Col>

                    {/* Referral Sent */}
                    <Col xs={12} sm={6} lg={4} xl={3}>
                      <Card
                        style={{
                          border: "none",
                          borderRadius: "22px",
                          background: "#fff",
                          boxShadow: "0 10px 30px rgba(0,0,0,0.08)",
                          minHeight: "260px",
                        }}
                        className="h-100"
                      >
                        <Card.Body className="p-4 d-flex flex-column justify-content-between">
                          <div className="d-flex justify-content-between align-items-center mb-4">
                            <div
                              style={{
                                width: "65px",
                                height: "65px",
                                borderRadius: "18px",
                                background: "linear-gradient(135deg,#22c55e,#16a34a)",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                              }}
                            >
                              <img
                                alt="Referral icon"
                                src={referralimg}
                                style={{ width: "38px", height: "38px" }}
                              />
                            </div>

                            <div
                              style={{
                                fontSize: "38px",
                                fontWeight: "700",
                                color: "#16a34a",
                              }}
                            >
                              {totalReferrals}
                            </div>
                          </div>

                          <div>
                            <h5 style={{ fontWeight: "700", color: "#1f2937" }}>
                              Referral Sent
                            </h5>
                          </div>
                        </Card.Body>
                      </Card>
                    </Col>

                    {/* Referral Received */}
                    <Col xs={12} sm={6} lg={4} xl={3}>
                      <Card
                        style={{
                          border: "none",
                          borderRadius: "22px",
                          background: "#fff",
                          boxShadow: "0 10px 30px rgba(0,0,0,0.08)",
                          minHeight: "260px",
                        }}
                        className="h-100"
                      >
                        <Card.Body className="p-4 d-flex flex-column justify-content-between">
                          <div className="d-flex justify-content-between align-items-center mb-4">
                            <div
                              style={{
                                width: "65px",
                                height: "65px",
                                borderRadius: "18px",
                                background: "linear-gradient(135deg,#ec4899,#db2777)",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                              }}
                            >
                              <img
                                alt="Referral icon"
                                src={referralimg}
                                style={{ width: "38px", height: "38px" }}
                              />
                            </div>

                            <div
                              style={{
                                fontSize: "38px",
                                fontWeight: "700",
                                color: "#db2777",
                              }}
                            >
                              {totalReferralss}
                            </div>
                          </div>

                          <div>
                            <h5 style={{ fontWeight: "700", color: "#1f2937" }}>
                              Referral Received
                            </h5>
                          </div>
                        </Card.Body>
                      </Card>
                    </Col>

                    {/* Thanks Note */}
                    <Col xs={12} sm={6} lg={4} xl={3}>
                      <Card
                        style={{
                          border: "none",
                          borderRadius: "22px",
                          background: "#fff",
                          boxShadow: "0 10px 30px rgba(0,0,0,0.08)",
                          minHeight: "260px",
                        }}
                        className="h-100"
                      >
                        <Card.Body className="p-4">
                          <div className="text-center mb-4">
                            <div
                              style={{
                                width: "65px",
                                height: "65px",
                                borderRadius: "18px",
                                background: "linear-gradient(135deg,#14b8a6,#0f766e)",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                margin: "0 auto",
                              }}
                            >
                              <img
                                alt="Referral icon"
                                src={handshake}
                                style={{ width: "38px", height: "38px" }}
                              />
                            </div>
                          </div>

                          <h5
                            className="text-center mb-4"
                            style={{ fontWeight: "700", color: "#1f2937" }}
                          >
                            Thanks Note
                          </h5>

                          <div className="d-flex justify-content-between text-center">
                            <div>
                              <h2 style={{ color: "#2563eb", fontWeight: "700" }}>
                                {thanksCount}
                              </h2>

                              <p style={{ fontSize: "13px", color: "#6b7280" }}>
                                Sent thanksNote
                              </p>
                            </div>

                            <div>
                              <h2 style={{ color: "#7c3aed", fontWeight: "700" }}>
                                {MythanksCount}
                              </h2>

                              <p style={{ fontSize: "13px", color: "#6b7280" }}>
                                Received thanksNote
                              </p>
                            </div>
                          </div>
                        </Card.Body>
                      </Card>
                    </Col>

                    {/* Meeting Calendar */}
                    <Col xs={12} sm={6} lg={4} xl={3}>
                      <Card
                        style={{
                          border: "none",
                          borderRadius: "22px",
                          background: "#fff",
                          boxShadow: "0 10px 30px rgba(0,0,0,0.08)",
                          minHeight: "260px",
                        }}
                        className="h-100"
                      >
                        <Card.Body className="p-4">
                          <div className="d-flex justify-content-between align-items-center mb-4">
                            <div
                              style={{
                                width: "65px",
                                height: "65px",
                                borderRadius: "18px",
                                background: "linear-gradient(135deg,#ef4444,#dc2626)",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                              }}
                            >
                              <img
                                alt="Referral icon"
                                src={appointment}
                                style={{ width: "38px", height: "38px" }}
                              />
                            </div>

                            <div
                              style={{
                                fontSize: "38px",
                                fontWeight: "700",
                                color: "#dc2626",
                              }}
                            >
                              {meetingsCount}
                            </div>
                          </div>

                          <h5 style={{ fontWeight: "700", color: "#1f2937" }}>
                            Meeting Calendar
                          </h5>

                          <p style={{ fontSize: "13px", color: "#6b7280" }}>
                            UpComing Meeting
                          </p>

                          <div className="d-flex gap-3 mt-3">
                            <span style={{ color: "green", fontSize: "13px" }}>
                              ✔ {yescount} Accepted
                            </span>

                            <span style={{ color: "red", fontSize: "13px" }}>
                              ✖ {nocount} Rejected
                            </span>
                          </div>
                        </Card.Body>
                      </Card>
                    </Col>

                    {/* Event Calendar */}
                    <Col xs={12} sm={6} lg={4} xl={3}>
                      <Card
                        style={{
                          border: "none",
                          borderRadius: "22px",
                          background: "#fff",
                          boxShadow: "0 10px 30px rgba(0,0,0,0.08)",
                          minHeight: "260px",
                        }}
                        className="h-100"
                      >
                        <Card.Body className="p-4 d-flex flex-column justify-content-between">
                          <div className="d-flex justify-content-between align-items-center mb-4">
                            <div
                              style={{
                                width: "65px",
                                height: "65px",
                                borderRadius: "18px",
                                background: "linear-gradient(135deg,#06b6d4,#0891b2)",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                              }}
                            >
                              <img
                                alt="Referral icon"
                                src={eventlist}
                                style={{ width: "38px", height: "38px" }}
                              />
                            </div>

                            <div
                              style={{
                                fontSize: "38px",
                                fontWeight: "700",
                                color: "#0891b2",
                              }}
                            >
                              {eventCount}
                            </div>
                          </div>

                          <div>
                            <h5 style={{ fontWeight: "700", color: "#1f2937" }}>
                              Event Calendar
                            </h5>

                            <p style={{ fontSize: "13px", color: "#6b7280" }}>
                              UpComing Events
                            </p>
                          </div>
                        </Card.Body>
                      </Card>
                    </Col>

                    {/* B-B */}
                    <Col xs={12} sm={6} lg={4} xl={3}>
                      <Card
                        style={{
                          border: "none",
                          borderRadius: "22px",
                          background: "#fff",
                          boxShadow: "0 10px 30px rgba(0,0,0,0.08)",
                          minHeight: "260px",
                        }}
                        className="h-100"
                      >
                        <Card.Body className="p-4 d-flex flex-column justify-content-between">
                          <div className="d-flex justify-content-between align-items-center mb-4">
                            <div
                              style={{
                                width: "65px",
                                height: "65px",
                                borderRadius: "18px",
                                background: "linear-gradient(135deg,#f59e0b,#d97706)",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                              }}
                            >
                              <img
                                alt="Referral icon"
                                src={A1}
                                style={{ width: "38px", height: "38px" }}
                              />
                            </div>

                            <div
                              style={{
                                fontSize: "38px",
                                fontWeight: "700",
                                color: "#d97706",
                              }}
                            >
                              {totalInvitation}
                            </div>
                          </div>

                          <div>
                            <h5 style={{ fontWeight: "700", color: "#1f2937" }}>
                              B - B
                            </h5>
                          </div>
                        </Card.Body>
                      </Card>
                    </Col>

                    {/* Visitor Invite */}
                    <Col xs={12} sm={6} lg={4} xl={3}>
                      <Card
                        style={{
                          border: "none",
                          borderRadius: "22px",
                          background: "#fff",
                          boxShadow: "0 10px 30px rgba(0,0,0,0.08)",
                          minHeight: "260px",
                        }}
                        className="h-100"
                      >
                        <Card.Body className="p-4 d-flex flex-column justify-content-between">
                          <div className="d-flex justify-content-between align-items-center mb-4">
                            <div
                              style={{
                                width: "65px",
                                height: "65px",
                                borderRadius: "18px",
                                background: "linear-gradient(135deg,#84cc16,#65a30d)",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                              }}
                            >
                              <img
                                alt="Referral icon"
                                src={A2}
                                style={{ width: "38px", height: "38px" }}
                              />
                            </div>

                            <div
                              style={{
                                fontSize: "38px",
                                fontWeight: "700",
                                color: "#65a30d",
                              }}
                            >
                              {invitecount}
                            </div>
                          </div>

                          <div>
                            <h5 style={{ fontWeight: "700", color: "#1f2937" }}>
                              Visitor Invite
                            </h5>
                          </div>
                        </Card.Body>
                      </Card>
                    </Col>

                    {/* Visitor Event Invite */}
                    <Col xs={12} sm={6} lg={4} xl={3}>
                      <Card
                        style={{
                          border: "none",
                          borderRadius: "22px",
                          background: "#fff",
                          boxShadow: "0 10px 30px rgba(0,0,0,0.08)",
                          minHeight: "260px",
                        }}
                        className="h-100"
                      >
                        <Card.Body className="p-4 d-flex flex-column justify-content-between">
                          <div className="d-flex justify-content-between align-items-center mb-4">
                            <div
                              style={{
                                width: "65px",
                                height: "65px",
                                borderRadius: "18px",
                                background: "linear-gradient(135deg,#f43f5e,#e11d48)",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                              }}
                            >
                              <img
                                alt="Referral icon"
                                src={A2}
                                style={{ width: "38px", height: "38px" }}
                              />
                            </div>

                            <div
                              style={{
                                fontSize: "38px",
                                fontWeight: "700",
                                color: "#e11d48",
                              }}
                            >
                              {invitecount_event}
                            </div>
                          </div>

                          <div>
                            <h5 style={{ fontWeight: "700", color: "#1f2937" }}>
                              Visitor Event Invite
                            </h5>
                          </div>
                        </Card.Body>
                      </Card>
                    </Col>

                  </Row>
                </div>
              </div>
            )}

            <Modal
              isOpen={showModalC}
              onRequestClose={handleModalClose}
              contentLabel="Referral Members"
              style={{
                content: {
                  top: "50%",
                  left: "50%",
                  right: "auto",
                  bottom: "auto",
                  marginRight: "-50%",
                  transform: "translate(-50%, -50%)",
                  width: "600px",
                  maxHeight: "80vh",
                  overflowY: "auto",
                  borderRadius: "20px",
                  border: "none",
                  padding: "25px",
                },
                overlay: {
                  backgroundColor: "rgba(0,0,0,0.5)",
                  zIndex: 999,
                },
              }}
            >
              <h2
                style={{
                  fontWeight: "700",
                  marginBottom: "20px",
                  color: "#1f2937",
                }}
              >
                Your Referred Members
              </h2>

              <Button
                variant="danger"
                onClick={handleModalClose}
                className="mb-3 float-end"
                style={{
                  borderRadius: "10px",
                  padding: "8px 20px",
                }}
              >
                Close
              </Button>

              {referralMembers.length > 0 ? (
                <ul style={{ paddingLeft: "20px" }}>
                  {referralMembers.map((member) => (
                    <li
                      key={member.id}
                      style={{
                        marginBottom: "12px",
                        fontSize: "15px",
                        color: "#374151",
                      }}
                    >
                      <strong>{member.name}</strong> – {member.email}
                    </li>
                  ))}
                </ul>
              ) : (
                <p>No referral members found.</p>
              )}
            </Modal>
          </>
          {activeSection === "profile" && (
            <div>
              <h2 className="section-title">
                Lions Business Network- Multiple District 320
              </h2>
              <div style={{ textAlign: 'right', margin: '10px' }}>
                <button onClick={openModalProfile}>Update Profile</button>
              </div>
              <div className="cardd-row">
                <div className="cardd">
                  <div className="cardd-content">
                    <p className="cardd-header">Basic Information</p>
                    <div className="profile-img">
                      <img alt={`Profile picture of ${users.name}`} height="100" src={users.logo} width="100" style={{ borderRadius: "50%", border: "2px solid #007bff", objectFit: "contain", }} />
                    </div>
                    <div className="info-item">
                      <FaIdBadge />
                      <span>Membership No:</span>{" "}
                      <span className="value">{users.membershipNo}</span>
                    </div>
                    <div className="info-item">
                      <FaUser />
                      <span>Name:</span>{" "}
                      <span className="value">{users.name}</span>
                    </div>
                    <div className="info-item">
                      <FaPhone />
                      <span>Mobile:</span>{" "}
                      <span className="value">{users.mobile}</span>
                    </div>
                    <div className="info-item">
                      <FaEnvelope />
                      <span>Email:</span>{" "}
                      <span className="value">{users.email}</span>
                    </div>
                    <div className="info-item">
                      <FaEnvelope />
                      <span>Business Vertical:</span>{" "}
                      <span className="value">{users.businessVerticalData}</span>
                    </div>
                    <div className="info-item">
                      <FaEnvelope />
                      <span>Location:</span>{" "}
                      <span className="value">{users.state}, {users.city}</span>
                    </div>
                    <div className="social-icons">
                      <a href="#">
                        <FaInstagram />
                      </a>
                      <a href="#">
                        <FaTwitter />
                      </a>
                      <a href="#">
                        <FaFacebook />
                      </a>
                    </div>
                  </div>
                </div>

                {/* <div className="cardd lions-card">
                    <div className="cardd-content lions-info">
                      <h4 className="cardd-header">Lions Information</h4>
                      <img
                        alt="Lions Club logo"
                        height="50"
                        src="https://storage.googleapis.com/a1aa/image/YwjE65g8qNJhNJQMAd051OqriYttZzb6ZPeytedxMaknar7TA.jpg"
                        width="50"
                      />
                      <p>
                        You are not a lions member so you have not added lion
                        data.
                      </p>
                      <button className="add-button">
                        <FaPlus />
                        ADD
                      </button>
                    </div>
                  </div> */}

                <div className="cardd">
                  <div className="cardd-content">
                    <p className="cardd-header">Business Information</p>
                    <div className="info-item">
                      <FaBuilding />
                      <span>Name Of Company:</span>{" "}
                      <span className="value">{users.name_of_company}</span>
                    </div>
                    <div className="info-item">
                      <FaBriefcase />
                      <span>Designation:</span>{" "}
                      <span className="value">{users.designation}</span>
                    </div>
                    <div className="info-item">
                      <FaGlobe />
                      <span>Website:</span>
                      <span> <a
                        href={users.website}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        {users.website}
                      </a></span>
                    </div>
                    <div className="info-item">
                      <FaEnvelope />
                      <span>Email Id:</span>{" "}
                      <span className="value">{users.official_email_id}</span>
                    </div>
                    <div className="info-item">
                      <FaBox />
                      <span>Product:</span>{" "}
                      <span className="value">{users.product}</span>
                    </div>
                    {/* <div className="info-item">
                      <FaIndustry />
                      <span> Business/Profession:</span>{" "}
                      <span className="value">
                        {users.businessProfession}
                      </span>
                    </div> */}
                    <div className="info-item">
                      <FaIndustry />
                      <span>GST:</span>{" "}
                      <span className="value">
                        {/* {users.Gst_No} */}
                        {maskGST(users.Gst_No)}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}

          {isModalOpenProfile && (
            <div className="modal-overlay" style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(0, 0, 0, 0.5)', display: 'flex', justifyContent: 'center', alignItems: 'center', }}>
              <div className="modal-content" style={{ backgroundColor: 'white', width: '80%', maxWidth: '800px', padding: '20px', borderRadius: '8px', textAlign: 'center', }}>
                <div className="carddd">
                  <form onSubmit={handleSubmit} className="business-form" style={{ display: 'flex', flexWrap: 'wrap' }}>
                    <div className="form-group" style={{ flex: '1 1 45%', margin: '10px' }}>
                      <label htmlFor="name_of_company">Name of Company:</label>
                      <input
                        type="text"
                        name="name_of_company"
                        readOnly
                        value={formData.name_of_company}
                        onChange={handleInputChange}
                        placeholder="Enter Your Company Name"
                        style={{ width: '100%', padding: '8px', marginBottom: '10px', borderRadius: '4px', border: '1px solid #ccc', }} />
                    </div>
                    <div className="form-group" style={{ flex: '1 1 45%', margin: '10px' }}>
                      <label htmlFor="designation">Designation:</label>
                      <input
                        type="text"
                        name="designation"
                        value={formData.designation}
                        onChange={handleInputChange}
                        placeholder="Enter your Designation"
                        style={{ width: '100%', padding: '8px', marginBottom: '10px', borderRadius: '4px', border: '1px solid #ccc', }} />
                    </div>
                    <div className="form-group" style={{ flex: '1 1 45%', margin: '10px' }}>
                      <label htmlFor="joined_year">Joined Year in Lions Clubs :</label>
                      <input
                        type="number"
                        name="joined_year"
                        value={formData.joined_year}
                        onChange={handleInputChange}
                        placeholder="Joined Year"
                        style={{ width: '100%', padding: '8px', marginBottom: '10px', borderRadius: '4px', border: '1px solid #ccc', }} />
                    </div>
                    <div className="form-group" style={{ flex: '1 1 45%', margin: '10px' }}>
                      <label htmlFor="position">Highest Position Served:</label>
                      <input
                        type="text"
                        name="position"
                        value={formData.position}
                        onChange={handleInputChange}
                        placeholder="Position"
                        style={{ width: '100%', padding: '8px', marginBottom: '10px', borderRadius: '4px', border: '1px solid #ccc', }} />
                    </div>
                    <div className="form-group" style={{ flex: '1 1 45%', margin: '10px' }}>
                      <label htmlFor="year">Year of Establishment of Company:</label>
                      <input
                        type="text"
                        name="year"
                        value={formData.year}
                        onChange={handleInputChange}
                        placeholder="Year"
                        style={{ width: '100%', padding: '8px', marginBottom: '10px', borderRadius: '4px', border: '1px solid #ccc', }} />
                    </div>
                    <div className="form-group" style={{ flex: '1 1 45%', margin: '10px' }}>
                      <label htmlFor="website">Website:</label>
                      <input
                        // type="url"
                        type="text"
                        pattern="(https?:\/\/)?(www\.)?[a-zA-Z0-9\-\.]+\.[a-zA-Z]{2,}\/?.*"
                        // pattern="https?://.*|www\..*"
                        name="website"
                        value={formData.website}
                        onChange={handleInputChange}
                        placeholder="Enter your WebSite"
                        style={{ width: '100%', padding: '8px', marginBottom: '10px', borderRadius: '4px', border: '1px solid #ccc', }} />
                    </div>
                    <div className="form-group" style={{ flex: '1 1 45%', margin: '10px' }}>
                      <label htmlFor="official_email_id">Official Email ID:</label>
                      <input
                        type="email"
                        name="official_email_id"
                        value={formData.official_email_id}
                        onChange={handleInputChange}
                        placeholder="Enter your Official Email ID"
                        style={{ width: '100%', padding: '8px', marginBottom: '10px', borderRadius: '4px', border: '1px solid #ccc', }} />
                    </div>
                    {/* <div className="form-group" style={{ flex: '1 1 45%', margin: '10px' }}>
                      <label htmlFor="product">Product:</label>
                      <input
                        type="text"
                        name="product"
                        value={formData.product}
                        onChange={handleInputChange}
                        placeholder="Enter your Product Name"
                        style={{ width: '100%', padding: '8px', marginBottom: '10px', borderRadius: '4px', border: '1px solid #ccc', }} />
                    </div>
                    <div className="form-group" style={{ flex: '1 1 45%', margin: '10px' }}>
                      <label htmlFor="businessProfession">Business Profession:</label>
                      <input
                        type="text"
                        name="businessProfession"
                        placeholder="Enter your Business Profession"
                        value={formData.businessProfession}
                        onChange={handleInputChange}
                        style={{ width: '100%', padding: '8px', marginBottom: '10px', borderRadius: '4px', border: '1px solid #ccc', }} />
                    </div> */}
                    <div className="form-group" style={{ flex: '1 1 45%', margin: '10px' }}>
                      <label htmlFor="logo">Your Profile Photo:</label>
                      <input
                        type="file"
                        name="logo"
                        accept="image/*"
                        onChange={handleFileChange}
                        style={{ width: '100%', padding: '8px', marginBottom: '10px', borderRadius: '4px', border: '1px solid #ccc', }} />
                    </div>

                    <div className="container" style={{ display: 'flex', alignItems: 'center', gap: '10px', flexWrap: 'wrap' }}>
                      {/* GST Input Section */}
                      {/* <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                        <div style={{ position: 'relative', width: '200px' }}>
                          <input
                            type="text"
                            name="Gst_No"
                            placeholder="Enter GST Number"
                            value={Gst_No}
                            onChange={handleInputChange}
                            style={{ padding: '8px', width: '100%' }}
                          />
                          {gstStatus !== null && (
                            <span
                              style={{
                                position: 'absolute',
                                right: '10px',
                                top: '50%',
                                transform: 'translateY(-50%)',
                                color: gstStatus ? 'green' : 'red',
                              }}
                            >
                              {gstStatus ? '✓' : '✘'}
                            </span>
                          )}
                        </div>
                        <button
                          type="button"
                          style={{ padding: '8px 12px', backgroundColor: '#4CAF50', color: 'white', border: 'none', cursor: 'pointer' }}
                          onClick={verifyGstin}
                        >
                          Verify GST
                        </button>
                      </div> */}
                      <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                        <div style={{ position: 'relative', width: '200px' }}>
                          <input
                            type="text"
                            name="Gst_No"
                            placeholder="Enter GST Number"
                            // value={Gst_No}
                            value={users?.gst_verify === 1 ? users?.Gst_No : Gst_No}

                            onChange={handleInputChange}
                            style={{ padding: '8px', width: '100%' }}
                            disabled={users?.gst_verify === 1}
                          />
                          {gstStatus !== null && (
                            <span
                              style={{
                                position: 'absolute',
                                right: '10px',
                                top: '50%',
                                transform: 'translateY(-50%)',
                                color: gstStatus ? 'green' : 'red',
                              }}
                            >
                              {gstStatus ? '✓' : '✘'}
                            </span>
                          )}
                        </div>

                        {users?.gst_verify === 1 ? (
                          <span style={{ color: 'green', fontWeight: 'bold' }}>    ✓ GST is verified</span>
                        ) : (
                          <button
                            type="button"
                            style={{
                              padding: '8px 12px',
                              backgroundColor: '#4CAF50',
                              color: 'white',
                              border: 'none',
                              cursor: 'pointer',
                            }}
                            onClick={verifyGstin}
                          >
                            Verify GST
                          </button>
                        )}
                      </div>


                      {/* Aadhaar Input Section */}
                      {/* <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                        {!isOtpSent && !isOtpVerified && (
                          <div style={{ position: 'relative', width: '200px' }}>
                            <input
                              type="text"
                              name="Aadhar_No"
                              placeholder="Enter Aadhaar Number"
                              value={Aadhar_No}
                              onChange={handleInputChangev}
                              style={{ padding: '8px', width: '100%' }}
                            />
                          </div>
                        )}

                        {isOtpSent && !isOtpVerified && (
                          <div style={{ position: 'relative', width: '200px' }}>
                            <input
                              type="text"
                              name="OTP"
                              placeholder="Enter OTP"
                              value={OTP}
                              onChange={handleInputChangev}
                              style={{ padding: '8px', width: '100%' }}
                            />
                          </div>
                        )}

                        <div>
                          {!isOtpSent && !isOtpVerified && (
                            <button
                              type="button"
                              style={{ padding: '8px 12px', backgroundColor: '#4CAF50', color: 'white', border: 'none', cursor: 'pointer' }}
                              onClick={sendOtp}
                            >
                              Send OTP
                            </button>
                          )}

                          {isOtpSent && !isOtpVerified && (
                            <button
                              type="button"
                              style={{ padding: '8px 12px', backgroundColor: '#4CAF50', color: 'white', border: 'none', cursor: 'pointer' }}
                              onClick={verifyOtp}
                            >
                              Verify OTP
                            </button>
                          )}

                          {isOtpVerified && (
                            <button
                              type="button"
                              style={{ padding: '8px 12px', backgroundColor: '#4CAF50', color: 'white', border: 'none', cursor: 'pointer' }}
                              onClick={resetProcess}
                            >
                              Reset
                            </button>
                          )}
                        </div>

                        {isOtpVerified && <div style={{ color: 'green' }}>OTP Verified Successfully!</div>}
                        {error && <div style={{ color: 'red' }}>{error}</div>}
                      </div> */}
                      <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                        {users?.aadhaar_verify === 1 ? (
                          <>
                            <div style={{ position: 'relative', width: '200px' }}>
                              {/* <input
          type="text"
          name="Aadhar_No"
          placeholder="Aadhaar Verified"
          value={Aadhar_No}
          style={{ padding: '8px', width: '100%' }}
          disabled
        /> */}
                              <span
                                style={{
                                  position: 'absolute',
                                  right: '10px',
                                  top: '50%',
                                  transform: 'translateY(-50%)',
                                  color: 'green',
                                }}
                              >

                              </span>
                            </div>
                            <span style={{ color: 'green', fontWeight: 'bold' }}>    ✓ Aadhaar is verified</span>
                          </>
                        ) : (
                          <>
                            {!isOtpSent && !isOtpVerified && (
                              <div style={{ position: 'relative', width: '200px' }}>
                                <input
                                  type="text"
                                  name="Aadhar_No"
                                  placeholder="Enter Aadhaar Number"
                                  value={Aadhar_No}
                                  onChange={handleInputChangev}
                                  style={{ padding: '8px', width: '100%' }}
                                />
                              </div>
                            )}

                            {isOtpSent && !isOtpVerified && (
                              <div style={{ position: 'relative', width: '200px' }}>
                                <input
                                  type="text"
                                  name="OTP"
                                  placeholder="Enter OTP"
                                  value={OTP}
                                  onChange={handleInputChangev}
                                  style={{ padding: '8px', width: '100%' }}
                                />
                              </div>
                            )}

                            <div>
                              {!isOtpSent && !isOtpVerified && (
                                <button
                                  type="button"
                                  style={{ padding: '8px 12px', backgroundColor: '#4CAF50', color: 'white', border: 'none', cursor: 'pointer' }}
                                  onClick={sendOtp}
                                >
                                  Send OTP
                                </button>
                              )}

                              {isOtpSent && !isOtpVerified && (
                                <button
                                  type="button"
                                  style={{ padding: '8px 12px', backgroundColor: '#4CAF50', color: 'white', border: 'none', cursor: 'pointer' }}
                                  onClick={verifyOtp}
                                >
                                  Verify OTP
                                </button>
                              )}

                              {isOtpVerified && (
                                <button
                                  type="button"
                                  style={{ padding: '8px 12px', backgroundColor: '#4CAF50', color: 'white', border: 'none', cursor: 'pointer' }}
                                  onClick={resetProcess}
                                >
                                  Reset
                                </button>
                              )}
                            </div>

                            {isOtpVerified && <div style={{ color: 'green' }}>OTP Verified Successfully!</div>}
                            {error && <div style={{ color: 'red' }}>{error}</div>}
                          </>
                        )}
                      </div>

                    </div>

                    <button type="submit" className="submit-btn mt-3" style={{ padding: '10px 20px', backgroundColor: '#007BFF', color: '#fff', border: 'none', borderRadius: '4px', cursor: 'pointer', width: '100%', marginBottom: '10px', }}>Submit</button>
                  </form>
                </div>

                <button onClick={closeModalProfile} style={{ marginTop: '20px', padding: '10px 20px', backgroundColor: '#FF5733', color: '#fff', border: 'none', borderRadius: '4px', cursor: 'pointer', }}>Close</button>
              </div>
            </div>
          )}

          {activeSection === "products" && (
            <div
              style={{
                minHeight: "100vh",
                background: "linear-gradient(to bottom right, #f8fafc, #e0f2fe)",
                paddingBottom: "40px",
              }}
            >
              {/* Header Section */}
              <div
                style={{
                  background: "linear-gradient(to right, #1e3a8a, #1e40af)",
                  padding: "45px 20px",
                  color: "#fff",
                  borderBottomLeftRadius: "25px",
                  borderBottomRightRadius: "25px",
                  marginBottom: "25px",
                }}
              >
                <div
                  style={{
                    maxWidth: "1300px",
                    margin: "auto",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    flexWrap: "wrap",
                    gap: "20px",
                  }}
                >
                  <div>
                    <h1
                      style={{
                        fontSize: "38px",
                        fontWeight: "700",
                        marginBottom: "8px",
                      }}
                    >
                      Products & Services
                    </h1>

                    <p
                      style={{
                        fontSize: "16px",
                        opacity: "0.9",
                      }}
                    >
                      Browse and manage business products from our network
                    </p>
                  </div>

                  <button
                    onClick={() => {
                      if (users.gst_verify === 1 && users.aadhaar_verify === 1) {
                        openModal();
                      } else {
                        alert(
                          "Please fill your KYC details in your profile GST & Aadhaar (click on Update Profile)."
                        );
                        setActiveSection("profile");
                      }
                    }}
                    disabled={productsCount >= 5}
                    style={{
                      background: "linear-gradient(to right, #fbbf24, #f59e0b)",
                      color: "#fff",
                      border: "none",
                      padding: "12px 24px",
                      borderRadius: "40px",
                      fontWeight: "600",
                      display: "flex",
                      alignItems: "center",
                      gap: "10px",
                      cursor: productsCount >= 5 ? "not-allowed" : "pointer",
                      opacity: productsCount >= 5 ? 0.5 : 1,
                      boxShadow: "0px 10px 20px rgba(0,0,0,0.12)",
                    }}
                  >
                    <FaPlus />
                    Add Products
                  </button>
                </div>
              </div>

              <div
                style={{
                  maxWidth: "1300px",
                  margin: "auto",
                  padding: "0px 20px",
                }}
              >
                {/* My Products */}
                <h2
                  style={{
                    fontSize: "28px",
                    fontWeight: "700",
                    color: "#1e293b",
                    marginBottom: "20px",
                  }}
                >
                  My Products
                </h2>

                <div
                  style={{
                    display: "grid",
                    // gridTemplateColumns: "repeat(auto-fit,minmax(250px,1fr))",
                    // gap: "18px",
                    gridTemplateColumns: "repeat(auto-fit,minmax(220px,1fr))",
                    gap: "12px",
                    marginBottom: "45px",
                  }}
                >
                  {products.map((product) => {
                    const productRatings = product.ratings || [];
                    const productAverageRating =
                      calculateAverageRating(productRatings);

                    const formatDate = (dateStr) => {
                      if (!dateStr) return "Not Given";

                      let date = new Date(dateStr);
                      if (date.toString() === "Invalid Date")
                        return "Not Given";

                      let day = String(date.getDate()).padStart(2, "0");
                      let month = String(date.getMonth() + 1).padStart(2, "0");
                      let year = date.getFullYear();

                      return `${day}-${month}-${year}`;
                    };

                    return (
                      <div
                        key={product.id}
                        style={{
                          background: "#fff",
                          // borderRadius: "18px",
                          // overflow: "hidden",
                          // boxShadow: "0 8px 20px rgba(0,0,0,0.08)",
                          // transition: "0.3s",
                          // position: "relative",
                          borderRadius: "12px",
overflow: "hidden",
boxShadow: "0 2px 10px rgba(0,0,0,0.08)",
transition: "0.3s",
position: "relative",
paddingBottom: "8px",
                        }}
                      >
                        <div style={{ position: "relative" }}>
                          {/* {product.productPhoto ? (
                            <img
                              src={product.productPhoto}
                              alt={product.productName}
                              style={{
                                width: "100%",
                                height: "180px",
                                objectFit: "cover",
                              }}
                            />
                          ) : (
                            <div
                              style={{
                                width: "100%",
                                height: "180px",
                                background: "#e2e8f0",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                color: "#475569",
                                fontWeight: "600",
                                fontSize: "18px",
                              }}
                            >
                              No Image
                            </div>
                          )} */}

                          <div
  style={{
    width: "100%",
    height: "140px",
    background: "#f1f5f9",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    overflow: "hidden",
  }}
>
  <img
    src={product.productPhoto}
    alt={product.productName}
    onError={(e) => {
      e.target.style.display = "none";
      e.target.nextSibling.style.display = "flex";
    }}
    style={{
      width: "100%",
      height: "100%",
      objectFit: "contain",
    }}
  />

  <div
    style={{
      width: "100%",
      height: "100%",
      display: "none",
      alignItems: "center",
      justifyContent: "center",
      color: "#64748b",
      fontWeight: "600",
      fontSize: "16px",
      background: "#e2e8f0",
    }}
  >
    No Image
  </div>
</div>

                          <div
                            style={{
                              position: "absolute",
                              top: "12px",
                              right: "12px",
                              background: "rgba(0,0,0,0.7)",
                              color: "#fff",
                              padding: "5px 12px",
                              borderRadius: "20px",
                              fontSize: "13px",
                              fontWeight: "600",
                            }}
                          >
                            ₹ {product.productPrice}
                          </div>
                        </div>

                        <div style={{ padding: "12px" }}>
                          <h3
                            style={{
                              fontSize: "16px",
                              fontWeight: "700",
                              color: "#1e293b",
                              marginBottom: "6px",
                              textTransform: "uppercase",
                            }}
                          >
                            {product.productName}
                          </h3>

                          <>
                            {!expanded ? (
                              <p
                                style={{
                                  color: "#64748b",
                                  // lineHeight: "1.5",
                                  fontSize: "14px",
                                }}
                              >
                                {product.productDesc.length > 80
                                  ? `${product.productDesc.substring(0, 80)}... `
                                  : product.productDesc}

                                {product.productDesc.length > 80 && (
                                  <span
                                    style={{
                                      color: "#2563eb",
                                      cursor: "pointer",
                                      fontWeight: "600",
                                    }}
                                    onClick={toggleExpanded}
                                  >
                                    more
                                  </span>
                                )}
                              </p>
                            ) : (
                              <div
                                style={{
                                  maxHeight: "120px",
                                  overflowY: "auto",
                                  padding: "8px",
                                  borderRadius: "8px",
                                  background: "#f1f5f9",
                                  color: "#334155",
                                  // lineHeight: "1.5",
                                  fontSize: "13px",
                                }}
                              >
                                {product.productDesc}

                                <div>
                                  <span
                                    style={{
                                      color: "#2563eb",
                                      cursor: "pointer",
                                      fontWeight: "600",
                                    }}
                                    onClick={toggleExpanded}
                                  >
                                    ...less
                                  </span>
                                </div>
                              </div>
                            )}
                          </>

                          <div style={{ marginTop: "14px" }}>
                            <p
                              style={{
                                color: isExpiredd(product.validity)
                                  ? "red"
                                  : "#0f766e",
                                fontWeight: "600",
                                fontSize: "14px",
                              }}
                            >
                              Offer :{" "}
                              {product.offer
                                ? `${product.offer}%`
                                : "No offer available"}{" "}
                              {isExpiredd(product.validity) &&
                                "(Expired!)"}
                            </p>

                            <p
                              style={{
                                color: isExpiredd(product.validity)
                                  ? "red"
                                  : "#475569",
                                marginTop: "6px",
                                fontWeight: "500",
                                fontSize: "14px",
                              }}
                            >
                              Validity : {formatDate(product.validity)}{" "}
                              {isExpiredd(product.validity) &&
                                "(Expired!)"}
                            </p>

                            <div
                              style={{
                                marginTop: "8px",
                                fontSize: "14px",
                                fontWeight: "600",
                              }}
                            >
                              {renderStars(productAverageRating)} (
                              {productAverageRating.toFixed(1)})
                            </div>
                          </div>

                          <div
                            style={{
                              display: "flex",
                              gap: "10px",
                              marginTop: "16px",
                            }}
                          >
                            <button
                              className="edit-btn"
                              onClick={() => editProduct(product)}
                              style={{
                                flex: 1,
                                border: "none",
                                padding: "8px",
                                borderRadius: "8px",
                                background:
                                  "linear-gradient(to right,#2563eb,#1d4ed8)",
                                color: "#fff",
                                fontWeight: "600",
                                fontSize: "13px",
                              }}
                            >
                              Edit
                            </button>

                            <button
                              className="delete-btn"
                              onClick={() => deleteProduct(product.id)}
                              style={{
                                flex: 1,
                                border: "none",
                                padding: "8px",
                                borderRadius: "8px",
                                background:
                                  "linear-gradient(to right,#ef4444,#dc2626)",
                                color: "#fff",
                                fontWeight: "600",
                                fontSize: "13px",
                              }}
                            >
                              Delete
                            </button>
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>

                {/* All Products */}
                <h2
                  style={{
                    fontSize: "28px",
                    fontWeight: "700",
                    color: "#1e293b",
                    marginBottom: "18px",
                  }}
                >
                  All Products
                </h2>

                {/* Search Bar */}
                <div
                  style={{
                    marginBottom: "30px",
                    display: "flex",
                    justifyContent: "center",
                  }}
                >
                  <div
                    style={{
                      // width: "100%",
                      // maxWidth: "500px",
                      // background: "#fff",
                      // borderRadius: "50px",
                      // padding: "12px 18px",
                      display: "flex",
                      alignItems: "center",
                      gap: "12px",
                      // boxShadow: "0 6px 18px rgba(0,0,0,0.08)",
                      // border: "1px solid #e2e8f0",
                    }}
                  >
                    <FaSearch
                      style={{
                        color: "#64748b",
                        fontSize: "17px",
                      }}
                    />

                    <input
                      type="text"
                      placeholder="Search products here..."
                      value={searchTerm}
                      onChange={(e) => setSearchTerm(e.target.value)}
                      style={{
                        border: "none",
                        outline: "none",
                        flex: 1,
                        fontSize: "15px",
                        background: "transparent",
                        color: "#1e293b",
                      }}
                    />
                  </div>
                </div>


                

                <div
                  style={{
                    display: "grid",
                    // gridTemplateColumns: "repeat(auto-fit,minmax(250px,1fr))",
                    // gap: "18px",
                    gridTemplateColumns: "repeat(auto-fit,minmax(220px,1fr))",
gap: "12px",
                  }}
                >
                  {filteredProducts.map((product) => {
                    const productRatings = product.ratings || [];
                    const productAverageRating =
                      calculateAverageRating(productRatings);

                    const formatDate = (dateStr) => {
                      if (!dateStr) return "Not Given";

                      let date = new Date(dateStr);
                      if (date.toString() === "Invalid Date")
                        return "Not Given";

                      let day = String(date.getDate()).padStart(2, "0");
                      let month = String(date.getMonth() + 1).padStart(2, "0");
                      let year = date.getFullYear();

                      return `${day}-${month}-${year}`;
                    };

                    return (
                      <div
                        key={product.id}
                        style={{
                          background: "#fff",
                          borderRadius: "18px",
                          overflow: "hidden",
                          boxShadow: "0 8px 20px rgba(0,0,0,0.08)",
                        }}
                      >
                        <div style={{ position: "relative" }}>
                          {/* {product.productPhoto ? (
                            <img
                              src={product.productPhoto}
                              alt={product.productName}
                              style={{
                                width: "100%",
                                height: "180px",
                                objectFit: "contain",
                              }}
                            />
                          ) : (
                            <div
                              style={{
                                width: "100%",
                                height: "180px",
                                background: "#e2e8f0",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                color: "#475569",
                                fontWeight: "600",
                                fontSize: "18px",
                              }}
                            >
                              No Image
                            </div>
                          )} */}
                          <div
  style={{
    width: "100%",
    height: "140px",
    background: "#f1f5f9",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    overflow: "hidden",
  }}
>
  <img
    src={product.productPhoto}
    alt={product.productName}
    onError={(e) => {
      e.target.style.display = "none";
      e.target.nextSibling.style.display = "flex";
    }}
    style={{
      width: "100%",
      height: "100%",
      objectFit: "contain",
    }}
  />

  <div
    style={{
      width: "100%",
      height: "100%",
      display: "none",
      alignItems: "center",
      justifyContent: "center",
      color: "#64748b",
      fontWeight: "600",
      fontSize: "16px",
      background: "#e2e8f0",
    }}
  >
    No Image
  </div>
</div>

                          <div
                            style={{
                              position: "absolute",
                              top: "12px",
                              right: "12px",
                              background: "#1e293b",
                              color: "#fff",
                              padding: "5px 12px",
                              borderRadius: "20px",
                              fontSize: "13px",
                              fontWeight: "600",
                            }}
                          >
                            ₹ {product.productPrice}
                          </div>
                        </div>

                        <div style={{ padding: "12px" }}>
                          <h3
                            style={{
                              fontSize: "15px",
                              fontWeight: "700",
                              color: "#1e293b",
                              marginBottom: "15px",
                              textTransform: "uppercase",
                            }}
                          >
                            {product.productName}
                          </h3>

                          <>
                            {!expanded ? (
                              <p
                                style={{
                                  color: "#64748b",
                                  fontSize: "14px",
                                  // lineHeight: "1.5",
                                }}
                              >
                                {product.productDesc.length > 25
                                  ? `${product.productDesc.substring(0, 25)}... `
                                  : product.productDesc}

                                {product.productDesc.length > 25 && (
                                  <span
                                    style={{
                                      color: "#2563eb",
                                      cursor: "pointer",
                                      fontWeight: "600",
                                    }}
                                    onClick={toggleExpanded}
                                  >
                                    more
                                  </span>
                                )}
                              </p>
                            ) : (
                              <div
                                style={{
                                  maxHeight: "120px",
                                  overflowY: "auto",
                                  padding: "8px",
                                  borderRadius: "8px",
                                  background: "#f1f5f9",
                                  color: "#334155",
                                  fontSize: "13px",
                                }}
                              >
                                {product.productDesc}

                                <div>
                                  <span
                                    style={{
                                      color: "#2563eb",
                                      cursor: "pointer",
                                      fontWeight: "600",
                                    }}
                                    onClick={toggleExpanded}
                                  >
                                    ...less
                                  </span>
                                </div>
                              </div>
                            )}
                          </>

                          <div style={{ marginTop: "0px" }}>
                            <p
                              style={{
                                color: isExpiredd(product.validity)
                                  ? "red"
                                  : "#0f766e",
                                fontWeight: "600",
                                fontSize: "14px",
                              }}
                            >
                              Offer :{" "}
                              {product.offer
                                ? `${product.offer}%`
                                : "No offer available"}{" "}
                              {isExpiredd(product.validity) &&
                                "(Expired!)"}
                            </p>

                            <p
                              style={{
                                color: isExpiredd(product.validity)
                                  ? "red"
                                  : "#475569",
                                // marginTop: "6px",
                                fontWeight: "500",
                                fontSize: "14px",
                              }}
                            >
                              Validity : {formatDate(product.validity)}{" "}
                              {isExpiredd(product.validity) &&
                                "(Expired!)"}
                            </p>

                            <p
                              style={{
                                // marginTop: "6px",
                                color: "#16a34a",
                                fontWeight: "600",
                                fontSize: "14px",
                              }}
                            >
                              GST Verified ✅
                            </p>

                            <div
                              style={{
                               // marginTop: "8px",
                                fontSize: "14px",
                                fontWeight: "600",
                              }}
                            >
                              {renderStars(productAverageRating)} (
                              {productAverageRating.toFixed(1)})
                            </div>
                          </div>

                          <div
                            style={{
                              display: "flex",
                              gap: "10px",
                              marginTop: "16px",
                            }}
                          >
                            <button
                              onClick={() => openRatingModal(product)}
                              style={{
                                flex: 1,
                                border: "none",
                                padding: "8px",
                                borderRadius: "8px",
                                background:
                                  "linear-gradient(to right,#1D3FAA,#1D3FAA)",
                                color: "#fff",
                                fontWeight: "600",
                                fontSize: "13px",
                              }}
                            >
                              Rate
                            </button>

                            <button
                              // className="edit-btn"
                              onClick={() => handleOpenModal(product)}
                              style={{
                                flex: 1,
                                border: "none",
                                padding: "8px",
                                borderRadius: "8px",
                                background:
                                  "linear-gradient(to right,#1e3a8a,#2563eb)",
                                color: "#fff",
                                fontWeight: "600",
                                fontSize: "13px",
                              }}
                            >
                              Referral
                            </button>
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>



                <Modal
                  isOpen={isModalRatingOpen}
                  onRequestClose={closeRatingModal}
                  contentLabel="Product Ratings"
                  style={{
                    overlay: { backgroundColor: "rgba(0, 0, 0, 0.5)" },
                    content: {
                      position: "absolute",
                      top: "50%",
                      left: "50%",
                      transform: "translate(-50%, -50%)",
                      padding: "20px",
                      backgroundColor: "#fff",
                      borderRadius: "10px",
                      width: "90%",
                      maxWidth: "600px",
                      height: "auto",
                      maxHeight: "90vh",
                      overflowY: "auto",
                      boxSizing: "border-box",
                    },
                  }}
                >
                  <h2>Rate This Product</h2>

                  {/* Rating Form */}
                  <div className="rating-form">
                    <h4>Rate this Product</h4>
                    {/* <select
                      value={newRating.rating}
                      onChange={(e) => setNewRating({ ...newRating, rating: parseInt(e.target.value) })}
                      style={{ padding: "8px", marginBottom: "10px", width: "100%" }}
                    >
                      <option value="0">Select Rating</option>
                      {[1, 2, 3, 4, 5].map((r) => (
                        <option key={r} value={r}>{r} Stars</option>
                      ))}
                    </select> */}
                    <div className="star-rating" style={{ marginBottom: "10px" }}>
                      {[1, 2, 3, 4, 5].map((star) => (
                        <span
                          key={star}
                          onClick={() => setNewRating({ ...newRating, rating: star })}
                          onMouseEnter={() => setNewRating({ ...newRating, hoverRating: star })}
                          onMouseLeave={() => setNewRating({ ...newRating, hoverRating: 0 })}
                          style={{
                            cursor: "pointer",
                            fontSize: "30px",
                            color:
                              newRating.hoverRating >= star || newRating.rating >= star
                                ? "black" // gold for selected or hovered
                                : "#ccc", // grey for unselected
                          }}
                        >
                          ★
                        </span>
                      ))}
                    </div>
                    <textarea
                      value={newRating.review}
                      onChange={(e) => setNewRating({ ...newRating, review: e.target.value })}
                      placeholder="Write a review"
                      style={{
                        padding: "10px",
                        marginBottom: "15px",
                        width: "100%",
                        height: "100px",
                        resize: "vertical",
                      }}
                    />

                    <button
                      onClick={() => handleRatingSubmit(currentProduct.id)}
                      style={{
                        backgroundColor: "#4CAF50",
                        color: "white",
                        padding: "10px 20px",
                        border: "none",
                        borderRadius: "5px",
                        cursor: "pointer",
                      }}
                    >
                      Submit Rating
                    </button>
                  </div>

                  <hr />

                  {/* Display All Ratings */}
                  {ratings.length > 0 ? (
                    <div className="ratings-display">
                      <h3>All Ratings</h3>
                      <div style={{ maxHeight: "300px", overflowY: "scroll" }}>
                        {ratings.map((rating, index) => (
                          <div key={rating.id || index} style={{ marginBottom: "10px", padding: "10px", border: "1px solid #ddd", borderRadius: "5px" }}>
                            <p><strong>{rating.email}</strong></p>
                            <p>{renderStars(rating.rating)} - {rating.review}</p>
                          </div>
                        ))}
                      </div>
                    </div>
                  ) : (
                    <p>No ratings yet.</p>
                  )}

                  <button
                    onClick={closeRatingModal}
                    style={{
                      backgroundColor: "red",
                      color: "white",
                      padding: "10px 20px",
                      border: "none",
                      borderRadius: "5px",
                      cursor: "pointer",
                    }}
                  >
                    Close
                  </button>
                </Modal>




                <Modal
                  isOpen={isModalOpen}
                  onRequestClose={handleCloseModal}
                  contentLabel="Customer Referral"
                  style={{
                    overlay: {
                      backgroundColor: "rgba(0, 0, 0, 0.5)",
                    },
                    content: {
                      position: "absolute",
                      top: "50%",
                      left: "50%",
                      transform: "translate(-50%, -50%)",
                      padding: "20px",
                      backgroundColor: "#fff",
                      borderRadius: "10px",
                      width: "90%", // Default width for smaller screens
                      maxWidth: "600px", // Maximum width for larger screens
                      height: "auto", // Height should adjust based on content
                      maxHeight: "90vh", // Ensure the modal doesn't overflow the viewport
                      overflowY: "auto", // Adds scroll if content is too long
                      boxSizing: "border-box", // Ensures padding doesn't affect size
                      marginBottom: "20px",
                    },
                  }}
                >
                  <h2>Referral - Customer </h2>
                  <button
                    className="close"
                    onClick={handleCloseModal}
                    style={{
                      color: "red",
                      position: "absolute",
                      top: "10px",
                      right: "10px",
                      background: "none",
                      border: "none",
                      fontSize: "20px",
                      cursor: "pointer",
                    }}
                  >
                    X
                  </button>
                  <form>
                    <div>
                      <label htmlFor="customerName">Customer Name</label>
                      <input
                        type="text"
                        id="customerName"
                        name="customerName"
                        value={customerDetails.customerName}
                        onChange={handleChange}
                        required
                      />
                    </div>
                    <div>
                      <label htmlFor="customerEmail">Customer Email</label>
                      <input
                        type="email"
                        id="customerEmail"
                        name="customerEmail"
                        value={customerDetails.customerEmail}
                        onChange={handleChange}
                        required
                      />
                    </div>
                    <div>
                      <label htmlFor="customerMobile">Customer Mobile</label>
                      <input
                        type="text"
                        id="customerMobile"
                        name="customerMobile"
                        value={customerDetails.customerMobile}
                        onChange={handleChange}
                        required
                      />
                    </div>
                    <div>
                      <button
                        className="m-3"
                        type="button"
                        onClick={referral} // Handle referral submission
                      >
                        Submit Referral
                      </button>
                    </div>
                  </form>
                </Modal>
              </div>

            </div>
          )}
{activeSection === "sendreferral" && (
  <>
    <div
      style={{
        minHeight: "100vh",
        background: "linear-gradient(to bottom right,#f8fafc,#e0f2fe)",
        paddingBottom: "40px",
      }}
    >
      {/* Header */}
      <div
        style={{
          background: "linear-gradient(to right,#1e3a8a,#2563eb)",
          padding: "40px 20px",
          borderBottomLeftRadius: "25px",
          borderBottomRightRadius: "25px",
          color: "#fff",
          marginBottom: "30px",
        }}
      >
        <div
          style={{
            maxWidth: "1200px",
            margin: "auto",
          }}
        >
          <h1
            style={{
              fontSize: "34px",
              fontWeight: "700",
              marginBottom: "8px",
            }}
          >
            Referral Management
          </h1>

          <p
            style={{
              opacity: "0.9",
              fontSize: "15px",
            }}
          >
            Send and manage your business referrals
          </p>
        </div>
      </div>

      <div
        style={{
          maxWidth: "1200px",
          margin: "auto",
          padding: "0px 20px",
        }}
      >
        <div
          style={{
            background: "#fff",
            borderRadius: "18px",
            padding: "25px",
            boxShadow: "0 4px 15px rgba(0,0,0,0.08)",
            border: "1px solid #e2e8f0",
          }}
        >
          <h3
            style={{
              fontSize: "22px",
              fontWeight: "700",
              color: "#1e293b",
              marginBottom: "25px",
              display: "flex",
              alignItems: "center",
              gap: "10px",
            }}
          >
            <FaUser color="#2563eb" />
            Send Referral
          </h3>

          {/* Select User */}
          <div style={{ marginBottom: "25px" }}>
            <label
              style={{
                fontSize: "14px",
                fontWeight: "600",
                color: "#475569",
                marginBottom: "10px",
                display: "block",
              }}
            >
              Select a User
            </label>

            <Select
              options={usersOptionssend}
              value={
                selectedUserSend
                  ? {
                      value: selectedUserSend.id,
                      label: selectedUserSend.name,
                    }
                  : null
              }
              onChange={handleUserChange1}
              placeholder="Select a User"
            />
          </div>

          {/* Selected User */}
          {selectedUserSend && (
            <>
              <div
                style={{
                  background: "#f8fafc",
                  padding: "18px",
                  borderRadius: "14px",
                  border: "1px solid #e2e8f0",
                  marginBottom: "20px",
                }}
              >
                <h4
                  style={{
                    fontSize: "20px",
                    fontWeight: "700",
                    color: "#1e293b",
                    marginBottom: "8px",
                  }}
                >
                  Send Referral to
                </h4>

                <p
                  style={{
                    fontSize: "16px",
                    color: "#2563eb",
                    fontWeight: "600",
                    margin: 0,
                  }}
                >
                  {selectedUserSend.name}
                </p>
              </div>

              {/* Buttons */}
              <div
                style={{
                  display: "flex",
                  gap: "15px",
                  flexWrap: "wrap",
                }}
              >
                <button
                  onClick={handleSendReffSelf}
                  style={{
                    border: "none",
                    background:
                      "linear-gradient(to right,#2563eb,#1d4ed8)",
                    color: "#fff",
                    padding: "12px 30px",
                    borderRadius: "10px",
                    fontWeight: "600",
                    cursor: "pointer",
                    boxShadow: "0 4px 10px rgba(37,99,235,0.3)",
                  }}
                >
                  Self Referral
                </button>

                <button
                  onClick={() => setShowModalSend(true)}
                  style={{
                    border: "none",
                    background:
                      "linear-gradient(to right,#0f172a,#334155)",
                    color: "#fff",
                    padding: "12px 30px",
                    borderRadius: "10px",
                    fontWeight: "600",
                    cursor: "pointer",
                    boxShadow: "0 4px 10px rgba(0,0,0,0.15)",
                  }}
                >
                  Referral for Others
                </button>
              </div>
            </>
          )}
        </div>
      </div>
    </div>

    {/* Modal */}
    <Modal
      isOpen={showModalSend}
      onRequestClose={() => setShowModalSend(false)}
      contentLabel="Send Referral Modal"
      style={{
        overlay: {
          backgroundColor: "rgba(0,0,0,0.5)",
          zIndex: 999,
        },
        content: {
          maxWidth: "500px",
          margin: "auto",
          borderRadius: "18px",
          padding: "25px",
          border: "none",
          inset: "50% auto auto 50%",
          transform: "translate(-50%, -50%)",
          height: "fit-content",
        },
      }}
    >
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: "20px",
        }}
      >
        <h3
          style={{
            margin: 0,
            fontSize: "22px",
            fontWeight: "700",
            color: "#1e293b",
          }}
        >
          Referral for Others
        </h3>

        <button
          onClick={() => setShowModalSend(false)}
          style={{
            background: "none",
            border: "none",
            fontSize: "22px",
            cursor: "pointer",
            color: "#ef4444",
          }}
        >
          ×
        </button>
      </div>

      <form>
        <div style={{ marginBottom: "16px" }}>
          <label
            style={{
              display: "block",
              marginBottom: "6px",
              fontWeight: "600",
              color: "#475569",
            }}
          >
            Name
          </label>

          <input
            type="text"
            name="name"
            value={otherDetails.name}
            onChange={handleInputChangeSend}
            placeholder="Enter name"
            style={{
              width: "100%",
              padding: "12px",
              borderRadius: "10px",
              border: "1px solid #cbd5e1",
              outline: "none",
            }}
          />
        </div>

        <div style={{ marginBottom: "16px" }}>
          <label
            style={{
              display: "block",
              marginBottom: "6px",
              fontWeight: "600",
              color: "#475569",
            }}
          >
            Number
          </label>

          <input
            type="text"
            name="number"
            value={otherDetails.number}
            onChange={handleInputChangeSend}
            placeholder="Enter number"
            style={{
              width: "100%",
              padding: "12px",
              borderRadius: "10px",
              border: "1px solid #cbd5e1",
              outline: "none",
            }}
          />
        </div>

        <div style={{ marginBottom: "20px" }}>
          <label
            style={{
              display: "block",
              marginBottom: "6px",
              fontWeight: "600",
              color: "#475569",
            }}
          >
            Email
          </label>

          <input
            type="email"
            name="email"
            value={otherDetails.email}
            onChange={handleInputChangeSend}
            placeholder="Enter email"
            style={{
              width: "100%",
              padding: "12px",
              borderRadius: "10px",
              border: "1px solid #cbd5e1",
              outline: "none",
            }}
          />
        </div>

        <div
          style={{
            display: "flex",
            gap: "12px",
          }}
        >
          <button
            type="button"
            onClick={handleSendReff}
            style={{
              flex: 1,
              border: "none",
              background:
                "linear-gradient(to right,#16a34a,#15803d)",
              color: "#fff",
              padding: "12px",
              borderRadius: "10px",
              fontWeight: "600",
              cursor: "pointer",
            }}
          >
            Send Referral
          </button>

          <button
            type="button"
            onClick={() => setShowModalSend(false)}
            style={{
              flex: 1,
              border: "none",
              background: "#e2e8f0",
              color: "#1e293b",
              padding: "12px",
              borderRadius: "10px",
              fontWeight: "600",
              cursor: "pointer",
                
            }}
          >
            Close
          </button>
        </div>
      </form>
    </Modal>
  </>
)}


   {activeSection === "referralIn" && (
  <div
    style={{
      minHeight: "100vh",
      background: "linear-gradient(to bottom right,#f8fafc,#e0f2fe)",
      paddingBottom: "40px",
    }}
  >
    {/* Header */}
    <div
      style={{
        background: "linear-gradient(to right,#1e3a8a,#2563eb)",
        padding: "45px 20px",
        borderBottomLeftRadius: "25px",
        borderBottomRightRadius: "25px",
        color: "#fff",
        marginBottom: "30px",
      }}
    >
      <div
        style={{
          maxWidth: "1200px",
          margin: "auto",
        }}
      >
        <h1
          style={{
            fontSize: "34px",
            fontWeight: "700",
            marginBottom: "10px",
            display: "flex",
            alignItems: "center",
            gap: "10px",
          }}
        >
          <RiArrowLeftUpFill />
          Referral Sent
        </h1>

        <p
          style={{
            opacity: "0.9",
            fontSize: "15px",
          }}
        >
          Monitor all product referrals sent to customers
        </p>
      </div>
    </div>

    {/* Content */}
    <div
      style={{
        maxWidth: "1200px",
        margin: "auto",
        padding: "0px 20px",
      }}
    >
      <div
        style={{
          display: "grid",
          gap: "20px",
        }}
      >
        {referralData.map((item) => (
          <div
            key={item.id}
            style={{
              background: "#fff",
              borderRadius: "18px",
              overflow: "hidden",
              boxShadow: "0 4px 15px rgba(0,0,0,0.08)",
              border: "1px solid #e2e8f0",
            }}
          >
            <div
              style={{
                display: "flex",
                flexWrap: "wrap",
              }}
            >
              {/* Image */}
              <div
                style={{
                  width: "220px",
                  minHeight: "220px",
                  background: "#f1f5f9",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  overflow: "hidden",
                }}
              >
                <img
                  src={item.product}
                  alt="Product"
                  onError={(e) => {
                    e.target.style.display = "none";
                    e.target.nextSibling.style.display = "flex";
                  }}
                  style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "contain",
                  }}
                />

                <div
                  style={{
                    width: "100%",
                    height: "100%",
                    display: "none",
                    alignItems: "center",
                    justifyContent: "center",
                    background: "#e2e8f0",
                    color: "#64748b",
                    fontWeight: "600",
                    fontSize: "18px",
                  }}
                >
                  No Image
                </div>
              </div>

              {/* Details */}
              <div
                style={{
                  flex: 1,
                  padding: "24px",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "space-between",
                  gap: "18px",
                }}
              >
                <div>
                  <h2
                    style={{
                      fontSize: "24px",
                      fontWeight: "700",
                      color: "#0f172a",
                      marginBottom: "10px",
                    }}
                  >
                    {item.productName}
                  </h2>

                  <div
                    style={{
                      display: "inline-block",
                      background: "#dcfce7",
                      color: "#15803d",
                      padding: "8px 16px",
                      borderRadius: "30px",
                      fontWeight: "700",
                      fontSize: "15px",
                    }}
                  >
                    ₹ {item.price}
                  </div>
                </div>

                {/* Emails */}
                <div
                  style={{
                    display: "grid",
                    gridTemplateColumns:
                      "repeat(auto-fit,minmax(220px,1fr))",
                    gap: "18px",
                  }}
                >
                  <div
                    style={{
                      background: "#f8fafc",
                      padding: "16px",
                      borderRadius: "14px",
                      border: "1px solid #e2e8f0",
                    }}
                  >
                    <p
                      style={{
                        fontSize: "12px",
                        fontWeight: "700",
                        color: "#64748b",
                        textTransform: "uppercase",
                        marginBottom: "8px",
                      }}
                    >
                      Customer Email
                    </p>

                    <p
                      style={{
                        color: "#1e293b",
                        fontWeight: "600",
                        margin: 0,
                        wordBreak: "break-word",
                      }}
                    >
                      {item.customerEmail}
                    </p>
                  </div>

                  <div
                    style={{
                      background: "#f8fafc",
                      padding: "16px",
                      borderRadius: "14px",
                      border: "1px solid #e2e8f0",
                    }}
                  >
                    <p
                      style={{
                        fontSize: "12px",
                        fontWeight: "700",
                        color: "#64748b",
                        textTransform: "uppercase",
                        marginBottom: "8px",
                      }}
                    >
                      Seller Email
                    </p>

                    <p
                      style={{
                        color: "#1e293b",
                        fontWeight: "600",
                        margin: 0,
                        wordBreak: "break-word",
                      }}
                    >
                      {item.salerEmail}
                    </p>
                  </div>

                  <div
  style={{
    background: "#f8fafc",
    padding: "16px",
    borderRadius: "14px",
    border: "1px solid #e2e8f0",
  }}
>
  <p
    style={{
      fontSize: "12px",
      fontWeight: "700",
      color: "#64748b",
      textTransform: "uppercase",
      marginBottom: "8px",
    }}
  >
    Referral Date
  </p>

  <p
    style={{
      color: "#1e293b",
      fontWeight: "600",
      margin: 0,
    }}
  >
    {formatDate(item.createdDate)}
  </p>
</div>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  </div>
)}

 {activeSection === "referralOut" && (
  <div
    style={{
      minHeight: "100vh",
      background: "linear-gradient(to bottom right,#f8fafc,#e0f2fe)",
      paddingBottom: "40px",
    }}
  >
    {/* Header */}
    <div
      style={{
        background: "linear-gradient(to right,#1e3a8a,#2563eb)",
        padding: "45px 20px",
        borderBottomLeftRadius: "25px",
        borderBottomRightRadius: "25px",
        color: "#fff",
        marginBottom: "30px",
      }}
    >
      <div
        style={{
          maxWidth: "1200px",
          margin: "auto",
        }}
      >
        <h1
          style={{
            fontSize: "34px",
            fontWeight: "700",
            marginBottom: "10px",
            display: "flex",
            alignItems: "center",
            gap: "10px",
          }}
        >
          <RiArrowLeftDownFill />
          Referral Received
        </h1>

        <p
          style={{
            opacity: "0.9",
            fontSize: "15px",
          }}
        >
          View and manage product referrals received from your network
        </p>
      </div>
    </div>

    {/* Content */}
    <div
      style={{
        maxWidth: "1200px",
        margin: "auto",
        padding: "0px 20px",
      }}
    >
      <div
        style={{
          display: "grid",
          gap: "22px",
        }}
      >
        {referralOutData.map((item) => (
          <div
            key={item.id}
            style={{
              background: "#fff",
              borderRadius: "22px",
              overflow: "hidden",
              boxShadow: "0 4px 15px rgba(0,0,0,0.08)",
              border: "1px solid #e2e8f0",
            }}
          >
            <div
              style={{
                display: "flex",
                flexWrap: "wrap",
              }}
            >
              {/* Image */}
              <div
                style={{
                  width: "240px",
                  minHeight: "240px",
                  background: "#f1f5f9",
                  overflow: "hidden",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <img
                  src={item.product}
                  alt="Product"
                  onError={(e) => {
                    e.target.style.display = "none";
                    e.target.nextSibling.style.display = "flex";
                  }}
                  style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "contain",
                    transition: "0.4s",
                  }}
                />

                <div
                  style={{
                    width: "100%",
                    height: "100%",
                    display: "none",
                    alignItems: "center",
                    justifyContent: "center",
                    background: "#e2e8f0",
                    color: "#64748b",
                    fontWeight: "600",
                    fontSize: "18px",
                  }}
                >
                  No Image
                </div>
              </div>

              {/* Details */}
              <div
                style={{
                  flex: 1,
                  padding: "28px",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "space-between",
                }}
              >
                {/* Top */}
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    flexWrap: "wrap",
                    gap: "20px",
                    marginBottom: "25px",
                  }}
                >
                  <div>
                    <div
                      style={{
                        color: "#2563eb",
                        fontWeight: "700",
                        fontSize: "12px",
                        textTransform: "uppercase",
                        letterSpacing: "1px",
                        marginBottom: "8px",
                      }}
                    >
                      New Referral
                    </div>

                    <h2
                      style={{
                        fontSize: "28px",
                        fontWeight: "800",
                        color: "#0f172a",
                        marginBottom: "12px",
                      }}
                    >
                      {item.productName}
                    </h2>

                    <div
                      style={{
                        display: "inline-block",
                        background: "#dcfce7",
                        color: "#15803d",
                        padding: "8px 18px",
                        borderRadius: "30px",
                        fontWeight: "700",
                        fontSize: "16px",
                      }}
                    >
                      ₹ {item.price}
                    </div>
                  </div>

                  {/* Date */}
                  <div
                    style={{
                      background: "#f8fafc",
                      border: "1px solid #e2e8f0",
                      padding: "12px 18px",
                      borderRadius: "30px",
                      height: "fit-content",
                      color: "#475569",
                      fontWeight: "600",
                      fontSize: "14px",
                    }}
                  >
                    {formatDate(item.createdDate)}
                  </div>
                </div>

                {/* Bottom Details */}
                <div
                  style={{
                    display: "grid",
                    gridTemplateColumns:
                      "repeat(auto-fit,minmax(250px,1fr))",
                    gap: "18px",
                    background: "#eff6ff",
                    padding: "20px",
                    borderRadius: "18px",
                    border: "1px solid #dbeafe",
                  }}
                >
                  {/* Seller Email */}
                  <div
                    style={{
                      background: "#fff",
                      padding: "16px",
                      borderRadius: "14px",
                      border: "1px solid #dbeafe",
                    }}
                  >
                    <p
                      style={{
                        fontSize: "11px",
                        color: "#60a5fa",
                        textTransform: "uppercase",
                        fontWeight: "700",
                        marginBottom: "10px",
                        letterSpacing: "1px",
                      }}
                    >
                      Seller Email
                    </p>

                    <p
                      style={{
                        color: "#1e293b",
                        fontWeight: "700",
                        margin: 0,
                        wordBreak: "break-word",
                      }}
                    >
                      {item.salerEmail}
                    </p>
                  </div>

                  {/* Referral By */}
                  <div
                    style={{
                      background: "#fff",
                      padding: "16px",
                      borderRadius: "14px",
                      border: "1px solid #dbeafe",
                    }}
                  >
                    <p
                      style={{
                        fontSize: "11px",
                        color: "#818cf8",
                        textTransform: "uppercase",
                        fontWeight: "700",
                        marginBottom: "10px",
                        letterSpacing: "1px",
                      }}
                    >
                      Product Referral By
                    </p>

                    <p
                      style={{
                        color: "#0f172a",
                        fontWeight: "700",
                        margin: 0,
                      }}
                    >
                      {item.email}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  </div>
)}

      {activeSection === "thankYou" && (
  <div
    style={{
      minHeight: "100vh",
      background: "#f1f5f9",
      paddingBottom: "40px",
    }}
  >

    {/* HEADER */}
    <div
      style={{
        background: "linear-gradient(135deg,#1e3a8a,#2563eb)",
        padding: "60px 25px",
        borderBottomLeftRadius: "35px",
        borderBottomRightRadius: "35px",
        boxShadow: "0 10px 35px rgba(37,99,235,0.25)",
      }}
    >
      <div
        style={{
          maxWidth: "1400px",
          margin: "0 auto",
        }}
      >
        <h1
          style={{
            color: "#fff",
            fontSize: "42px",
            fontWeight: "800",
            marginBottom: "12px",
          }}
        >
          Thanks Notes 💙
        </h1>

        <p
          style={{
            color: "rgba(255,255,255,0.9)",
            fontSize: "17px",
            maxWidth: "700px",
            lineHeight: "1.7",
            margin: 0,
          }}
        >
          Document business success and express gratitude to your network
        </p>
      </div>
    </div>

    {/* MAIN */}
    <div
      style={{
        maxWidth: "1400px",
        margin: "auto",
        marginTop: "-30px",
        padding: "0px 15px",
      }}
    >

      <div className="row g-4">

        {/* LEFT SIDE */}
        <div className="col-xl-8 col-lg-7 col-12">

          <div
            style={{
              background: "#fff",
              borderRadius: "30px",
              overflow: "hidden",
              boxShadow: "0 10px 30px rgba(0,0,0,0.08)",
              border: "1px solid #e2e8f0",
            }}
          >

            {/* TOP TAB */}
            <div
              style={{
                padding: "14px",
                background: "#f8fafc",
                display: "flex",
                gap: "12px",
                flexWrap: "wrap",
              }}
            >

              <div
                onClick={() =>
                  handleThankTypeChange({
                    target: { value: "without" },
                  })
                }
                style={{
                  flex: 1,
                  minWidth: "240px",
                  background:
                    thankType === "without"
                      ? "linear-gradient(135deg,#1e3a8a,#2563eb)"
                      : "#fff",
                  color:
                    thankType === "without"
                      ? "#fff"
                      : "#475569",
                  padding: "16px",
                  borderRadius: "18px",
                  fontWeight: "700",
                  textAlign: "center",
                  cursor: "pointer",
                  transition: "0.3s",
                  boxShadow:
                    thankType === "without"
                      ? "0 10px 25px rgba(37,99,235,0.25)"
                      : "none",
                }}
              >
                Send ThanksNote Without Referral
              </div>

              <div
                onClick={() =>
                  handleThankTypeChange({
                    target: { value: "with" },
                  })
                }
                style={{
                  flex: 1,
                  minWidth: "240px",
                  background:
                    thankType === "with"
                      ? "linear-gradient(135deg,#1e3a8a,#2563eb)"
                      : "#fff",
                  color:
                    thankType === "with"
                      ? "#fff"
                      : "#475569",
                  padding: "16px",
                  borderRadius: "18px",
                  fontWeight: "700",
                  textAlign: "center",
                  cursor: "pointer",
                  transition: "0.3s",
                  boxShadow:
                    thankType === "with"
                      ? "0 10px 25px rgba(37,99,235,0.25)"
                      : "none",
                }}
              >
                Send ThanksNote With Referral
              </div>

            </div>

            {/* WITHOUT */}
            {thankType === "without" && (
              <div style={{ padding: "35px 25px" }}>

                <div className="row g-4">

                  {/* SELECT USER */}
                  <div className="col-md-6 col-12">
                    <label
                      style={{
                        fontWeight: "800",
                        fontSize: "12px",
                        letterSpacing: "1px",
                        color: "#64748b",
                        marginBottom: "10px",
                        display: "block",
                        textTransform: "uppercase",
                      }}
                    >
                      <FaUser style={{ marginRight: "8px" }} />
                      Select User
                    </label>

                    <Select
                      options={usersOptionsThanks}
                      value={
                        selectedUserThanks
                          ? {
                            value: selectedUserThanks.id,
                            label: selectedUserThanks.name,
                          }
                          : null
                      }
                      onChange={handleUserChange2}
                      placeholder="Select a User"
                    />
                  </div>

                  {/* BUSINESS VALUE */}
                  <div className="col-md-6 col-12">
                    <label
                      style={{
                        fontWeight: "800",
                        fontSize: "12px",
                        letterSpacing: "1px",
                        color: "#64748b",
                        marginBottom: "10px",
                        display: "block",
                        textTransform: "uppercase",
                      }}
                    >
                      Business Value
                    </label>

                    <FormControl
                      type="text"
                      value={inputValue}
                      onChange={handleInputChangee}
                      placeholder="Enter additional information"
                      style={{
                        height: "55px",
                        borderRadius: "18px",
                        border: "2px solid #dbeafe",
                        background: "#f8fbff",
                        fontWeight: "600",
                        paddingLeft: "18px",
                        boxShadow: "none",
                      }}
                    />
                  </div>

                </div>

                {/* DETAILS */}
                {selectedUserThanks && (
                  <>

                    <div
                      style={{
                        marginTop: "35px",
                        background:
                          "linear-gradient(135deg,#0f172a,#1e293b)",
                        borderRadius: "30px",
                        padding: "35px",
                        position: "relative",
                        overflow: "hidden",
                      }}
                    >

                      <div
                        style={{
                          position: "absolute",
                          top: "-100px",
                          right: "-100px",
                          width: "250px",
                          height: "250px",
                          borderRadius: "50%",
                          background:
                            "rgba(37,99,235,0.15)",
                        }}
                      />

                      <div
                        style={{
                          position: "relative",
                          zIndex: 2,
                        }}
                      >

                        <div
                          style={{
                            marginBottom: "30px",
                          }}
                        >
                          <h4
                            style={{
                              color: "#60a5fa",
                              fontSize: "13px",
                              letterSpacing: "2px",
                              textTransform: "uppercase",
                              fontWeight: "800",
                              marginBottom: "10px",
                            }}
                          >
                            Thanks Note Details
                          </h4>

                          <h2
                            style={{
                              color: "#fff",
                              fontWeight: "800",
                              fontSize: "30px",
                              margin: 0,
                            }}
                          >
                            {selectedUserThanks.name}
                          </h2>
                        </div>

                        <div className="row g-4">

                          <div className="col-md-6 col-12">
                            <div
                              style={{
                                background:
                                  "rgba(255,255,255,0.05)",
                                border: "1px solid rgba(255,255,255,0.08)",
                                borderRadius: "20px",
                                padding: "18px",
                              }}
                            >
                              <p
                                style={{
                                  color: "#60a5fa",
                                  fontSize: "11px",
                                  textTransform: "uppercase",
                                  fontWeight: "700",
                                  marginBottom: "8px",
                                }}
                              >
                                Referral Sender Email
                              </p>

                              <h5
                                style={{
                                  color: "#fff",
                                  fontWeight: "700",
                                  margin: 0,
                                  wordBreak: "break-word",
                                }}
                              >
                                {email}
                              </h5>
                            </div>
                          </div>

                          <div className="col-md-6 col-12">
                            <div
                              style={{
                                background:
                                  "rgba(255,255,255,0.05)",
                                border: "1px solid rgba(255,255,255,0.08)",
                                borderRadius: "20px",
                                padding: "18px",
                              }}
                            >
                              <p
                                style={{
                                  color: "#60a5fa",
                                  fontSize: "11px",
                                  textTransform: "uppercase",
                                  fontWeight: "700",
                                  marginBottom: "8px",
                                }}
                              >
                                Selected Email
                              </p>

                              <h5
                                style={{
                                  color: "#fff",
                                  fontWeight: "700",
                                  margin: 0,
                                  wordBreak: "break-word",
                                }}
                              >
                                {selectedUserThanks.email}
                              </h5>
                            </div>
                          </div>

                          <div className="col-md-6 col-12">
                            <div
                              style={{
                                background:
                                  "rgba(255,255,255,0.05)",
                                border: "1px solid rgba(255,255,255,0.08)",
                                borderRadius: "20px",
                                padding: "18px",
                              }}
                            >
                              <p
                                style={{
                                  color: "#60a5fa",
                                  fontSize: "11px",
                                  textTransform: "uppercase",
                                  fontWeight: "700",
                                  marginBottom: "8px",
                                }}
                              >
                                Business Value
                              </p>

                              <h5
                                style={{
                                  color: "#fff",
                                  fontWeight: "700",
                                  margin: 0,
                                }}
                              >
                                {inputValue || "---"}
                              </h5>
                            </div>
                          </div>

                        </div>

                      </div>

                    </div>

                    {/* BUTTON */}
                    <Button
                      variant="primary"
                      onClick={sendThankYouNoteRef}
                      style={{
                        marginTop: "25px",
                        width: "100%",
                        height: "60px",
                        borderRadius: "18px",
                        border: "none",
                        background:
                          "linear-gradient(135deg,#1e3a8a,#2563eb)",
                        fontWeight: "800",
                        fontSize: "16px",
                        boxShadow:
                          "0 10px 25px rgba(37,99,235,0.25)",
                      }}
                    >
                      Send Referral Thank You Note
                    </Button>

                  </>
                )}

              </div>
            )}

            {/* WITH */}
            {thankType === "with" && (
              <div style={{ padding: "35px 25px" }}>

                <div className="mb-4 text-center">
                  <img
                    alt="Referral icon"
                    src={stickynote}
                    style={{
                      width: "100px",
                      height: "100px",
                      objectFit: "contain",
                    }}
                  />
                </div>

                {/* DROPDOWN */}
                <Form.Group controlId="referralOutData">

                  <Form.Label
                    style={{
                      fontWeight: "800",
                      fontSize: "12px",
                      letterSpacing: "1px",
                      color: "#64748b",
                      marginBottom: "10px",
                      display: "block",
                      textTransform: "uppercase",
                    }}
                  >
                    Select Referral Received ID
                  </Form.Label>

                  <DropdownButton
                    as={ButtonGroup}
                    variant="outline-primary"
                    title={
                      selectedReferralOut
                        ? `Referral Out ID: ${selectedReferralOut}`
                        : "Select Referral Out"
                    }
                    onSelect={handleReferralOutSelect}
                  >
                    <Dropdown.Item eventKey="">
                      Select Referral Out
                    </Dropdown.Item>

                    {thanks.map((item) => (
                      <Dropdown.Item
                        key={item.id}
                        eventKey={item.id}
                      >
                        Referral Out ID: {item.email}
                      </Dropdown.Item>
                    ))}
                  </DropdownButton>

                </Form.Group>

                {/* DETAILS */}
                {selectedReferralOut &&
                  selectedReferralOutDetails && (
                    <>

                      <div
                        style={{
                          marginTop: "30px",
                          background:
                            "linear-gradient(135deg,#0f172a,#1e293b)",
                          borderRadius: "30px",
                          padding: "35px",
                        }}
                      >

                        <div className="row g-4">

                          <div className="col-md-6 col-12">
                            <div
                              style={{
                                background:
                                  "rgba(255,255,255,0.05)",
                                borderRadius: "18px",
                                padding: "18px",
                              }}
                            >
                              <small
                                style={{
                                  color: "#60a5fa",
                                  fontWeight: "700",
                                }}
                              >
                                PRODUCT NAME
                              </small>

                              <h5
                                style={{
                                  color: "#fff",
                                  marginTop: "8px",
                                  fontWeight: "700",
                                }}
                              >
                                {selectedReferralOutDetails.productName}
                              </h5>
                            </div>
                          </div>

                          <div className="col-md-6 col-12">
                            <div
                              style={{
                                background:
                                  "rgba(255,255,255,0.05)",
                                borderRadius: "18px",
                                padding: "18px",
                              }}
                            >
                              <small
                                style={{
                                  color: "#60a5fa",
                                  fontWeight: "700",
                                }}
                              >
                                PRODUCT PRICE
                              </small>

                              <h5
                                style={{
                                  color: "#fff",
                                  marginTop: "8px",
                                  fontWeight: "700",
                                }}
                              >
                                {selectedReferralOutDetails.price}
                              </h5>
                            </div>
                          </div>

                          <div className="col-md-6 col-12">
                            <div
                              style={{
                                background:
                                  "rgba(255,255,255,0.05)",
                                borderRadius: "18px",
                                padding: "18px",
                              }}
                            >
                              <small
                                style={{
                                  color: "#60a5fa",
                                  fontWeight: "700",
                                }}
                              >
                                CUSTOMER NAME
                              </small>

                              <h5
                                style={{
                                  color: "#fff",
                                  marginTop: "8px",
                                  fontWeight: "700",
                                }}
                              >
                                {selectedReferralOutDetails.customerName}
                              </h5>
                            </div>
                          </div>

                          <div className="col-md-6 col-12">
                            <div
                              style={{
                                background:
                                  "rgba(255,255,255,0.05)",
                                borderRadius: "18px",
                                padding: "18px",
                              }}
                            >
                              <small
                                style={{
                                  color: "#60a5fa",
                                  fontWeight: "700",
                                }}
                              >
                                CUSTOMER EMAIL
                              </small>

                              <h5
                                style={{
                                  color: "#fff",
                                  marginTop: "8px",
                                  fontWeight: "700",
                                  wordBreak: "break-word",
                                }}
                              >
                                {
                                  selectedReferralOutDetails.customerEmail
                                }
                              </h5>
                            </div>
                          </div>

                          <div className="col-md-6 col-12">
                            <div
                              style={{
                                background:
                                  "rgba(255,255,255,0.05)",
                                borderRadius: "18px",
                                padding: "18px",
                              }}
                            >
                              <small
                                style={{
                                  color: "#60a5fa",
                                  fontWeight: "700",
                                }}
                              >
                                SELLER EMAIL
                              </small>

                              <h5
                                style={{
                                  color: "#fff",
                                  marginTop: "8px",
                                  fontWeight: "700",
                                  wordBreak: "break-word",
                                }}
                              >
                                {selectedReferralOutDetails.salerEmail}
                              </h5>
                            </div>
                          </div>

                          <div className="col-md-6 col-12">
                            <div
                              style={{
                                background:
                                  "rgba(255,255,255,0.05)",
                                borderRadius: "18px",
                                padding: "18px",
                              }}
                            >
                              <small
                                style={{
                                  color: "#60a5fa",
                                  fontWeight: "700",
                                }}
                              >
                                CUSTOMER MOBILE
                              </small>

                              <h5
                                style={{
                                  color: "#fff",
                                  marginTop: "8px",
                                  fontWeight: "700",
                                }}
                              >
                                {
                                  selectedReferralOutDetails.customerMobile
                                }
                              </h5>
                            </div>
                          </div>

                          <div className="col-12">
                            <div
                              style={{
                                background:
                                  "rgba(255,255,255,0.05)",
                                borderRadius: "18px",
                                padding: "18px",
                              }}
                            >
                              <small
                                style={{
                                  color: "#60a5fa",
                                  fontWeight: "700",
                                }}
                              >
                                PRODUCT IMAGE
                              </small>

                              <div className="mt-3">
                                <img
                                  src={
                                    selectedReferralOutDetails.product
                                  }
                                  alt="Product"
                                  style={{
                                    width: "100px",
                                    height: "100px",
                                    borderRadius: "16px",
                                    objectFit: "cover",
                                  }}
                                />
                              </div>
                            </div>
                          </div>

                        </div>

                      </div>

                      {/* INPUT */}
                      <div className="mt-4">
                        <FormControl
                          type="text"
                          value={inputValue}
                          onChange={handleInputChangee}
                          placeholder="Enter additional information"
                          style={{
                            height: "55px",
                            borderRadius: "18px",
                            border: "2px solid #dbeafe",
                            background: "#f8fbff",
                            fontWeight: "600",
                            paddingLeft: "18px",
                            boxShadow: "none",
                          }}
                        />
                      </div>

                      {/* BUTTON */}
                      <Button
                        variant="primary"
                        onClick={sendThankYouNote}
                        disabled={
                          loading || !selectedReferralOutDetails
                        }
                        style={{
                          marginTop: "25px",
                          width: "100%",
                          height: "60px",
                          borderRadius: "18px",
                          border: "none",
                          background:
                            "linear-gradient(135deg,#1e3a8a,#2563eb)",
                          fontWeight: "800",
                          fontSize: "16px",
                          boxShadow:
                            "0 10px 25px rgba(37,99,235,0.25)",
                        }}
                      >
                        Send Thank You Note
                      </Button>

                    </>
                  )}

              </div>
            )}

          </div>
        </div>

        {/* RIGHT SIDE */}
        <div 
        //className="col-xl-4 col-lg-5 col-12"
        >

          {/* SENT NOTES */}
          <div
            style={{
              background: "#fff",
              borderRadius: "30px",
              overflow: "hidden",
              marginBottom: "25px",
              boxShadow: "0 10px 30px rgba(0,0,0,0.08)",
            }}
          >

            <div
              style={{
                padding: "20px 24px",
                background:
                  "linear-gradient(135deg,#1e3a8a,#2563eb)",
                color: "#fff",
              }}
            >
              <h3
                style={{
                  margin: 0,
                  fontSize: "15px",
                  fontWeight: "800",
                  letterSpacing: "1px",
                  textTransform: "uppercase",
                }}
              >
                Sent Thanks Notes
              </h3>
            </div>

            <div
              style={{
                padding: "18px",
                maxHeight: "550px",
                overflowY: "auto",
                background: "#f8fafc",
              }}
            >

              {thanksNotes.length > 0 ? (
                thanksNotes.map((note) => (
                  <div
                    key={note.id}
                    style={{
                      background: "#fff",
                      borderRadius: "22px",
                      padding: "18px",
                      marginBottom: "18px",
                      border: "1px solid #e2e8f0",
                    }}
                  >

                    {note.product &&
                      note.product.startsWith("http") ? (
                      <img
                        src={note.product}
                        alt={note.productName}
                        style={{
                          width: "100%",
                          height: "180px",
                          objectFit: "cover",
                          borderRadius: "18px",
                          marginBottom: "15px",
                        }}
                      />
                    ) : (
                      <div
                        style={{
                          width: "100%",
                          height: "180px",
                          borderRadius: "18px",
                          marginBottom: "15px",
                          background: "#e2e8f0",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          color: "#64748b",
                          fontWeight: "700",
                        }}
                      >
                        No Image Available
                      </div>
                    )}

                    <h4
                      style={{
                        fontWeight: "800",
                        fontSize: "18px",
                        marginBottom: "12px",
                        color: "#0f172a",
                      }}
                    >
                      {note.productName || "General Note"}
                    </h4>

                    <p style={{ marginBottom: "8px" }}>
                      <strong>Price:</strong> {note.price}
                    </p>

                    <p style={{ marginBottom: "8px" }}>
                      <strong>Email:</strong> {note.email}
                    </p>

                    <div
                      style={{
                        background: "#eff6ff",
                        padding: "12px",
                        borderRadius: "14px",
                        marginTop: "14px",
                        color: "#1e3a8a",
                        fontWeight: "700",
                      }}
                    >
                      BV : {note.additionalInfo}
                    </div>

                  </div>
                ))
              ) : (
                <p>No Sent thanks notes available.</p>
              )}

            </div>

          </div>

          {/* RECEIVED NOTES */}
          <div
            style={{
              background: "#fff",
              borderRadius: "30px",
              overflow: "hidden",
              boxShadow: "0 10px 30px rgba(0,0,0,0.08)",
            }}
          >

            <div
              style={{
                padding: "20px 24px",
                background:
                  "linear-gradient(135deg,#dc2626,#ef4444)",
                color: "#fff",
              }}
            >
              <h3
                style={{
                  margin: 0,
                  fontSize: "15px",
                  fontWeight: "800",
                  letterSpacing: "1px",
                  textTransform: "uppercase",
                }}
              >
                Received Thanks Note
              </h3>
            </div>

            <div
              style={{
                padding: "18px",
                maxHeight: "550px",
                overflowY: "auto",
                background: "#f8fafc",
              }}
            >

              {myThankNote.length > 0 ? (
                myThankNote.map((note) => (
                  <div
                    key={note.id}
                    style={{
                      background: "#fff",
                      borderRadius: "22px",
                      padding: "18px",
                      marginBottom: "18px",
                      border: "1px solid #fecaca",
                      position: "relative",
                      overflow: "hidden",
                    }}
                  >

                    <div
                      style={{
                        position: "absolute",
                        top: 0,
                        right: 0,
                        width: "5px",
                        height: "100%",
                        background: "#dc2626",
                      }}
                    />

                    <h4
                      style={{
                        fontWeight: "800",
                        fontSize: "18px",
                        marginBottom: "10px",
                        color: "#0f172a",
                      }}
                    >
                      {note.productName || "Direct Thanks"}
                    </h4>

                    <p style={{ marginBottom: "10px" }}>
                      <strong>From:</strong> {note.salerEmail}
                    </p>

                    <div
                      style={{
                        background: "#fef2f2",
                        padding: "14px",
                        borderRadius: "14px",
                        color: "#b91c1c",
                        fontWeight: "700",
                        lineHeight: "1.6",
                      }}
                    >
                      ThankYou Message : {note.additionalInfo}
                    </div>

                  </div>
                ))
              ) : (
                <p>No Received thanks notes available.</p>
              )}

            </div>

          </div>

        </div>

      </div>
    </div>
  </div>
)}

   {activeSection === "meetingCalendar" && (

  <div className="min-h-screen bg-gray-50 rounded-4 overflow-hidden">
    
    {/* Header */}
    <div
      style={{
        background: "linear-gradient(to right, #1e3a8a, #1e40af)",
        padding: "50px 30px",
        color: "white",
      }}
    >
      <div>
        <h1
          style={{
            fontSize: "38px",
            fontWeight: "800",
            marginBottom: "10px",
          }}
        >
          Meetings Calendar <GrValidate />
        </h1>

        <p
          style={{
            fontSize: "16px",
            opacity: "0.9",
            maxWidth: "700px",
          }}
        >
          Confirm your presence for upcoming business sessions and networking events.
        </p>
      </div>
    </div>

    <Card.Body style={{ padding: "30px" }}>
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "1fr",
          gap: "25px",
        }}
      >
        {meetings.map((meeting, index) => {

          const expired = isExpired(meeting.date, meeting.time);

          return (
            <div
              key={index}
              style={{
                background: "#fff",
                borderRadius: "28px",
                padding: "30px",
                border: "1px solid #e5e7eb",
                boxShadow: "0 6px 18px rgba(0,0,0,0.06)",
                opacity: expired ? 0.7 : 1,
                transition: "0.3s",
              }}
            >
              <div
                style={{
                  display: "flex",
                  flexWrap: "wrap",
                  justifyContent: "space-between",
                  gap: "30px",
                }}
              >

                {/* LEFT SIDE */}
                <div style={{ flex: 1, minWidth: "260px" }}>

                  <div
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      gap: "8px",
                      background: "#eff6ff",
                      color: "#1d4ed8",
                      padding: "6px 14px",
                      borderRadius: "50px",
                      fontSize: "12px",
                      fontWeight: "700",
                      marginBottom: "18px",
                      textTransform: "uppercase",
                      letterSpacing: "1px",
                    }}
                  >
                    <FaCalendarAlt />
                    Meeting #{index + 1}
                  </div>

                  <h2
                    style={{
                      fontSize: "28px",
                      fontWeight: "800",
                      color: "#111827",
                      marginBottom: "25px",
                    }}
                  >
                    Business Networking Session
                  </h2>

                  {/* DETAILS GRID */}
                  <div
                    style={{
                      display: "grid",
                      gridTemplateColumns: "repeat(auto-fit,minmax(220px,1fr))",
                      gap: "18px",
                    }}
                  >

                    {/* DATE */}
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "15px",
                        background: "#f8fafc",
                        padding: "16px",
                        borderRadius: "18px",
                      }}
                    >
                      <div
                        style={{
                          background: "#dbeafe",
                          width: "48px",
                          height: "48px",
                          borderRadius: "14px",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        <FaCalendarAlt color="#1e40af" size={18} />
                      </div>

                      <div>
                        <p
                          style={{
                            margin: 0,
                            fontSize: "11px",
                            fontWeight: "700",
                            color: "#94a3b8",
                            textTransform: "uppercase",
                            letterSpacing: "1px",
                          }}
                        >
                          Meeting Date
                        </p>

                        <p
                          style={{
                            margin: 0,
                            marginTop: "4px",
                            fontWeight: "700",
                            color: "#111827",
                          }}
                        >
                          {new Date(meeting.date).toLocaleDateString()}
                        </p>
                      </div>
                    </div>

                    {/* TIME */}
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "15px",
                        background: "#f8fafc",
                        padding: "16px",
                        borderRadius: "18px",
                      }}
                    >
                      <div
                        style={{
                          background: "#dbeafe",
                          width: "48px",
                          height: "48px",
                          borderRadius: "14px",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        <FaRegClock color="#1e40af" size={18} />
                      </div>

                      <div>
                        <p
                          style={{
                            margin: 0,
                            fontSize: "11px",
                            fontWeight: "700",
                            color: "#94a3b8",
                            textTransform: "uppercase",
                            letterSpacing: "1px",
                          }}
                        >
                          Meeting Time
                        </p>

                        <p
                          style={{
                            margin: 0,
                            marginTop: "4px",
                            fontWeight: "700",
                            color: "#111827",
                          }}
                        >
                          {meeting.time}
                        </p>
                      </div>
                    </div>

                    {/* VENUE */}
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "15px",
                        background: "#f8fafc",
                        padding: "16px",
                        borderRadius: "18px",
                      }}
                    >
                      <div
                        style={{
                          background: "#dbeafe",
                          width: "48px",
                          height: "48px",
                          borderRadius: "14px",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        <FaMapPin color="#1e40af" size={18} />
                      </div>

                      <div>
                        <p
                          style={{
                            margin: 0,
                            fontSize: "11px",
                            fontWeight: "700",
                            color: "#94a3b8",
                            textTransform: "uppercase",
                            letterSpacing: "1px",
                          }}
                        >
                          Venue
                        </p>

                        <p
                          style={{
                            margin: 0,
                            marginTop: "4px",
                            fontWeight: "700",
                            color: "#111827",
                          }}
                        >
                          {meeting.venue}
                        </p>
                      </div>
                    </div>

                  </div>
                </div>

                {/* RIGHT SIDE BUTTONS */}
             <div>
                                       {responses[meeting.id] ? (
                                         <Button
                                           variant={responses[meeting.id] === "yes" ? "success" : "danger"}
                                           disabled
                                           style={{
                                             width: "100%",
                                             padding: "8px 12px",
                                             fontWeight: "600",
                                             fontSize: "14px",
                                           }}
                                         >
                                           {responses[meeting.id] === "yes"
                                             ? expired ? "Present" : "Attending"
                                             : expired ? "Absent" : "Not Attending"}
                                         </Button>
                                       ) : (
                                         <>
                                           {responses[meeting.id] !== "yes" && (
                                             <Button
                                               variant="success"
                                               onClick={() => handleButtonClick(meeting.id, "yes")}
                                               disabled={expired || responses[meeting.id]} // Disable if expired or already responded
                                               style={{
                                                 width: "100%",
                                                 padding: "8px 12px",
                                                 fontWeight: "600",
                                                 fontSize: "14px",
                                                 marginBottom: "8px",
                                               }}
                                             >
                                               Attending
                                             </Button>
                                           )}
             
                                           {responses[meeting.id] !== "no" && (
                                             <Button
                                               variant="danger"
                                               onClick={() => handleButtonClick(meeting.id, "no")}
                                               disabled={expired || responses[meeting.id]} // Disable if expired or already responded
                                               style={{
                                                 width: "100%",
                                                 padding: "8px 12px",
                                                 fontWeight: "600",
                                                 fontSize: "14px",
                                               }}
                                             >
                                               Not Attending
                                             </Button>
                                           )}
                                         </>
                                       )}
                                     </div>
              </div>
            </div>
          );
        })}
      </div>
    </Card.Body>
  </div>
)}

     {activeSection === "eventCalendar" && (

  <div className="min-h-screen bg-gray-50 rounded-4 overflow-hidden">

    {/* Header */}
    <div
      style={{
        background: "linear-gradient(to right, #1e3a8a, #1e40af)",
        padding: "50px 30px",
        color: "white",
      }}
    >
      <div>
        <h1
          style={{
            fontSize: "38px",
            fontWeight: "800",
            marginBottom: "10px",
          }}
        >
          Events Calendar <GrValidate />
        </h1>

        <p
          style={{
            fontSize: "16px",
            opacity: "0.9",
            maxWidth: "700px",
          }}
        >
          Confirm your presence for upcoming events and networking programs.
        </p>
      </div>
    </div>

    <Card.Body style={{ padding: "30px" }}>
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "1fr",
          gap: "25px",
        }}
      >
        {eventss.map((event, index) => {

          const expired = isExpired(event.date, event.time);

          return (
            <div
              key={index}
              style={{
                background: "#fff",
                borderRadius: "28px",
                padding: "30px",
                border: "1px solid #e5e7eb",
                boxShadow: "0 6px 18px rgba(0,0,0,0.06)",
                opacity: expired ? 0.7 : 1,
                transition: "0.3s",
              }}
            >
              <div
                style={{
                  display: "flex",
                  flexWrap: "wrap",
                  justifyContent: "space-between",
                  gap: "30px",
                }}
              >

                {/* LEFT SIDE */}
                <div style={{ flex: 1, minWidth: "260px" }}>

                  <div
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      gap: "8px",
                      background: "#eff6ff",
                      color: "#1d4ed8",
                      padding: "6px 14px",
                      borderRadius: "50px",
                      fontSize: "12px",
                      fontWeight: "700",
                      marginBottom: "18px",
                      textTransform: "uppercase",
                      letterSpacing: "1px",
                    }}
                  >
                    <FaRegBell />
                    Event #{index + 1}
                  </div>

                  <h2
                    style={{
                      fontSize: "28px",
                      fontWeight: "800",
                      color: "#111827",
                      marginBottom: "25px",
                    }}
                  >
                    {event.events}
                  </h2>

                  {/* DETAILS GRID */}
                  <div
                    style={{
                      display: "grid",
                      gridTemplateColumns: "repeat(auto-fit,minmax(220px,1fr))",
                      gap: "18px",
                    }}
                  >

                    {/* DATE */}
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "15px",
                        background: "#f8fafc",
                        padding: "16px",
                        borderRadius: "18px",
                      }}
                    >
                      <div
                        style={{
                          background: "#dbeafe",
                          width: "48px",
                          height: "48px",
                          borderRadius: "14px",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        <FaCalendarAlt color="#1e40af" size={18} />
                      </div>

                      <div>
                        <p
                          style={{
                            margin: 0,
                            fontSize: "11px",
                            fontWeight: "700",
                            color: "#94a3b8",
                            textTransform: "uppercase",
                            letterSpacing: "1px",
                          }}
                        >
                          Event Date
                        </p>

                        <p
                          style={{
                            margin: 0,
                            marginTop: "4px",
                            fontWeight: "700",
                            color: "#111827",
                          }}
                        >
                          {new Date(event.date).toLocaleDateString()}
                        </p>
                      </div>
                    </div>

                    {/* TIME */}
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "15px",
                        background: "#f8fafc",
                        padding: "16px",
                        borderRadius: "18px",
                      }}
                    >
                      <div
                        style={{
                          background: "#dbeafe",
                          width: "48px",
                          height: "48px",
                          borderRadius: "14px",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        <FaRegClock color="#1e40af" size={18} />
                      </div>

                      <div>
                        <p
                          style={{
                            margin: 0,
                            fontSize: "11px",
                            fontWeight: "700",
                            color: "#94a3b8",
                            textTransform: "uppercase",
                            letterSpacing: "1px",
                          }}
                        >
                          Event Time
                        </p>

                        <p
                          style={{
                            margin: 0,
                            marginTop: "4px",
                            fontWeight: "700",
                            color: "#111827",
                          }}
                        >
                          {event.time}
                        </p>
                      </div>
                    </div>

                    {/* VENUE */}
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "15px",
                        background: "#f8fafc",
                        padding: "16px",
                        borderRadius: "18px",
                      }}
                    >
                      <div
                        style={{
                          background: "#dbeafe",
                          width: "48px",
                          height: "48px",
                          borderRadius: "14px",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        <FaMapPin color="#1e40af" size={18} />
                      </div>

                      <div>
                        <p
                          style={{
                            margin: 0,
                            fontSize: "11px",
                            fontWeight: "700",
                            color: "#94a3b8",
                            textTransform: "uppercase",
                            letterSpacing: "1px",
                          }}
                        >
                          Venue
                        </p>

                        <p
                          style={{
                            margin: 0,
                            marginTop: "4px",
                            fontWeight: "700",
                            color: "#111827",
                          }}
                        >
                          {event.venue}
                        </p>
                      </div>
                    </div>

                    {/* EVENT NAME */}
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "15px",
                        background: "#f8fafc",
                        padding: "16px",
                        borderRadius: "18px",
                      }}
                    >
                      <div
                        style={{
                          background: "#dbeafe",
                          width: "48px",
                          height: "48px",
                          borderRadius: "14px",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        <FaRegBell color="#1e40af" size={18} />
                      </div>

                      <div>
                        <p
                          style={{
                            margin: 0,
                            fontSize: "11px",
                            fontWeight: "700",
                            color: "#94a3b8",
                            textTransform: "uppercase",
                            letterSpacing: "1px",
                          }}
                        >
                          Event Name
                        </p>

                        <p
                          style={{
                            margin: 0,
                            marginTop: "4px",
                            fontWeight: "700",
                            color: "#111827",
                          }}
                        >
                          {event.events}
                        </p>
                      </div>
                    </div>

                  </div>
                </div>

                {/* RIGHT SIDE BUTTONS */}
                <div>
                  {eventresponses[event.id] ? (
                    <Button
                      variant={eventresponses[event.id] === "yes" ? "success" : "danger"}
                      disabled
                      style={{
                        width: "100%",
                        padding: "8px 12px",
                        fontWeight: "600",
                        fontSize: "14px",
                      }}
                    >
                      {eventresponses[event.id] === "yes"
                        ? expired ? "Present" : "Attending"
                        : expired ? "Absent" : "Not Attending"}
                    </Button>
                  ) : (
                    <>
                      {eventresponses[event.id] !== "yes" && (
                        <Button
                          variant="success"
                          onClick={() => handleButtonEventClick(event.id, "yes")}
                          disabled={expired || eventresponses[event.id]}
                          style={{
                            width: "100%",
                            padding: "8px 12px",
                            fontWeight: "600",
                            fontSize: "14px",
                            marginBottom: "8px",
                          }}
                        >
                          Attending
                        </Button>
                      )}

                      {eventresponses[event.id] !== "no" && (
                        <Button
                          variant="danger"
                          onClick={() => handleButtonEventClick(event.id, "no")}
                          disabled={expired || eventresponses[event.id]}
                          style={{
                            width: "100%",
                            padding: "8px 12px",
                            fontWeight: "600",
                            fontSize: "14px",
                          }}
                        >
                          Not Attending
                        </Button>
                      )}
                    </>
                  )}
                </div>

              </div>
            </div>
          );
        })}
      </div>
    </Card.Body>
  </div>
)}
          {activeSection === "notification" && (
            <div>
              <h2>notification</h2>
            </div>
          )}

          {activeSection === "meetinginvite" && (
            <div>
              <div style={formContainerStyle}>
                <form style={formStyle} onSubmit={handleSubmitMeetingInvite}>
                  <h1 style={{ textAlign: 'center', marginBottom: '20px' }}>Meeting Invite Form</h1>

                  <label htmlFor="name" style={labelStyle}>Name</label>
                  <input
                    type="text"
                    id="name"
                    name="name"
                    value={formDatamettinginvute.name}
                    onChange={handleChangeMeetingInvite}
                    style={inputStyle}
                    required
                  />

                  <label htmlFor="mobile" style={labelStyle}>Mobile</label>
                  <input
                    type="tel"
                    id="mobile"
                    name="mobile"
                    value={formDatamettinginvute.mobile}
                    onChange={handleChangeMeetingInvite}
                    style={inputStyle}
                    required
                  />

                  <label htmlFor="email" style={labelStyle}>Email</label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    value={formDatamettinginvute.email}
                    onChange={handleChangeMeetingInvite}
                    style={inputStyle}
                    required
                  />

                  <label htmlFor="membershipNo" style={labelStyle}>Membership No</label>
                  <input
                    type="text"
                    id="membershipNo"
                    name="membershipNo"
                    value={formDatamettinginvute.membershipNo}
                    onChange={handleChangeMeetingInvite}
                    style={inputStyle}
                    required
                  />

                  <label htmlFor="district" style={labelStyle}>District</label>
                  <select
                    id="district"
                    name="district"
                    value={formDatamettinginvute.district}
                    onChange={handleChangeMeetingInvite}
                    style={inputStyle}
                    required
                  >
                    <option value="320A">320A</option>
                    <option value="320B">320B</option>
                    <option value="320C">320C</option>
                    <option value="320D">320D</option>
                    <option value="320E">320E</option>
                    <option value="320F">320F</option>
                    <option value="320G">320G</option>
                    <option value="320H">320H</option>
                  </select>

                  <label htmlFor="club" style={labelStyle}>Club</label>
                  <input
                    type="text"
                    id="club"
                    name="club"
                    value={formDatamettinginvute.club}
                    onChange={handleChangeMeetingInvite}
                    style={inputStyle}
                    required
                  />

                  <label htmlFor="businessVertical" style={labelStyle}>Business Vertical</label>
                  <input
                    type="text"
                    id="businessVertical"
                    name="businessVertical"
                    value={formDatamettinginvute.businessVertical}
                    onChange={handleChangeMeetingInvite}
                    style={inputStyle}
                    required
                  />

                  <label htmlFor="firmName" style={labelStyle}>Firm / Company Name</label>
                  <input
                    type="text"
                    id="firmName"
                    name="firmName"
                    value={formDatamettinginvute.firmName}
                    onChange={handleChangeMeetingInvite}
                    style={inputStyle}
                    required
                  />

                  <button type="submit" style={buttonStyle} onMouseOver={(e) => e.target.style.backgroundColor = '#0056b3'} onMouseOut={(e) => e.target.style.backgroundColor = '#007BFF'}>
                    Submit
                  </button>
                </form>
              </div>
            </div>
          )}


          {/* {activeSection === "invite" && (
            <div className="container mt-4">
              <h2 className="mb-4">Invite</h2>
              <div className="row">
                <div className="col-md-6">
                  <label><FaUser className="me-2" />Select a User</label>
                  <Select
                    options={usersOptions}
                    value={selectedUser ? { value: selectedUser.id, label: selectedUser.name } : null}
                    onChange={handleUserChange}
                    placeholder="Select a User"
                  />
                </div>
              </div>

              <div className="row mt-4">
                <div className="col-md-6">
                  <h3>Invite {selectedUser ? selectedUser.name : 'a User'} for a meeting</h3>

                  <div className="mb-3">
                    <label className="form-label"><FaCalendarAlt className="me-2" /> Date & Time:</label>
                    <input type="datetime-local" className="form-control" value={dateTime} onChange={handleDateTimeChange} />
                  </div>

                  <div className="mb-3">
                    <label className="form-label"><FaCommentDots className="me-2" />Your Message:</label>
                    <textarea rows={4} className="form-control" value={messagex} onChange={handleMessageChange} placeholder="I am interested in for a one to one meeting you. Kindly confirm your appointment." />
                  </div>

                  <button className="btn btn-primary w-100" onClick={handleSend}>Send</button>
                </div>


                <div className="col-md-6">
                <div
                  style={{
                    display: 'grid',
                    gridTemplateColumns: 'repeat(4, 1fr)', // Exactly 4 columns
                    gap: '20px',
                    padding: '30px',
                    backgroundColor: '#f4f6f9',
                  }}
                >
                  {invitations.map((invite) => (
                    <div
                      key={invite.id}
                      style={{
                        backgroundColor: '#fff',
                        borderRadius: '12px',
                        padding: '16px',
                        boxShadow: '0 6px 18px rgba(0, 0, 0, 0.1)',
                        fontFamily: 'Arial, sans-serif',
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'space-between',
                        height: '250px',
                      }}
                    >
                      <div style={{ fontSize: '16px', fontWeight: 'bold', color: '#333', marginBottom: '4px' }}>
                        {invite.name}
                      </div>
                      <div style={{ fontSize: '12px', color: '#777', marginBottom: '8px' }}>
                        {invite.email}
                      </div>
                      <div style={{ fontSize: '13px', color: '#444', marginBottom: '10px', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                        {invite.message}
                      </div>
                      <div style={{ fontSize: '12px', color: '#555' }}>
                        📅 <strong>Date:</strong><br /> {new Date(invite.dateTime).toLocaleString()}
                      </div>
                      <div style={{ fontSize: '12px', color: '#555' }}>
                        <strong>Status:</strong><br />
                        {invite.status === 0
                          ? '🕒 Pending'
                          : invite.status === 1
                            ? '✅ Accepted'
                            : invite.status === 2
                              ? '❌ Rejected'
                              : 'Unknown'}
                      </div>

                      <div style={{ fontSize: '11px', color: '#aaa', marginTop: '8px' }}>
                        Created: {new Date(invite.createdAt).toLocaleString()}
                      </div>
                    </div>
                  ))}
                </div>
</div>

              </div>
            </div>
          )} */}

   {activeSection === "invite" && (
  <div
    style={{
      minHeight: "100vh",
      background: "#f8fafc",
      borderRadius: "30px",
      overflow: "hidden",
    }}
  >

    {/* HEADER */}
    <div
      style={{
        background: "linear-gradient(to right, #1e3a8a, #1e40af)",
        padding: "55px 30px",
        color: "#fff",
      }}
    >
      <div
        style={{
          maxWidth: "1400px",
          margin: "0 auto",
        }}
      >
        <h1
          style={{
            fontSize: "40px",
            fontWeight: "800",
            marginBottom: "12px",
            letterSpacing: "-1px",
          }}
        >
          Meeting Invitation
        </h1>

        <p
          style={{
            fontSize: "16px",
            opacity: "0.9",
            maxWidth: "700px",
            margin: 0,
          }}
        >
          Schedule one-to-one meetings with your business network and manage invitation responses easily.
        </p>
      </div>
    </div>

    {/* MAIN SECTION */}
    <div
      style={{
        padding: "30px",
        maxWidth: "1400px",
        margin: "0 auto",
      }}
    >
      <div
        className="row"
        style={{
          rowGap: "25px",
        }}
      >

        {/* LEFT SIDE */}
        <div className="col-12 col-lg-7">

          <div
            style={{
              background: "#fff",
              borderRadius: "32px",
              padding: "35px",
              boxShadow: "0 10px 35px rgba(0,0,0,0.06)",
              border: "1px solid #e5e7eb",
              height: "100%",
            }}
          >

            {/* TOP TITLE */}
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "15px",
                marginBottom: "35px",
              }}
            >
              <div
                style={{
                  width: "58px",
                  height: "58px",
                  borderRadius: "18px",
                  background: "#dbeafe",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <FaUser
                  size={24}
                  color="#1e40af"
                />
              </div>

              <div>
                <h2
                  style={{
                    margin: 0,
                    fontSize: "30px",
                    fontWeight: "800",
                    color: "#111827",
                  }}
                >
                  Send Invite
                </h2>

                <p
                  style={{
                    margin: 0,
                    marginTop: "4px",
                    color: "#6b7280",
                    fontSize: "14px",
                  }}
                >
                  Invite your network for a professional meeting.
                </p>
              </div>
            </div>

            {/* USER SELECT */}
            <div
              style={{
                marginBottom: "28px",
              }}
            >
              <label
                style={{
                  fontSize: "12px",
                  fontWeight: "800",
                  textTransform: "uppercase",
                  letterSpacing: "1px",
                  color: "#64748b",
                  marginBottom: "10px",
                  display: "block",
                }}
              >
                <FaUser className="me-2" />
                Select User
              </label>

              <Select
                options={usersOptions}
                value={
                  selectedUser
                    ? {
                      value: selectedUser.id,
                      label: selectedUser.name,
                    }
                    : null
                }
                onChange={handleUserChange}
                placeholder="Select a User"
              />
            </div>

            {/* INVITE TITLE */}
            <div
              style={{
                background: "#eff6ff",
                padding: "18px 22px",
                borderRadius: "20px",
                marginBottom: "28px",
                border: "1px solid #bfdbfe",
              }}
            >
              <h3
                style={{
                  margin: 0,
                  fontSize: "22px",
                  fontWeight: "700",
                  color: "#1e3a8a",
                  lineHeight: "34px",
                }}
              >
                Invite{" "}
                <span style={{ color: "#111827" }}>
                  {selectedUser ? selectedUser.name : "a User"}
                </span>{" "}
                for a meeting
              </h3>
            </div>

            {/* DATE TIME */}
            <div
              style={{
                marginBottom: "28px",
              }}
            >
              <label
                style={{
                  fontSize: "12px",
                  fontWeight: "800",
                  textTransform: "uppercase",
                  letterSpacing: "1px",
                  color: "#64748b",
                  marginBottom: "10px",
                  display: "block",
                }}
              >
                <FaCalendarAlt className="me-2" />
                Date & Time
              </label>

              <input
                type="datetime-local"
                className="form-control"
                value={dateTime}
                onChange={handleDateTimeChange}
                style={{
                  borderRadius: "18px",
                  padding: "16px",
                  border: "2px solid #e5e7eb",
                  background: "#f8fafc",
                  fontWeight: "600",
                  boxShadow: "none",
                }}
              />
            </div>

            {/* MESSAGE */}
            <div
              style={{
                marginBottom: "30px",
              }}
            >
              <label
                style={{
                  fontSize: "12px",
                  fontWeight: "800",
                  textTransform: "uppercase",
                  letterSpacing: "1px",
                  color: "#64748b",
                  marginBottom: "10px",
                  display: "block",
                }}
              >
                <FaCommentDots className="me-2" />
                Your Message
              </label>

              <textarea
                rows={5}
                className="form-control"
                value={messagex}
                onChange={handleMessageChange}
                placeholder="I am interested in a one-to-one meeting with you. Kindly confirm your appointment."
                style={{
                  borderRadius: "20px",
                  padding: "18px",
                  border: "2px solid #e5e7eb",
                  background: "#f8fafc",
                  resize: "none",
                  fontWeight: "500",
                  boxShadow: "none",
                }}
              />
            </div>

            {/* SEND BUTTON */}
            <button
              className="btn w-100"
              onClick={handleSend}
              style={{
                background: "linear-gradient(to right, #1e3a8a, #2563eb)",
                border: "none",
                color: "#fff",
                padding: "18px",
                borderRadius: "20px",
                fontWeight: "800",
                fontSize: "16px",
                letterSpacing: "1px",
                boxShadow: "0 10px 25px rgba(37,99,235,0.35)",
                transition: "0.3s",
              }}
            >
              Send Invitation
            </button>

          </div>
        </div>

        {/* RIGHT SIDE */}
        <div className="col-12 col-lg-5">

          <div
            style={{
              background: "#fff",
              borderRadius: "32px",
              overflow: "hidden",
              border: "1px solid #e5e7eb",
              boxShadow: "0 10px 35px rgba(0,0,0,0.06)",
              height: "100%",
            }}
          >

            {/* HEADER */}
            <div
              style={{
                background: "linear-gradient(to right, #1e3a8a, #2563eb)",
                padding: "22px 25px",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <div>
                <h3
                  style={{
                    margin: 0,
                    color: "#fff",
                    fontSize: "20px",
                    fontWeight: "800",
                  }}
                >
                  Invitation Status
                </h3>

                <p
                  style={{
                    margin: 0,
                    marginTop: "4px",
                    color: "rgba(255,255,255,0.8)",
                    fontSize: "13px",
                  }}
                >
                  Meeting invitation history
                </p>
              </div>

              <div
                style={{
                  width: "50px",
                  height: "50px",
                  borderRadius: "16px",
                  background: "rgba(255,255,255,0.15)",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <FaCommentDots color="#fff" size={20} />
              </div>
            </div>

            {/* INVITES */}
            <div
              style={{
                maxHeight: "800px",
                overflowY: "auto",
                padding: "22px",
                background: "#f8fafc",
              }}
            >
              <div className="row g-4">

                {invitations.map((invite) => (

                  <div
                    key={invite.id}
                    className="col-12"
                  >

                    <div
                      style={{
                        background: "#fff",
                        borderRadius: "24px",
                        padding: "22px",
                        border: "1px solid #e5e7eb",
                        boxShadow: "0 4px 18px rgba(0,0,0,0.04)",
                        height: "100%",
                        transition: "0.3s",
                      }}
                    >

                      {/* TOP */}
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "flex-start",
                          gap: "10px",
                          marginBottom: "18px",
                          flexWrap: "wrap",
                        }}
                      >

                        <div>
                          <h4
                            style={{
                              margin: 0,
                              fontSize: "20px",
                              fontWeight: "800",
                              color: "#111827",
                            }}
                          >
                            {invite.name}
                          </h4>

                          <p
                            style={{
                              margin: 0,
                              marginTop: "4px",
                              fontSize: "13px",
                              color: "#64748b",
                              wordBreak: "break-word",
                            }}
                          >
                            {invite.email}
                          </p>
                        </div>

                        <div
                          style={{
                            padding: "8px 14px",
                            borderRadius: "50px",
                            background:
                              invite.status === 0
                                ? "#fef3c7"
                                : invite.status === 1
                                  ? "#dcfce7"
                                  : "#fee2e2",
                            color:
                              invite.status === 0
                                ? "#d97706"
                                : invite.status === 1
                                  ? "#15803d"
                                  : "#dc2626",
                            fontSize: "12px",
                            fontWeight: "800",
                            textTransform: "uppercase",
                            letterSpacing: "0.5px",
                            whiteSpace: "nowrap",
                          }}
                        >
                          {invite.status === 0
                            ? "🕒 Pending"
                            : invite.status === 1
                              ? "✅ Accepted"
                              : invite.status === 2
                                ? "❌ Rejected"
                                : "Unknown"}
                        </div>

                      </div>

                      {/* MESSAGE */}
                      <div
                        style={{
                          background: "#f8fafc",
                          borderRadius: "18px",
                          padding: "18px",
                          border: "1px solid #e5e7eb",
                          marginBottom: "18px",
                        }}
                      >
                        <p
                          style={{
                            margin: 0,
                            fontSize: "14px",
                            color: "#374151",
                            lineHeight: "26px",
                            fontWeight: "500",
                          }}
                        >
                          "{invite.message}"
                        </p>
                      </div>

                      {/* DATE */}
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          gap: "10px",
                        }}
                      >

                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "10px",
                            color: "#475569",
                            fontSize: "13px",
                            fontWeight: "600",
                            flexWrap: "wrap",
                          }}
                        >
                          <FaCalendarAlt color="#2563eb" />
                          <span>
                            Meeting Date :{" "}
                            {new Date(invite.dateTime).toLocaleString()}
                          </span>
                        </div>

                        <div
                          style={{
                            fontSize: "12px",
                            color: "#94a3b8",
                            paddingLeft: "32px",
                            wordBreak: "break-word",
                          }}
                        >
                          Created :{" "}
                          {new Date(invite.createdAt).toLocaleString()}
                        </div>

                      </div>

                    </div>

                  </div>

                ))}

              </div>
            </div>

          </div>

        </div>

      </div>
    </div>
  </div>
)}




{/* 
          {activeSection === "report" && (
            <div className="container mt-4">
              <h2 className="mb-4">Report</h2>
              <div className="row mt-4">
                <div className="col-md-6">
                  <div className="form-group">
                    <label htmlFor="userSelect">
                      <FaUser className="mr-2" /> Select User:
                    </label>
                    <Select
                      id="userSelect"
                      options={usersOptionsz}
                      value={selectedUserz ? { value: selectedUserz.email, label: selectedUserz.name } : null}
                      onChange={handleUserChangez}
                      placeholder="Select a User"
                    />
                  </div>
                </div>
              </div>
              <div className="row mt-4">
                <div className="col-md-6">
                  <form onSubmit={handleSubmitz}>
                    <div className="form-group">
                      <label htmlFor="inputBox">
                        <FaClipboard className="mr-2" /> Text Box:
                      </label>
                      <textarea type="text" id="inputBox" className="form-control" value={inputBox} onChange={(e) => setInputBox(e.target.value)} required />
                    </div>

                    <div className="form-group">
                      <label htmlFor="ask">
                        <FaQuestionCircle className="mr-2" /> Ask (my 5 asks):
                      </label>
                      <input type="text" id="ask" className="form-control" value={ask} onChange={(e) => setAsk(e.target.value)} required />
                    </div>

                    <div className="form-group">
                      <label htmlFor="give">
                        <FaGift className="mr-2" /> Give (my 5 gives):
                      </label>
                      <input type="text" id="give" className="form-control" value={give} onChange={(e) => setGive(e.target.value)} required />
                    </div>

                    <button type="submit" className="btn btn-primary w-100 mt-3">Submit</button>
                  </form>
                </div>
              </div>
            </div>
          )} */}
{activeSection === "report" && (
  <div
    style={{
      minHeight: "100vh",
      background: "linear-gradient(to bottom right, #f8fafc, #e0f2fe)",
      borderRadius: "30px",
      overflow: "hidden",
    }}
  >
    {/* HEADER */}
    <div
      style={{
        background: "linear-gradient(to right, #1e3a8a, #1e40af)",
        padding: "50px 30px",
        color: "white",
      }}
    >
      <div>
        <h1
          style={{
            fontSize: "38px",
            fontWeight: "800",
            marginBottom: "10px",
          }}
        >
           Report <FaClipboard />
        </h1>

        <p
          style={{
            fontSize: "16px",
            opacity: "0.9",
            maxWidth: "700px",
          }}
        >
          Submit your networking report, asks, and gives in a professional way.
        </p>
      </div>
    </div>

    <div style={{ padding: "30px" }}>
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fit,minmax(320px,1fr))",
          gap: "30px",
          alignItems: "start",
        }}
      >
        {/* LEFT SIDE FORM */}
        <div
          style={{
            background: "#fff",
            borderRadius: "30px",
            padding: "30px",
            boxShadow: "0 10px 30px rgba(0,0,0,0.08)",
            border: "1px solid #e5e7eb",
          }}
        >
          {/* TITLE */}
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "14px",
              marginBottom: "30px",
            }}
          >
            <div
              style={{
                width: "55px",
                height: "55px",
                borderRadius: "18px",
                background: "#dbeafe",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <FaClipboard color="#1e40af" size={24} />
            </div>

            <div>
              <h2
                style={{
                  margin: 0,
                  fontSize: "26px",
                  fontWeight: "800",
                  color: "#111827",
                }}
              >
                Submit Report
              </h2>

              <p
                style={{
                  margin: 0,
                  marginTop: "4px",
                  color: "#6b7280",
                  fontSize: "14px",
                }}
              >
                Fill all report information below
              </p>
            </div>
          </div>

          <form onSubmit={handleSubmitz}>
            {/* USER SELECT */}
            <div style={{ marginBottom: "25px" }}>
              <label
                htmlFor="userSelect"
                style={{
                  display: "block",
                  marginBottom: "10px",
                  fontSize: "12px",
                  fontWeight: "800",
                  color: "#64748b",
                  textTransform: "uppercase",
                  letterSpacing: "1px",
                }}
              >
                <FaUser
                  style={{
                    marginRight: "8px",
                    color: "#2563eb",
                  }}
                />
                Select User
              </label>

              <Select
                id="userSelect"
                options={usersOptionsz}
                value={
                  selectedUserz
                    ? {
                        value: selectedUserz.email,
                        label: selectedUserz.name,
                      }
                    : null
                }
                onChange={handleUserChangez}
                placeholder="Select a User"
              />
            </div>

            {/* TEXT BOX */}
            <div style={{ marginBottom: "25px" }}>
              <label
                htmlFor="inputBox"
                style={{
                  display: "block",
                  marginBottom: "10px",
                  fontSize: "12px",
                  fontWeight: "800",
                  color: "#64748b",
                  textTransform: "uppercase",
                  letterSpacing: "1px",
                }}
              >
                <FaClipboard
                  style={{
                    marginRight: "8px",
                    color: "#2563eb",
                  }}
                />
                General Message
              </label>

              <textarea
                id="inputBox"
                className="form-control"
                value={inputBox}
                onChange={(e) => setInputBox(e.target.value)}
                required
                rows={4}
                placeholder="Enter your report message..."
                style={{
                  borderRadius: "18px",
                  border: "2px solid #e5e7eb",
                  padding: "16px",
                  fontWeight: "500",
                  resize: "none",
                  boxShadow: "none",
                }}
              />
            </div>

            {/* ASK */}
            <div style={{ marginBottom: "25px" }}>
              <label
                htmlFor="ask"
                style={{
                  display: "block",
                  marginBottom: "10px",
                  fontSize: "12px",
                  fontWeight: "800",
                  color: "#2563eb",
                  textTransform: "uppercase",
                  letterSpacing: "1px",
                }}
              >
                <FaQuestionCircle
                  style={{
                    marginRight: "8px",
                  }}
                />
                My 5 Asks
              </label>

              <textarea
                id="ask"
                className="form-control"
                value={ask}
                onChange={(e) => setAsk(e.target.value)}
                required
                rows={4}
                placeholder="Enter your asks..."
                style={{
                  borderRadius: "18px",
                  border: "2px solid #dbeafe",
                  padding: "16px",
                  fontWeight: "500",
                  resize: "none",
                  boxShadow: "none",
                }}
              />
            </div>

            {/* GIVE */}
            <div style={{ marginBottom: "25px" }}>
              <label
                htmlFor="give"
                style={{
                  display: "block",
                  marginBottom: "10px",
                  fontSize: "12px",
                  fontWeight: "800",
                  color: "#16a34a",
                  textTransform: "uppercase",
                  letterSpacing: "1px",
                }}
              >
                <FaGift
                  style={{
                    marginRight: "8px",
                  }}
                />
                My 5 Gives
              </label>

              <textarea
                id="give"
                className="form-control"
                value={give}
                onChange={(e) => setGive(e.target.value)}
                required
                rows={4}
                placeholder="Enter your gives..."
                style={{
                  borderRadius: "18px",
                  border: "2px solid #dcfce7",
                  padding: "16px",
                  fontWeight: "500",
                  resize: "none",
                  boxShadow: "none",
                }}
              />
            </div>

            {/* BUTTON */}
            <button
              type="submit"
              className="btn w-100"
              style={{
                background: "linear-gradient(to right, #1e3a8a, #2563eb)",
                color: "#fff",
                border: "none",
                padding: "16px",
                borderRadius: "20px",
                fontWeight: "800",
                fontSize: "15px",
                letterSpacing: "1px",
                boxShadow: "0 10px 20px rgba(37,99,235,0.3)",
              }}
            >
              Submit Report
            </button>
          </form>
        </div>

        {/* RIGHT SIDE PREVIEW */}
        {/* <div
          style={{
            background: "linear-gradient(to bottom right, #1e3a8a, #1e40af)",
            borderRadius: "30px",
            overflow: "hidden",
            color: "white",
            boxShadow: "0 15px 40px rgba(0,0,0,0.15)",
          }}
        >
          <div
            style={{
              padding: "25px",
              borderBottom: "1px solid rgba(255,255,255,0.1)",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              flexWrap: "wrap",
              gap: "15px",
            }}
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "14px",
              }}
            >
              <div
                style={{
                  width: "55px",
                  height: "55px",
                  borderRadius: "50%",
                  background: "rgba(255,255,255,0.15)",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  fontSize: "24px",
                  fontWeight: "800",
                }}
              >
                {selectedUserz?.name
                  ? selectedUserz.name.charAt(0)
                  : "U"}
              </div>

              <div>
                <h3
                  style={{
                    margin: 0,
                    fontWeight: "800",
                    fontSize: "22px",
                  }}
                >
                  {selectedUserz?.name || "Selected User"}
                </h3>

                <p
                  style={{
                    margin: 0,
                    marginTop: "4px",
                    opacity: "0.7",
                    fontSize: "12px",
                    letterSpacing: "1px",
                    textTransform: "uppercase",
                  }}
                >
                  B-B Networking Member
                </p>
              </div>
            </div>

            <div
              style={{
                background: "rgba(34,197,94,0.15)",
                color: "#86efac",
                padding: "8px 14px",
                borderRadius: "50px",
                fontSize: "11px",
                fontWeight: "800",
                letterSpacing: "1px",
                textTransform: "uppercase",
              }}
            >
              Live Preview
            </div>
          </div>

          <div style={{ padding: "30px" }}>
            {inputBox && (
              <div
                style={{
                  marginBottom: "30px",
                  paddingBottom: "25px",
                  borderBottom: "1px solid rgba(255,255,255,0.1)",
                }}
              >
                <p
                  style={{
                    fontSize: "15px",
                    lineHeight: "1.8",
                    color: "#dbeafe",
                    margin: 0,
                    fontStyle: "italic",
                  }}
                >
                  "{inputBox}"
                </p>
              </div>
            )}

            <div
              style={{
                marginBottom: "30px",
                position: "relative",
                paddingLeft: "20px",
              }}
            >
              <div
                style={{
                  position: "absolute",
                  left: 0,
                  top: 0,
                  bottom: 0,
                  width: "5px",
                  borderRadius: "20px",
                  background: "#60a5fa",
                }}
              />

              <p
                style={{
                  margin: 0,
                  marginBottom: "10px",
                  fontSize: "11px",
                  fontWeight: "800",
                  color: "#93c5fd",
                  letterSpacing: "2px",
                  textTransform: "uppercase",
                }}
              >
                My 5 Asks
              </p>

              <p
                style={{
                  margin: 0,
                  lineHeight: "1.8",
                  fontSize: "15px",
                  color: "#eff6ff",
                }}
              >
                {ask || "Pending asks..."}
              </p>
            </div>

            <div
              style={{
                position: "relative",
                paddingLeft: "20px",
              }}
            >
              <div
                style={{
                  position: "absolute",
                  left: 0,
                  top: 0,
                  bottom: 0,
                  width: "5px",
                  borderRadius: "20px",
                  background: "#4ade80",
                }}
              />

              <p
                style={{
                  margin: 0,
                  marginBottom: "10px",
                  fontSize: "11px",
                  fontWeight: "800",
                  color: "#86efac",
                  letterSpacing: "2px",
                  textTransform: "uppercase",
                }}
              >
                My 5 Gives
              </p>

              <p
                style={{
                  margin: 0,
                  lineHeight: "1.8",
                  fontSize: "15px",
                  color: "#f0fdf4",
                }}
              >
                {give || "Pending gives..."}
              </p>
            </div>
          </div>

          <div
            style={{
              background: "rgba(0,0,0,0.15)",
              padding: "18px",
              textAlign: "center",
            }}
          >
            <p
              style={{
                margin: 0,
                fontSize: "10px",
                letterSpacing: "2px",
                textTransform: "uppercase",
                opacity: "0.7",
              }}
            >
              Official Networking Report
            </p>
          </div>
        </div> */}
      </div>
    </div>
  </div>
)}
          {/* {activeSection === "visitorInvite" && (
            <div className="container">
              <h2>Visitor Invitation</h2>
              
              <div className="row mt-4">
               
               
                <div className="mb-4 col-md-6">
                <div className='col-md-6'>
                  <h3>Select a Meeting</h3>
                  <Select
                    options={meetingOptions}
                    value={selectedMeeting ? { value: selectedMeeting.id, label: `${selectedMeeting.venue} - ${new Date(selectedMeeting.date).toLocaleDateString()}` } : null}
                    onChange={handleMeetingChange}
                    placeholder="Select a Meeting"
                  />
                </div>
           
              <div >
                <div className="col-md-6">
                  <form onSubmit={handleSubmity}>
                    <div className="form-group">
                      <label><FaUser className="mr-2" /> Visitor Name:</label>
                      <input type="text" className="form-control" value={visitorName} onChange={(e) => setVisitorName(e.target.value)} required />
                    </div>

                    <div className="form-group">
                      <label><FaPhone className="mr-2" /> Mobile:</label>
                      <input type="text" className="form-control" value={visitorMobile} onChange={(e) => setVisitorMobile(e.target.value)} required maxLength={10} />
                    </div>

                    <div className="form-group">
                      <label><FaEnvelope className="mr-2" /> Email:</label>
                      <input type="email" className="form-control" value={visitorEmail} onChange={(e) => setVisitorEmail(e.target.value)} required />
                    </div>
                    

                    <div className="form-group">
                      <label><FaRegComment className="mr-2" /> Message:</label>
                      <textarea className="form-control" placeholder="Dear, I’m inviting you to attend our chapter meeting as a visitor." value={visitorMessage} onChange={(e) => setVisitorMessage(e.target.value)} required></textarea>
                    </div>
                    <div className="form-group">
    <label><FaRegImage className="mr-2" /> Upload Image:</label>
    <input type="file" className="form-control" accept="image/*" onChange={(e) => setVisitorImage(e.target.files[0])} />
  </div>

                    <button type="submit" className="btn btn-primary w-100 mt-3">Send Invitation</button>
                  </form>
                </div>
              </div>
</div>


<div className="col-md-6">
                  <div
                    style={{
                      maxHeight: '300px',
                      overflowY: 'auto',
                      paddingRight: '10px', // optional: for space between content and scrollbar
                    }}
                  >
                    <div className="row g-3">
                      {invitationsget.map((invite) => (
                        <div key={invite.id} className="col-12 col-sm-6 col-md-6 col-lg-6">
                          <div
                            style={{
                              backgroundColor: '#fff',
                              borderRadius: '12px',
                              padding: '16px',
                              boxShadow: '0 6px 18px rgba(0, 0, 0, 0.1)',
                              fontFamily: 'Arial, sans-serif',
                              height: '100%',
                              display: 'flex',
                              flexDirection: 'column',
                              justifyContent: 'space-between'
                            }}
                          >
                            <div style={{ fontSize: '16px', fontWeight: 'bold', color: '#333' }}>{invite.visitor_name}</div>
                            <div style={{ fontSize: '12px', color: '#777' }}>{invite.visitor_email}</div>
                            <div style={{ fontSize: '13px', color: '#444', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                              {invite.visitor_message}
                            </div>
                            <div>{invite.meeting_id}</div>
                            {/* <div style={{ fontSize: '12px', color: '#555' }}>
                              📅 <strong>Date:</strong><br /> {new Date(invite.dateTime).toLocaleString()}
                            </div>
                            <div style={{ fontSize: '12px', color: '#555' }}>
                              <strong>Status:</strong><br />
                              {invite.status === 0
                                ? '🕒 Pending'
                                : invite.status === 1
                                  ? '✅ Accepted'
                                  : invite.status === 2
                                    ? '❌ Rejected'
                                    : 'Unknown'}
                            </div>
                            <div style={{ fontSize: '11px', color: '#aaa', marginTop: '8px' }}>
                              Created: {new Date(invite.createdAt).toLocaleString()}
                            </div> 
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>

              </div>

            </div>
          )} */}


{activeSection === "visitorInvite" && (
  <div
    style={{
      minHeight: "100vh",
      background: "#f3f4f6",
      padding: "20px 10px",
    }}
  >
    <div className="container-fluid">
      <div className="row g-4">

        {/* LEFT SIDE FORM */}
        <div className="col-12 col-lg-5">
          <div
            style={{
              background: "#fff",
              borderRadius: "30px",
              padding: "28px",
              boxShadow: "0 15px 40px rgba(0,0,0,0.08)",
              border: "1px solid #e5e7eb",
              height: "100%",
            }}
          >
            {/* HEADER */}
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                marginBottom: "28px",
                flexWrap: "wrap",
                gap: "15px",
              }}
            >
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "14px",
                }}
              >
                <div
                  style={{
                    width: "58px",
                    height: "58px",
                    borderRadius: "18px",
                    background: "linear-gradient(135deg,#1e3a8a,#2563eb)",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    boxShadow: "0 10px 25px rgba(37,99,235,0.25)",
                  }}
                >
                  <FaUser
                    style={{
                      color: "#fff",
                      fontSize: "22px",
                    }}
                  />
                </div>

                <div>
                  <h2
                    style={{
                      margin: 0,
                      fontWeight: "900",
                      fontSize: "28px",
                      color: "#111827",
                      letterSpacing: "-0.5px",
                    }}
                  >
                    Visitor Invitation
                  </h2>

                  <p
                    style={{
                      margin: 0,
                      color: "#6b7280",
                      fontWeight: "500",
                      fontSize: "13px",
                    }}
                  >
                    Invite visitors to your chapter meeting
                  </p>
                </div>
              </div>

              {/* <div
                style={{
                  background: "#dbeafe",
                  color: "#1d4ed8",
                  padding: "8px 16px",
                  borderRadius: "999px",
                  fontSize: "11px",
                  fontWeight: "800",
                  letterSpacing: "1px",
                  textTransform: "uppercase",
                }}
              >
                Live Registration
              </div> */}
            </div>

            {/* SELECT MEETING */}
            <div className="mb-4">
              <label
                style={{
                  fontSize: "11px",
                  fontWeight: "900",
                  color: "#6b7280",
                  letterSpacing: "1.5px",
                  textTransform: "uppercase",
                  marginBottom: "10px",
                  display: "block",
                }}
              >
                Select Meeting
              </label>

              <Select
                options={meetingOptions}
                value={
                  selectedMeeting
                    ? {
                        value: selectedMeeting.id,
                        label: `${selectedMeeting.venue} - ${new Date(
                          selectedMeeting.date
                        ).toLocaleDateString()}`,
                      }
                    : null
                }
                onChange={handleMeetingChange}
                placeholder="Select a Meeting"
              />
            </div>

            <form onSubmit={handleSubmity}>
              {/* VISITOR NAME */}
              <div className="mb-4">
                <label
                  style={{
                    fontSize: "11px",
                    fontWeight: "900",
                    color: "#6b7280",
                    letterSpacing: "1.5px",
                    textTransform: "uppercase",
                    marginBottom: "10px",
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                  }}
                >
                  <FaUser />
                  Visitor Name
                </label>

                <input
                  type="text"
                  className="form-control"
                  value={visitorName}
                  onChange={(e) => setVisitorName(e.target.value)}
                  required
                  style={{
                    borderRadius: "18px",
                    padding: "15px",
                    border: "2px solid #e5e7eb",
                    background: "#f9fafb",
                    fontWeight: "600",
                    minHeight: "56px",
                    boxShadow: "none",
                  }}
                />
              </div>

              {/* MOBILE + EMAIL */}
              <div className="row">
                <div className="col-12 col-md-6 mb-4">
                  <label
                    style={{
                      fontSize: "11px",
                      fontWeight: "900",
                      color: "#6b7280",
                      letterSpacing: "1.5px",
                      textTransform: "uppercase",
                      marginBottom: "10px",
                      display: "flex",
                      alignItems: "center",
                      gap: "8px",
                    }}
                  >
                    <FaPhone />
                    Mobile
                  </label>

                  <input
                    type="text"
                    className="form-control"
                    value={visitorMobile}
                    onChange={(e) => setVisitorMobile(e.target.value)}
                    required
                    maxLength={10}
                    style={{
                      borderRadius: "18px",
                      padding: "15px",
                      border: "2px solid #e5e7eb",
                      background: "#f9fafb",
                      fontWeight: "600",
                      minHeight: "56px",
                      boxShadow: "none",
                    }}
                  />
                </div>

                <div className="col-12 col-md-6 mb-4">
                  <label
                    style={{
                      fontSize: "11px",
                      fontWeight: "900",
                      color: "#6b7280",
                      letterSpacing: "1.5px",
                      textTransform: "uppercase",
                      marginBottom: "10px",
                      display: "flex",
                      alignItems: "center",
                      gap: "8px",
                    }}
                  >
                    <FaEnvelope />
                    Email
                  </label>

                  <input
                    type="email"
                    className="form-control"
                    value={visitorEmail}
                    onChange={(e) => setVisitorEmail(e.target.value)}
                    style={{
                      borderRadius: "18px",
                      padding: "15px",
                      border: "2px solid #e5e7eb",
                      background: "#f9fafb",
                      fontWeight: "600",
                      minHeight: "56px",
                      boxShadow: "none",
                    }}
                  />
                </div>
              </div>

              {/* MESSAGE */}
              <div className="mb-4">
                <label
                  style={{
                    fontSize: "11px",
                    fontWeight: "900",
                    color: "#6b7280",
                    letterSpacing: "1.5px",
                    textTransform: "uppercase",
                    marginBottom: "10px",
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                  }}
                >
                  <FaRegComment />
                  Message
                </label>

                <textarea
                  className="form-control"
                  value={visitorMessage}
                  onChange={(e) => setVisitorMessage(e.target.value)}
                  required
                  rows={4}
                  style={{
                    borderRadius: "18px",
                    padding: "16px",
                    border: "2px solid #e5e7eb",
                    background: "#f9fafb",
                    fontWeight: "500",
                    resize: "none",
                    boxShadow: "none",
                  }}
                ></textarea>
              </div>

              {/* IMAGE */}
              <div className="mb-4">
                <label
                  style={{
                    fontSize: "11px",
                    fontWeight: "900",
                    color: "#6b7280",
                    letterSpacing: "1.5px",
                    textTransform: "uppercase",
                    marginBottom: "10px",
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                  }}
                >
                  <FaRegImage />
                  Upload Image
                </label>

                <div
                  style={{
                    border: "2px dashed #cbd5e1",
                    borderRadius: "20px",
                    padding: "22px",
                    background: "#f9fafb",
                    textAlign: "center",
                  }}
                >
                  <input
                    type="file"
                    className="form-control"
                    accept="image/*"
                    onChange={(e) => setVisitorImage(e.target.files[0])}
                    style={{
                      border: "none",
                      background: "transparent",
                      fontWeight: "600",
                      boxShadow: "none",
                    }}
                  />
                </div>
              </div>

              {/* BUTTON */}
              <button
                type="submit"
                className="btn w-100"
                style={{
                  background:
                    "linear-gradient(135deg,#1e3a8a,#2563eb)",
                  color: "#fff",
                  border: "none",
                  borderRadius: "20px",
                  padding: "16px",
                  fontWeight: "900",
                  fontSize: "13px",
                  letterSpacing: "1.5px",
                  textTransform: "uppercase",
                  boxShadow: "0 15px 30px rgba(37,99,235,0.30)",
                }}
              >
                Send Invitation
              </button>
            </form>
          </div>
        </div>

        {/* RIGHT SIDE */}
        <div className="col-12 col-lg-7">

          {/* HEADER */}
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              marginBottom: "24px",
              flexWrap: "wrap",
              gap: "15px",
            }}
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "14px",
              }}
            >
              <div
                style={{
                  width: "55px",
                  height: "55px",
                  borderRadius: "18px",
                  background: "#dbeafe",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <FaEnvelope
                  style={{
                    color: "#2563eb",
                    fontSize: "22px",
                  }}
                />
              </div>

              <div>
                <h3
                  style={{
                    margin: 0,
                    fontWeight: "900",
                    color: "#111827",
                    fontSize: "26px",
                  }}
                >
                  Posted Invitations
                </h3>

                <p
                  style={{
                    margin: 0,
                    fontSize: "13px",
                    color: "#6b7280",
                    fontWeight: "500",
                  }}
                >
                  Visitor invitation feed
                </p>
              </div>
            </div>

            <div
              style={{
                background: "#dbeafe",
                color: "#1d4ed8",
                padding: "10px 16px",
                borderRadius: "999px",
                fontSize: "11px",
                fontWeight: "900",
                letterSpacing: "1px",
                textTransform: "uppercase",
              }}
            >
              {invitationsget.length} Total
            </div>
          </div>

          {/* LIST */}
          <div
            style={{
              maxHeight: "900px",
              overflowY: "auto",
              paddingRight: "5px",
            }}
          >
            {invitationsget.length === 0 ? (
              <div
                style={{
                  background: "#fff",
                  borderRadius: "28px",
                  padding: "70px 20px",
                  textAlign: "center",
                  border: "2px dashed #d1d5db",
                }}
              >
                <h5
                  style={{
                    color: "#6b7280",
                    fontWeight: "800",
                    marginBottom: "8px",
                  }}
                >
                  No Visitor Invitations Available
                </h5>

                <p
                  style={{
                    margin: 0,
                    color: "#9ca3af",
                    fontSize: "13px",
                  }}
                >
                  Submitted visitor invitations will appear here
                </p>
              </div>
            ) : (
              <div className="row g-4">
                {invitationsget.map((invite) => (
                  <div key={invite.id} className="col-12 col-md-6">
                    <div
                      style={{
                        background: "#fff",
                        borderRadius: "28px",
                        overflow: "hidden",
                        boxShadow: "0 12px 35px rgba(0,0,0,0.08)",
                        border: "1px solid #e5e7eb",
                        height: "100%",
                        transition: "0.3s",
                      }}
                    >
                      {/* TOP */}
                      <div
                        style={{
                          background:
                            "linear-gradient(135deg,#1e3a8a,#2563eb)",
                          padding: "18px",
                          display: "flex",
                          alignItems: "center",
                          gap: "14px",
                        }}
                      >
                        <div
                          style={{
                            width: "62px",
                            height: "62px",
                            borderRadius: "20px",
                            overflow: "hidden",
                            background: "#3b82f6",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            color: "#fff",
                            fontSize: "22px",
                            fontWeight: "900",
                            flexShrink: 0,
                          }}
                        >
                          {invite.visitor_image ? (
                            <img
                              src={invite.visitor_image}
                              alt={invite.visitor_name}
                              style={{
                                width: "100%",
                                height: "100%",
                                objectFit: "cover",
                              }}
                            />
                          ) : (
                            invite.visitor_name?.charAt(0)
                          )}
                        </div>

                        <div
                          style={{
                            overflow: "hidden",
                          }}
                        >
                          <h4
                            style={{
                              margin: 0,
                              color: "#fff",
                              fontWeight: "900",
                              fontSize: "18px",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              whiteSpace: "nowrap",
                            }}
                          >
                            {invite.visitor_name}
                          </h4>

                          <p
                            style={{
                              margin: 0,
                              color: "#bfdbfe",
                              fontSize: "11px",
                              fontWeight: "700",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              whiteSpace: "nowrap",
                            }}
                          >
                            {invite.visitor_email}
                          </p>
                        </div>
                      </div>

                      {/* BODY */}
                      <div
                        style={{
                          padding: "20px",
                        }}
                      >
                        <div
                          style={{
                            background: "#f3f4f6",
                            borderRadius: "18px",
                            padding: "15px",
                            marginBottom: "18px",
                          }}
                        >
                          <p
                            style={{
                              margin: 0,
                              color: "#374151",
                              fontSize: "13px",
                              lineHeight: "24px",
                              fontWeight: "500",
                            }}
                          >
                            "{invite.visitor_message}"
                          </p>
                        </div>

                        <div
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            gap: "10px",
                          }}
                        >
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "10px",
                              color: "#374151",
                              fontWeight: "700",
                              fontSize: "12px",
                            }}
                          >
                            <FaPhone
                              style={{
                                color: "#2563eb",
                              }}
                            />
                            {invite.visitor_mobile}
                          </div>

                          {invite.meeting_id && (
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "10px",
                                color: "#374151",
                                fontWeight: "700",
                                fontSize: "12px",
                              }}
                            >
                              📅 Meeting ID : {invite.meeting_id}
                            </div>
                          )}
                        </div>
                      </div>

                      {/* FOOTER */}
                      <div
                        style={{
                          padding: "14px 20px",
                          borderTop: "1px solid #f3f4f6",
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                          background: "#fafafa",
                        }}
                      >
                        <span
                          style={{
                            fontSize: "10px",
                            fontWeight: "800",
                            color: "#9ca3af",
                            letterSpacing: "1px",
                            textTransform: "uppercase",
                          }}
                        >
                          Visitor Invite
                        </span>

                        <span
                          style={{
                            background: "#dcfce7",
                            color: "#166534",
                            padding: "6px 12px",
                            borderRadius: "999px",
                            fontSize: "10px",
                            fontWeight: "900",
                            textTransform: "uppercase",
                            letterSpacing: "1px",
                          }}
                        >
                          Active
                        </span>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>

      </div>
    </div>
  </div>
)}

   {activeSection === "visitorEventInvite" && (
  <>
    <div
      style={{
        minHeight: "100vh",
        background: "#f3f4f6",
        padding: "20px 10px",
      }}
    >
      <div className="container-fluid">
        <div className="row g-4">

          {/* LEFT SIDE FORM */}
          <div className="col-12 col-lg-5">
            <div
              style={{
                background: "#fff",
                borderRadius: "28px",
                padding: "30px",
                boxShadow: "0 15px 40px rgba(0,0,0,0.08)",
                border: "1px solid #e5e7eb",
                height: "100%",
              }}
            >
              {/* HEADER */}
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "14px",
                  marginBottom: "28px",
                }}
              >
                <div
                  style={{
                    width: "55px",
                    height: "55px",
                    borderRadius: "16px",
                    background: "#dbeafe",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <FaUser
                    style={{
                      color: "#2563eb",
                      fontSize: "22px",
                    }}
                  />
                </div>

                <div>
                  <h2
                    style={{
                      margin: 0,
                      fontWeight: "800",
                      color: "#111827",
                      fontSize: "28px",
                    }}
                  >
                    Visitor Event Invitation
                  </h2>

                  <p
                    style={{
                      margin: 0,
                      color: "#6b7280",
                      fontSize: "13px",
                      fontWeight: "500",
                    }}
                  >
                    Invite visitors for your events and meetings
                  </p>
                </div>
              </div>

              {/* SELECT EVENT */}
              <div className="mb-4">
                <label
                  style={{
                    fontSize: "11px",
                    fontWeight: "800",
                    color: "#6b7280",
                    letterSpacing: "1px",
                    textTransform: "uppercase",
                    marginBottom: "8px",
                    display: "block",
                  }}
                >
                  Select Event - Meeting
                </label>

                <Select
                  options={meetingOptions_event}
                  value={
                    selectedMeeting_event
                      ? {
                          value: selectedMeeting_event.id,
                          label: `${selectedMeeting_event.venue} - ${new Date(
                            selectedMeeting_event.date
                          ).toLocaleDateString()}`,
                        }
                      : null
                  }
                  onChange={handleMeetingChange_event}
                  placeholder="Select a Meeting"
                />
              </div>

              <form onSubmit={handleSubmity_event} className="mt-3">

                {/* VISITOR NAME */}
                <div className="mb-4">
                  <label
                    style={{
                      fontSize: "11px",
                      fontWeight: "800",
                      color: "#6b7280",
                      letterSpacing: "1px",
                      textTransform: "uppercase",
                      marginBottom: "8px",
                      display: "block",
                    }}
                  >
                    <FaUser className="me-2" />
                    Visitor Name
                  </label>

                  <input
                    type="text"
                    className="form-control"
                    value={visitorName_event}
                    onChange={(e) => setVisitorName_event(e.target.value)}
                    required
                    style={{
                      borderRadius: "16px",
                      padding: "14px",
                      border: "2px solid #e5e7eb",
                      background: "#f9fafb",
                      fontWeight: "600",
                      boxShadow: "none",
                    }}
                  />
                </div>

                {/* MOBILE + EMAIL */}
                <div className="row">
                  <div className="col-12 col-md-6 mb-4">
                    <label
                      style={{
                        fontSize: "11px",
                        fontWeight: "800",
                        color: "#6b7280",
                        letterSpacing: "1px",
                        textTransform: "uppercase",
                        marginBottom: "8px",
                        display: "block",
                      }}
                    >
                      <FaPhone className="me-2" />
                      Mobile
                    </label>

                    <input
                      type="text"
                      className="form-control"
                      value={visitorMobile_event}
                      onChange={(e) => setVisitorMobile_event(e.target.value)}
                      required
                      maxLength={10}
                      style={{
                        borderRadius: "16px",
                        padding: "14px",
                        border: "2px solid #e5e7eb",
                        background: "#f9fafb",
                        fontWeight: "600",
                        boxShadow: "none",
                      }}
                    />
                  </div>

                  <div className="col-12 col-md-6 mb-4">
                    <label
                      style={{
                        fontSize: "11px",
                        fontWeight: "800",
                        color: "#6b7280",
                        letterSpacing: "1px",
                        textTransform: "uppercase",
                        marginBottom: "8px",
                        display: "block",
                      }}
                    >
                      <FaEnvelope className="me-2" />
                      Email
                    </label>

                    <input
                      type="email"
                      className="form-control"
                      value={visitorEmail_event}
                      onChange={(e) => setVisitorEmail_event(e.target.value)}
                      style={{
                        borderRadius: "16px",
                        padding: "14px",
                        border: "2px solid #e5e7eb",
                        background: "#f9fafb",
                        fontWeight: "600",
                        boxShadow: "none",
                      }}
                    />
                  </div>
                </div>

                {/* MESSAGE */}
                <div className="mb-4">
                  <label
                    style={{
                      fontSize: "11px",
                      fontWeight: "800",
                      color: "#6b7280",
                      letterSpacing: "1px",
                      textTransform: "uppercase",
                      marginBottom: "8px",
                      display: "block",
                    }}
                  >
                    <FaRegComment className="me-2" />
                    Message
                  </label>

                  <textarea
                    className="form-control"
                    value={visitorMessage_event}
                    onChange={(e) => setVisitorMessage_event(e.target.value)}
                    required
                    rows={4}
                    style={{
                      borderRadius: "16px",
                      padding: "14px",
                      border: "2px solid #e5e7eb",
                      background: "#f9fafb",
                      fontWeight: "500",
                      resize: "none",
                      boxShadow: "none",
                    }}
                  ></textarea>
                </div>

                {/* IMAGE */}
                <div className="mb-4">
                  <label
                    style={{
                      fontSize: "11px",
                      fontWeight: "800",
                      color: "#6b7280",
                      letterSpacing: "1px",
                      textTransform: "uppercase",
                      marginBottom: "8px",
                      display: "block",
                    }}
                  >
                    <FaRegImage className="me-2" />
                    Upload Image
                  </label>

                  <input
                    type="file"
                    className="form-control"
                    accept="image/*"
                    onChange={(e) => setVisitorImage_event(e.target.files[0])}
                    style={{
                      borderRadius: "16px",
                      padding: "12px",
                      border: "2px dashed #cbd5e1",
                      background: "#fff",
                      fontWeight: "600",
                      boxShadow: "none",
                    }}
                  />
                </div>

                {/* BUTTON */}
                <button
                  type="submit"
                  className="btn w-100 mt-2"
                  style={{
                    background:
                      "linear-gradient(135deg, #1e3a8a, #2563eb)",
                    color: "#fff",
                    border: "none",
                    borderRadius: "18px",
                    padding: "15px",
                    fontWeight: "800",
                    fontSize: "14px",
                    letterSpacing: "1px",
                    textTransform: "uppercase",
                    boxShadow: "0 10px 25px rgba(37,99,235,0.3)",
                  }}
                >
                  Send Event Invitation
                </button>
              </form>
            </div>
          </div>

          {/* RIGHT SIDE LIST */}
          <div className="col-12 col-lg-7">

            {/* HEADER */}
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                marginBottom: "20px",
              }}
            >
              <div>
                <h3
                  style={{
                    margin: 0,
                    fontWeight: "800",
                    color: "#111827",
                  }}
                >
                  Posted Invitations
                </h3>

                <p
                  style={{
                    margin: 0,
                    color: "#6b7280",
                    fontSize: "12px",
                    fontWeight: "500",
                  }}
                >
                  Event invitation activity
                </p>
              </div>

              <div
                style={{
                  background: "#dbeafe",
                  color: "#1d4ed8",
                  padding: "8px 16px",
                  borderRadius: "999px",
                  fontWeight: "800",
                  fontSize: "11px",
                }}
              >
                {invitationsget_event.length} TOTAL
              </div>
            </div>

            {/* LIST */}
            <div
              style={{
                maxHeight: "850px",
                overflowY: "auto",
                paddingRight: "5px",
              }}
            >
              <div className="row g-4">
                {invitationsget_event.map((invite) => (
                  <div key={invite.id} className="col-12 col-md-6">

                    <div
                      style={{
                        background: "#fff",
                        borderRadius: "24px",
                        overflow: "hidden",
                        boxShadow: "0 12px 30px rgba(0,0,0,0.08)",
                        border: "1px solid #e5e7eb",
                        transition: "0.3s",
                        height: "100%",
                      }}
                    >
                      {/* TOP HEADER */}
                      <div
                        style={{
                          background:
                            "linear-gradient(135deg, #1e3a8a, #2563eb)",
                          padding: "16px",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "space-between",
                        }}
                      >
                        <div
                          style={{
                            color: "#fff",
                            fontSize: "11px",
                            fontWeight: "800",
                            letterSpacing: "1px",
                            textTransform: "uppercase",
                          }}
                        >
                          Event Invitation
                        </div>

                        <div
                          style={{
                            width: "10px",
                            height: "10px",
                            borderRadius: "50%",
                            background: "#4ade80",
                          }}
                        ></div>
                      </div>

                      {/* BODY */}
                      <div style={{ padding: "20px" }}>

                        {/* PROFILE */}
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "14px",
                            marginBottom: "18px",
                          }}
                        >
                          <div
                            style={{
                              width: "60px",
                              height: "60px",
                              borderRadius: "50%",
                              background: "#dbeafe",
                              overflow: "hidden",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              fontWeight: "800",
                              color: "#1d4ed8",
                              fontSize: "22px",
                              textTransform: "uppercase",
                            }}
                          >
                            {invite.visitor_image ? (
                              <img
                                src={invite.visitor_image}
                                alt={invite.visitor_name}
                                style={{
                                  width: "100%",
                                  height: "100%",
                                  objectFit: "cover",
                                }}
                              />
                            ) : (
                              invite.visitor_name?.charAt(0)
                            )}
                          </div>

                          <div
                            style={{
                              overflow: "hidden",
                            }}
                          >
                            <h4
                              style={{
                                margin: 0,
                                fontSize: "18px",
                                fontWeight: "800",
                                color: "#111827",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                whiteSpace: "nowrap",
                              }}
                            >
                              {invite.visitor_name}
                            </h4>

                            <p
                              style={{
                                margin: 0,
                                fontSize: "12px",
                                color: "#2563eb",
                                fontWeight: "600",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                whiteSpace: "nowrap",
                              }}
                            >
                              {invite.visitor_email}
                            </p>
                          </div>
                        </div>

                        {/* MESSAGE */}
                        <div
                          style={{
                            background: "#f3f4f6",
                            borderRadius: "16px",
                            padding: "14px",
                            marginBottom: "16px",
                          }}
                        >
                          <p
                            style={{
                              margin: 0,
                              fontSize: "13px",
                              lineHeight: "22px",
                              color: "#374151",
                              fontWeight: "500",
                            }}
                          >
                            "{invite.visitor_message}"
                          </p>
                        </div>

                        {/* FOOTER */}
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            gap: "10px",
                          }}
                        >
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "8px",
                              fontSize: "12px",
                              color: "#4b5563",
                              fontWeight: "600",
                            }}
                          >
                            <FaPhone />
                            {invite.visitor_mobile}
                          </div>

                          {invite.meeting_id && (
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "8px",
                                fontSize: "12px",
                                color: "#4b5563",
                                fontWeight: "600",
                              }}
                            >
                              📅 Event ID : {invite.meeting_id}
                            </div>
                          )}
                        </div>
                      </div>
                    </div>

                  </div>
                ))}
              </div>

              {invitationsget_event.length === 0 && (
                <div
                  style={{
                    background: "#fff",
                    borderRadius: "24px",
                    padding: "70px 20px",
                    textAlign: "center",
                    border: "2px dashed #d1d5db",
                  }}
                >
                  <h5
                    style={{
                      color: "#6b7280",
                      fontWeight: "700",
                    }}
                  >
                    No Event Invitations Available
                  </h5>
                </div>
              )}
            </div>
          </div>

        </div>
      </div>
    </div>
  </>
)}

        </div>

        <Modal isOpen={showModaal} onRequestClose={closeModaal} contentLabel="Edit Product" appElement={document.getElementById("root")} className="modall" overlayClassName="modal-over">
          <div className="modall-header">
            <h3 className="modall-title">Edit Product</h3>
            <button type="button" className="close" onClick={closeModaal}>
              <span>&times;</span>
            </button>
          </div>

          <form onSubmit={handleEditSubmit}>
            <div className="modall-body">
              <div className="form-group">
                <label htmlFor="productName">Product Name</label>
                <input
                  type="text"
                  id="productName"
                  name="productName"
                  value={editProductData.productName}
                  onChange={handleEditModelInputChange}
                  className="form-control"
                  placeholder="Enter Product Name"
                  required
                />
              </div>

              <div className="form-group">
                <label htmlFor="productDesc">Product Description</label>
                <textarea
                  id="productDesc"
                  name="productDesc"
                  value={editProductData.productDesc}
                  onChange={handleEditModelInputChange}
                  className="form-control"
                  placeholder="Enter Product Description"
                  required
                />
              </div>

              <div className="form-group">
                <label htmlFor="productPrice">Product Price</label>
                <input
                  type="text"
                  id="productPrice"
                  name="productPrice"
                  value={editProductData.productPrice}
                  onChange={handleEditModelInputChange}
                  className="form-control"
                  placeholder="Enter Product Price"
                  required
                />
              </div>

              <div className="form-group">
                <label htmlFor="offer">Offer (%)</label>
                <input
                  type="number"
                  id="offer"
                  name="offer"
                  value={editProductData.offer}
                  onChange={handleEditModelInputChange}
                  className="form-control"
                  placeholder="Enter Offer Percentage"
                />
              </div>

              <div className="form-group">
                <label htmlFor="validity">Offer Validity</label>
                <input
                  type="date"
                  id="validity"
                  name="validity"
                  value={editProductData.validity}
                  onChange={handleEditModelInputChange}
                  className="form-control"
                  required
                />
              </div>

              <div className="form-group">
                <label htmlFor="productPhoto">Product Photo</label>
                <input
                  type="file"
                  id="productPhoto"
                  name="productPhoto"
                  onChange={handleEditModelFileChange}
                  className="form-control-file"
                />
              </div>
            </div>

            <div className="modal-footer">
              <button type="submit" className="btn btn-primary">
                Save Changes
              </button>
            </div>
          </form>
        </Modal>

        {showModal && (
          <div className="modal-over">
            <div className="modall">
              <div className="modall-header">
                <h2>Add Product</h2>
                <button
                  className="close-modall-btn"
                  onClick={() => setShowModal(false)}
                >
                  &times;
                </button>
              </div>
              <form onSubmit={handleFormSubmit}>
                <div className="form-group">
                  <label>Product Name *</label>
                  <input
                    type="text"
                    name="productName"
                    value={productData.productName}
                    onChange={handleModelInputChange}
                    required
                  />
                </div>
                <div className="form-group">
                  <label>Product Price *</label>
                  <input
                    type="number"
                    name="productPrice"
                    value={productData.productPrice}
                    onChange={handleModelInputChange}
                    required
                  />
                </div>
                <div className="form-group">
                  <label>Product Description *</label>
                  <textarea
                    name="productDesc"
                    value={productData.productDesc}
                    onChange={handleModelInputChange}
                    required
                  />
                </div>
                <div className="form-group">
                  <label>Product Photo *</label>
                  <input
                    type="file"
                    onChange={handleModelFileChange}
                    accept="image/*"
                    required
                  />
                </div>
                <div className="form-group">
                  <label>Offer (%) *</label>
                  <input
                    type="number"
                    name="offer"
                    value={productData.offer}
                    onChange={handleModelInputChange}
                  />
                </div>
                <div className="form-group">
                  <label>Offer Validity (dd-mm-yyyy) *</label>
                  <input
                    type="date"
                    name="validity"
                    value={productData.validity}
                    onChange={handleModelInputChange}
                  />
                </div>
                <div className="modal-actions">
                  <button type="submit" className="submit-btn">
                    Submit
                  </button>
                </div>
              </form>
            </div>
          </div>
        )}
      </div>


      <footer
        style={{
          backgroundColor: "#2c2c6c",
          color: "white",
          textAlign: "center",
          padding: "10px",
          width: "100%",
        }}     >
        <div className="social-icons">

          <a
            href="https://www.facebook.com/lbnhyderabad"
            style={{ margin: "0 10px", color: "white", fontSize: "20px" }}
          >
            <FaFacebook />
          </a>
          <a
            href="https://www.youtube.com/@LBNMD320"
            style={{ margin: "0 10px", color: "white", fontSize: "20px" }}
          >
            <FaYoutube />
          </a>
          <a
            href="https://www.instagram.com/lbnhyderabad"
            style={{ margin: "0 10px", color: "white", fontSize: "20px" }}
          >
            <FaInstagram />
          </a>
        </div>
        <p>&copy; 2025 Emedha technologies all rights reserved.</p>
      </footer>
    </>
  );

};

export default UserDashboard;



















